import { exchangeEn } from './exchange';
export const LANG = {
    validation: {
        email_invalid: "Invalid email address",
        trade_evidence_required: "Please upload documents supporting the authenticity of the trade",
        withdrawal_amount_required: "Please enter the withdrawal amount",
        checkbox_required: "Please select the checkbox",
        english_name_required: "Please enter the English name",
        english_name_characters: "Only English letters, numbers, spaces and / - ? : ( ) . , ' + are allowed",
        expiry_date_required: "Please enter the expiry date",
        name_invalid: "Invalid name format",
        industry_required: "Please select an industry category",
        entity_category_required: "Please select an entity category",
        main_products_required: "Please enter the main products sold",
        annual_gmv_required: "Please enter the annual GMV",
        document_expiry_date_required: "Please select the document expiry date",
        company_registration_location_required: "Please select the company registration location",
        company_type_required: "Please select a company type",
        shop_payment_required: "Please select at least one store and enter the payment amount",
        max_length: "Maximum length is {max} characters",
        payment_amount_required: "Please enter the payment amount",
        account_nickname_required: "Please enter an account nickname",
        registration_location_required: "Please select the company or individual registration location",
        bank_card_required: "Please select a bank card",
        english_half_width_characters: "Only English letters, numbers, spaces and - ? : ( ) . , ' + are allowed. The value cannot start with -",
        chinese_name_invalid: "Invalid name format. Please enter the name in Chinese",
        issue_date_required: "Please enter the issue date",
        login_password_confirmation_required: "Please confirm your login password",
        payment_password_confirmation_required: "Please confirm your payment password",
        chinese_english_max_length: "Please enter Chinese or English text with no more than {max} characters",
        login_password_required: "Please enter your login password",
        phone_in_use: "This mobile number is already in use",
        document_validity_required: "Please select the document validity period",
        passport_number_required: "Please enter the passport number",
        passport_validity_required: "Please select the passport validity period",
        passport_issue_date_required: "Please select the passport issue date",
        sms_code_required: "Please enter the SMS verification code"
    },
    page: {
        exchange: exchangeEn,
        kyc: {
            "companyDto": {
                "NationalityoftheDirector": "Nationality",
                "NameofDirector": "Name",
                "NameofDirectorEn": "English Name",
                "ChineseFirstName": "Chinese Given Name",
                "ChineseLastName": "Chinese Family Name",
                "DateofBirthoftheDirector": "Date of Birth",
                "EnglishFirstName": "English First Name",
                "EnglishLastName": "English Last Name",
                "empty_text": "No data",
                "not_completed_account_holder_info": "You have not completed the account holder information setting, please complete the setting first",
            },
            step2Person: {
                titleCert: "Identity Document",
                titleDomicile: "Domicile Address",
                titleResidence: "Residence Address",
                nationality: "Nationality",
                certType: "Document Type",
                idCardFront: "ID Card (Portrait Page)",
                idCardBack: "ID Card (National Emblem Page)",
                passport: "Passport",
                certNo: "Document No.",
                certExpDate: "Document Expiry Date",
                certIssueDate: "Document Issue Date",
                holdIdCard: "Photo Holding ID Document",
                nameCn: "Name",
                nameEn: "English Name",
                birthday: "Date of Birth",
                domicileAddr1: "Domicile Address Line 1",
                domicileAddr1En: "Domicile Address Line 1 in English",
                domicileAddr2: "Domicile Address Line 2",
                domicileAddr2En: "Domicile Address Line 2 in English",
                domicileCountry: "Domicile Country/Region",
                domicileProvince: "Domicile Province",
                domicilePostCode: "Domicile Post Code",
                domicileCity: "Domicile City",
                notSameCheck: "My residence address is different",
                residenceAddr1: "Residence Address Line 1",
                residenceAddr1En: "Residence Address Line 1 in English",
                residenceAddr2: "Residence Address Line 2",
                residenceAddr2En: "Residence Address Line 2 in English",
                residenceCountry: "Residence Country/Region",
                residenceProvince: "Residence Province",
                residencePostCode: "Residence Post Code",
                residenceCity: "Residence City",
                placeholderNationality: "Please select country/region",
                placeholderName: "Please enter name",
                placeholderNameEn: "Please enter English name",
                placeholderAddr: "Please enter address",
                placeholderAddrEn: "Please enter the address in English",
                placeholderAddrCont: "Please enter address (continued)",
                placeholderAddrContEn: "Please enter the address in English (continued)",
                placeholderPostCode: "Please enter post code",
                errCertType: "Please select document type",
                errNationality: "Please select nationality",
                errNameCn: "Please enter name",
                errNameEn: "Please enter English name",
                errBirthday: "Please select date of birth",
                errDomicileAddr: "Please enter domicile address line 1",
                errDomicileAddrEn: "Please enter domicile address line 1 in English",
                errDomicileCountry: "Please select domicile country/region",
                errDomicileProvince: "Please select domicile province",
                errDomicilePostCode: "Please enter domicile post code",
                errDomicileCity: "Please select domicile city",
                errResidenceAddr1: "Please enter residence address line 1",
                errResidenceAddr1En: "Please enter residence address line 1 in English",
                errResidenceAddr2: "Please enter residence address line 2",
                errResidenceAddr2En: "Please enter residence address line 2 in English",
                errResidenceCountry: "Please select residence country/region",
                errResidenceProvince: "Please select residence province",
                errResidenceCity: "Please select residence city",
                errResidencePostCode: "Please enter residence post code",
                errCertExpired: "Certificate has expired, please replace with a valid one",
                otherAttachmentPlaceholder: "Please upload other attachments",
                otherAttachment: "Other Attachments",
            },
            step3: {
                name_placeholder: "Enter the name",
                name_en_placeholder: "Enter the English name",
                name_required: "Please enter the name",
                name_en_required: "Please enter the English name",
                residential_address: "Residential Address",
                residential_address_en: "Residential Address in English",
                residential_address_placeholder: "Enter the complete residential address",
                residential_address_en_placeholder: "Enter the complete residential address in English",
                residential_address_required: "Please enter the residential address",
                residential_address_en_required: "Please enter the residential address in English",
                holder_section_title: "Account Holder Information",
                holder_relation_title: "Registrant Identity Association",
                holder_relation_tip: "Associate the verified person for the account registration mobile number with a legal representative/director, beneficial owner, or authorized agent.",
                holder_select_phone_tip: "Please select the real-name information for {phone}",
                holder_select_phone_desc: "Select 1 person from the list below; if not listed, fill in the authorized agent.",
                holder_type_legal: "Legal Representative / Director",
                holder_type_director: "Director",
                holder_type_ubo: "Ultimate Beneficial Owner",
                holder_type_agent: "Designate an Authorized Agent",
                holder_agent_tip: "If the mobile number holder is not listed above, provide the authorized agent’s details and upload a power of attorney.",
                holder_type_other: "Other Holder",
                holder_type_self: "Myself",
                holder_self_tip: "Myself uses the personal identity and name information filled above as the account holder",
                holder_name: "Name",
                holder_cert_no: "ID Number",
                holder_id_front: "ID Photo (Portrait Side)",
                holder_id_back: "ID Photo (Emblem Side)",
                holder_id_hk: "Hong Kong Identity Card",
                holder_id_passport: "Passport",
                holder_agree_prefix: "I have read and agree to",
                holder_guarantee_link: "the Guarantee Letter on Confirmation of Mobile Number Ownership",
                holder_agree_required: "Please read and accept the declaration",
            },
            step2Company: {
                titleCertCN: "Enterprise Documents",
                titleCertHK: "Enterprise Documents (Hong Kong)",
                titleBasicInfo: "Company Basic Information",
                titleBusinessAddr: "Business Address",
                titleAttachment: "Attachments",
                businessLicense: "Business License",
                certNo: "Certificate No.",
                certRegDate: "Certificate Registration Date",
                certExpDate: "Certificate Expiration Date",
                hkIncorpCert: "Certificate of Incorporation",
                hkBizRegCert: "Business Registration Certificate",
                hkBizRegCertNo: "Business Registration Certificate No.",
                hkRelatedCert: "Related Company Documents",
                nar1Label: "Annual Return (NAR1)",
                nnc1Label: "Incorporation Form (NNC1)",
                nd2aLabel: "Notice of Change of Company Secretary and Director (ND2A)",
                companyName: "Company Name",
                companyNameHint: "Must exactly match the name on the company registration document",
                nameCn: "Company Name (Chinese)",
                nameCnFull: "Full Chinese Name",
                nameCnPlaceholder: "Enter the full registered Chinese company name",
                nameEn: "Company Name (English)",
                nameEnFull: "Full English Name",
                nameEnPlaceholder: "Enter the full registered English name, or Pinyin if unavailable",
                translateCompanyName: "Translate to English",
                translateGenerated: "Generated. Please verify the English content.",
                translateFailed: "No translation result was returned. Please try again.",
                clearNameCn: "Clear Chinese company name",
                clearNameEn: "Clear English company name",
                registCountry: "Registered Address Country/Region",
                registProvince: "Registered Address Province",
                registCity: "Registered Address City",
                registAddress: "Registered Address",
                registAddressEn: "Registered Address (English)",
                addressCn: "Chinese Address",
                addressEn: "English Address",
                detailAddress: "Detailed Address",
                registAddressPlaceholder: "Enter the complete registered address",
                registAddressEnPlaceholder: "Enter the complete registered address in English",
                isSameAddress: "Is business address same as registered address?",
                yes: "Yes",
                no: "No",
                bizAddrProof: "Business Address Proof",
                bizAddress: "Business Address",
                bizAddressEn: "Business Address (English)",
                bizAddressPlaceholder: "Enter the complete business address",
                bizAddressEnPlaceholder: "Enter the complete business address in English",
                bizCountry: "Business Address Country/Region",
                bizProvince: "Business Address Province",
                bizCity: "Business Address City",
                bizPostCode: "Business Address Post Code",
                equityDiagram: "Equity Structure Diagram (Optional)",
                otherAttachment: "Other Attachments (Optional)",
                certNoPlaceholderCN: "16-digit Business Registration Certificate No.",
                certNoPlaceholder: "Please enter certificate number",
                bizRegCertNoPlaceholder: "Please enter Business Registration Certificate No.",
                errUpload: "Please upload file",
                errCertNo: "Please enter certificate number",
                errCertRegDate: "Please select certificate registration date",
                errHkRegDate: "Please select registration date",
                errHkRelatedCert: "Please select related document",
                errHkRelatedCertUpload: "Please upload related company documents",
                errNameCn: "Please enter company name (Chinese)",
                errNameEn: "Please enter company name (English)",
                errRegistAddress: "Please enter registered address",
                errRegistAddressEn: "Please enter registered address in English",
                errRegistCountry: "Please select country/region for registered address",
                errRegistProvince: "Please select province for registered address",
                errRegistCity: "Please select city for registered address",
                errBizAddress: "Please enter business address",
                errBizAddressEn: "Please enter business address in English",
                errBizCountry: "Please select country/region for business address",
                errBizProvince: "Please select province for business address",
                errBizCity: "Please select city for business address",
                errBizPostCode: "Please enter post code for business address",
                errCertExpired: "Certificate has expired, please replace with a valid one",
                errRegisterAmount: "Please enter register capital",
            },
        },
        quota: {
            "action_view_detail": "Quota Details",
            "action_add_orders": "Add Quota",
            "search_button": "Search",
            "dialog_title": "Add Quota",
            "label_upload_trade_materials": "Upload Trade Materials",
            "label_upload_trade_materials_required": "Upload Trade Materials:",
            "button_template_download": "Download Template",
            "upload_tip_click": "Click to upload",
            "upload_tip_materials": "upload trade materials",
            "upload_tip_or": "or",
            "upload_tip_drag": "drag here",
            "upload_format_hint": "Attachments support xlsx, .xls, .csv, .zip, .rar, file not exceeding 10MB",
            "label_remark": "Remark",
            "label_remark_required": "Remark:",
            "placeholder_remark": "Please enter remark",
            "button_cancel": "Cancel",
            "button_confirm": "Confirm",
            "label_kyc_id": "KYCID:",
            "placeholder_kyc_id": "Please enter",
            "label_entity_name": "Entity Name:",
            "placeholder_entity_name": "Please enter",
            "label_operating_platform": "Operating Platform:",
            "placeholder_operating_platform": "Please select",
            "label_shop_name": "Shop Name:",
            "placeholder_shop_name": "Please enter",
            "button_query": "Query",
            "table_column_kyc_id": "KYCID",
            "table_column_entity_name": "Entity Name",
            "table_column_operating_platform": "Operating Platform",
            "table_column_shop_name": "Shop Name",
            "table_column_shop_currency": "Shop Currency",
            "table_column_upload_quota": "Upload Quota",
            "table_column_create_time": "Create Time",
            "table_column_review_status": "Review Status",
            "table_column_review_time": "Review Time",
            "table_column_review_note": "Review Note",
            "table_column_action": "Action",
            "action_view_file": "View File",
            "action_download_failed_file": "Download Failed File",
            "status_approved": "Approved",
            "status_rejected": "Rejected",
            "status_initialized": "Initialized",
            "status_pending": "Pending",
            "status_processing": "Processing",
            "status_completed": "Completed",
            "label_plateForm_name": "Business Type:",
            "action_update_materials": "Update Materials",
            "tab_single_add": "Add Single",
            "tab_batch_upload": "Batch Upload",
            "section_order_info": "Order Information",
            "label_order_no": "Order No.",
            "placeholder_order_no": "Please enter the order number",
            "label_transaction_time": "Transaction Time",
            "placeholder_select_time": "Please select time",
            "label_transaction_amount": "Transaction Amount",
            "label_currency": "Currency",
            "section_product_info": "Product Information",
            "label_product_name": "Product Name",
            "placeholder_product_name": "Please enter the product name",
            "label_quantity": "Quantity",
            "label_unit_price": "Unit Price",
            "label_product_type_code": "Product Type Code",
            "placeholder_select": "Please select",
            "section_logistics_info": "Logistics Information",
            "label_shipment_status": "Shipment Status",
            "label_estimated_shipping_time": "Estimated Shipping Time",
            "label_shipping_date": "Shipping Date",
            "label_trade_country": "Trade Country/Region",
            "label_tracking_no": "Tracking No.",
            "placeholder_tracking_no": "Please enter the tracking number",
            "label_logistics_company": "Logistics Company Name",
            "placeholder_logistics_company": "Please enter the logistics company name",
            "section_buyer_info": "Buyer Information",
            "label_buyer_name": "Buyer Name",
            "placeholder_buyer_name": "Please enter buyer name",
            "label_buyer_address": "Buyer Address",
            "placeholder_buyer_address": "Please enter buyer address",
            "section_company_info": "Company/Store Information",
            "label_company_website": "Company/Store Website",
            "placeholder_company_website": "Please enter company/store website",
            "shipment_status_not_shipped": "Not Shipped",
            "shipment_status_shipped": "Shipped",
            "error_order_no_required": "Please enter the order number",
            "error_transaction_time_required": "Please select transaction time",
            "error_transaction_amount_required": "Please enter transaction amount",
            "error_transaction_amount_min": "Transaction amount must be greater than 0",
            "error_currency_required": "Please select currency",
            "error_product_name_required": "Please enter the product name",
            "error_quantity_required": "Please enter quantity",
            "error_quantity_min": "Quantity must be greater than 0",
            "error_unit_price_required": "Please enter unit price",
            "error_unit_price_min": "Unit price must be greater than 0",
            "error_product_type_code_required": "Please select product type code",
            "error_shipment_status_required": "Please select shipment status",
            "error_estimated_shipping_time_required": "Please select estimated shipping time",
            "error_tracking_no_required": "Please enter the tracking number",
            "error_logistics_company_required": "Please enter the logistics company name",
            "error_shipping_date_required": "Please select shipping date",
            "error_trade_country_required": "Please select trade country/region",
            "error_buyer_name_required": "Please enter buyer name",
            "error_buyer_address_required": "Please enter buyer address",
            "error_company_website_required": "Please enter company/store website",
        },
        fileTips: {
            "EQUITY_STRUCTURE_DIAGRAM": "The shareholding structure should extend to natural persons, with each layer displaying the shareholder’s name and shareholding ratio, as well as indicating the date and affixing the company seal.",
            "CERTIFICATE_BUSINESS_ADDRESS": "Water, electricity, and gas bills from the last three months for the registered address, an office lease agreement, or a bank statement with addresses are acceptable.",
            "BUSINESS_REGISTER_CERTIFICATE": "The business registration certificate number must be filled in completely.",
            "NNC1": "It is required if the company is established less than one year.",
            "NAR1": "The annual return form must be provided if the company is registered for more than one year.",
            "ND2A": "If there are changes in the directors, the notice of change of company secretary and director must be provided.",
            "ID_CARD_HOLD": "Requirement of hand-held identity card: color photograph, clear and non-reflective.",
            "UPDATE_TIME": "Expires on",
            "store_status_frozen_title": "This entity has been frozen",
            "store_status_frozen_description": " Your company account is temporarily unavailable. Please contact your account manager or customer service for assistance.",
            "store_status_frozen_description1": "This store entity has been frozen. Please contact the sales manager",
            "store_status_frozen_button": "Confirm",
            "verify_rejected": "Verify Rejected",
            "verify_frozen": "Verify Frozen",
            "frozen": "Frozen"
        },
        shopBinding1: {
            "title": "You haven't completed real-name verification and cannot proceed.",
            "subtitle": "Please submit real-name verification information. We will prioritize processing within 1 business day.",
            "subtitle_2": "Once approved, a collection account will be automatically assigned, enabling fast incoming funds and global payout services.",
            "section_title_location": "Business Registration Location",
            "mainland_china": "Mainland China",
            "hong_kong": "Hong Kong",
            "international": "International",
            "account_nickname_label": "Account Nickname",
            "nickname_placeholder": "Please enter account nickname",
            "go_verify_button": "Proceed to Real-name Verification",
            "title_switch_account": "Switch Account",
            "createAccountLink": "Create New Account",
            "accountNumberLabel": "Account Number",
            "documentNumberLabel": "ID Number",
            "businessRegistrationNumberLabel": "Business Registration Number",
            "useAccountButton": "Use Account",
            "modalTitle": "Notice",
            "modalDescription": "Please confirm whether the binding is completed. Click Confirm to return to the homepage and exit the binding page. Click Cancel to continue the binding process.",
            "cancelButton": "Cancel",
            "confirmButton": "Confirm",

            "pageTitle": "Bind Infinia Account",
            "modalTitle_2": "Confirm Information",
            "modalDescription_2": "Please confirm the merchant entity ID on the current e-commerce platform: {idNumber}. If you wish to use a different ID, please update it in the platform's backend before re-initiating the binding process.",
            "cancelButton_2": "Cancel",
            "confirmButton_2": "Confirm",
            "actionButton_2": "Confirm Binding",
            "infiniaService": "Infinia service agreement",
            "privacyPolicy": "Privacy And Security Policy",
            "and": "and",
            "updateDocumentTips": "{feature_name} functionality has been disabled because your document has expired. Please click [Update Now] to upload the document, or go to the “My Account” page to complete the update and restore access.",
            "shopExpiredTips": "The primary document for store {shopName} has expired, so withdrawals/payments are currently unavailable. Please ask the managing account to upload the updated document in the “My Account” page to restore access.",

            "multipleDocumentsExpiring": "Your entity {entityName} has {num} document(s) expiring between {minExpire} {symbol} {maxExpire}, with the earliest expiring in only {minExpireDay} day(s). To ensure uninterrupted use of your account, please update them as soon as possible.",
            "documentExpiredGracePeriodTips": "We have provided a {delayExpireDay}-day grace period until {maxExpire}, during which transaction features will remain available. Please click [Update Now] to upload the new document, or go to the “My Account” page to complete the update. If the document is still not updated after the grace period, transaction features will be suspended.",

            "allBalance": "Total Store Balance",
            "allBalanceTips": "Total payable amount:",

            "documentExpiringTips": "Your certificate is about to expire",
            "documentExpiringTips_2": "{minExpireDay}days remaining",
            "documentExpiringTips_3": "please update immediately",
            "documentExpiringTips_4": "This store's entity certificate has expired",
            "documentExpiringTips_5": "Please update the certificate",
            "documentExpiringTips_6": "Your certificate has expired",
            "noLongerRemind": "Do not remind me again",
            "closeNoticeFail": "Failed to close the reminder. Please try again later"
        },
        shopBinding2: {
            "bindInfiniaAccount": "Bind Infinia Account",
            "yourLegalEntity": "Your Legal Entity Certificate Number",
            "infiniaEntity": "Infinia Verified Legal Entity Certificate Number",
            "switchAccount": "Switch Account",
            "reviewingNotice": "Please note: Your current Infinia verification is under review. Once approved, the account will be automatically bound.",
            "ensureInfoMatch": "Please ensure the real-name verification info matches the e-commerce platform entity",
            "confirmBinding": "Confirm Binding",
            "title": "Pre-Binding Submitted!",
            "processingNotice": "We will prioritize processing within 1 business day. Please check your email or SMS notifications.",
            "approvalInfo": "Once your identity is approved and the information matches, a collection account will be automatically assigned to you, enabling fast settlement and global payment services.",
            "returnHomeButton": "Return to Homepage",
            "unverified": "Unverified",
            "reviewing": "Reviewing",
            "verified": "Verified",
            "failed": "Failed",
            "certNoNotMatch": "The account certificate number does not match the seller's certificate number, cannot be selected",
            "switchAccountError": "Switch entity account error",
        },
        applyPayeeAccount: {
            "title_select_collection_platform": "Select the Collection Platform You Need",
            "tab_other": "Other",
            "card_general_trade_title": "General Trade",
            "card_general_trade_subtitle": "Self-developed",
            "page_title_bind_store": "Bind Store",
            "breadcrumb_path": "Home / My Store / Bind Store",
            "label_platform": "Store Platform",
            "label_store_name": "Store Name",
            "label_currency": "Currency",
            "label_store_url": "Store URL",
            "checkbox_agreement": "I have read and agree to the Declaration",
            "button_submit": "Submit Application",

            "button_add_beneficiary": "Add Recipient",
            "company_name": "Company Name",
            "card_no_mask": "Infinia Account ID",
            "registerPhone": "Registered Mobile Number",
            "message_missing_required": "Required information is missing. Please refresh and try again.",
            "message_submit_success": "Submitted successfully",
            "b2b_list": "E-commerce Business",
            "b2b_platform_name": "E-commerce Platform",
            "nav_name": "General Trade/Apply for Collection Account"
        },
        "accountList": {
            "breadcrumb_account": "Home / My Account",
            "collection_account": "Collection Account",
            "total_assets_label": "Total Assets",
            "apply_overseas_collection": "Apply for Opening Business",
            "withdraw_account_manage": "Withdrawal Account Management",
            "withdraw_now_button": "Withdraw Now",
            "exchange_rate_note": "Converted at market rate, the currency value is for reference only",
            "basic_account_balance": "Basic Account Balance",
            "currency_label": "Currency",
            "account_balance_label": "Account Balance",
            "available_balance_label": "Available Balance",
            "funds_in_transit_label": "Funds in Transit",
            "requested_accounts_label": "Number of Requested Accounts",
            "currency_cnh": "CNH"
        },
        "home": {
            "home_tab": "Home",
            "label_current_account": "Current Account",
            "available_balance": "Available Balance",
            "no_account_info": "No Account Info",
            "total_balance": "Total",
            "account_tab": "My Account",
            "account_tab_now": "My Account (Current)",
            "kyc_tab": "Real-name Verification Management",
            "collection_tab": "Collection",
            "withdraw_tab": "Withdrawal",
            "payment_tab": "Payment",
            "account_transfer_tab": "Account Transfer",
            "transaction_query_tab": "Transaction Inquiry",
            "quota_tab": "Quota Management",
            "my_assets": "{name}'s Assets",
            "current_entity": "Current Entity",
            "switch_manage_entity": "Switch/Manage Entity",
            "total_assets": "Total Assets",
            "manage_button": "Manage",
            "apply_overseas_account": "Activate General Trade",
            "bind_ecommerce_shop": "Activate Cross-border E-commerce",
            "withdraw_now": "Withdraw Now",
            "recent_transactions": "Recent Transactions",
            "no_label": "No.",
            "time_label": "Time",
            "transaction_type_label": "Transaction Type",
            "amount_label": "Amount",
            "transaction_fee_label": "Transaction Fee",
            "received_amount_label": "Received Amount",
            "payment_cny": "CNY Payment",
            "withdrawal_cny": "CNY Withdrawal",
            "collection_record": "Collection",
            "store_overview": "Store Overview",
            "store_count_info": "You have {count} stores",
            "pending_store_info": "{count} stores pending onboarding",
            "all_button": "All",
            "notifications": "Notifications & Announcements",
            "payment_rate_title": "Exchange Rate Calculator",
            "payment_rate_go_exchange": "Go to Exchange",
            "payment_rate_caption": "Convert using your current foreign currency payment rate",
            "payment_rate_source_currency": "Sell",
            "payment_rate_target_currency": "Buy",
            "payment_rate_amount": "Amount",
            "payment_rate_result": "Converted amount",
            "payment_rate_swap": "Swap currencies",
            "payment_rate_label": "Indicative rate",
            "payment_rate_currency_placeholder": "Select",
            "payment_rate_no_currency": "No currencies available",
            "payment_rate_invalid_amount": "Enter a valid non-negative amount",
            "payment_rate_currency_error": "Unable to load currencies",
            "payment_rate_convert_error": "Payment rate is temporarily unavailable",
            "payment_rate_retry": "Retry",
            "bank_holiday_title": "Holiday Calendar",
            "bank_holiday_month_suffix": "",
            "bank_holiday_loading": "Loading holidays…",
            "bank_holiday_error": "Unable to load holidays. Please retry.",
            "bank_holiday_retry": "Retry",
            "bank_holiday_empty": "No bank holidays on this date",
            "account_upgrade_notice": "Account Upgrade Reminder",
            "infinia_service_notice": "INFINIA Service Notices",
            "market_rate": "Market Exchange Rate",
            "flip_rate": "Invert rates",
            "rate_hint": "Exchange rates are for reference only. Actual rates are subject to the transaction page.",
            "boc_latest_rate": "Latest pricing info from Bank of China",
            "copyright": "All rights reserved",
            "about_us": "About Us",
            "contact_manager": "Contact Business Manager",


            "title_switch_account": "Switch Account",
            "label_select_account": "Please select an account",
            "link_create_new_account": "Create New Account",
            "account_filter_tooltip_show_all": "Show all accounts",
            "account_filter_tooltip_show_verified_only": "Show verified accounts only",
            "label_nickname": "Nickname:",
            "label_account_number": "Account Number:",
            "tag_not_verified": "Not Verified",
            "tag_pending_review": "Pending Review",
            "button_set_default": "Set as Default",
            "button_cancel": "Cancel",
            "button_confirm_switch": "Switch Account",
            "tag_approved": "Approved",
            "button_default_account": "Default Account",
            "menu_switch_account": "Switch Account",
            "menu_user_center": "User Center",
            "menu_logout": "Log Out",
            "locale_simplified_chinese": "简体中文",
            "locale_english": "English",
            "mobile_side_menu_title": "Menu",
            "label_business_reg_no": "Business registration no.: ",
            "label_cert_expire_status": "Document expiry: ",
            "cert_status_expired": "Expired",
            "cert_status_valid": "Not expired",
            "message_account_switched": "Switched successfully",
            "modal_title_service": "Service Activation",
            "modal_greeting": " Dear",
            "modal_message": "Hello, we’ve carefully prepared various services to meet your needs.",
            "button_activate_now": "Activate Now",
            "page_title_login": "Log in to Infinia Account",
            "button_back_infinia": "Back to Infinia",
            "guide_title": "New User Guide",
            "step_1_title": "User Registration",
            "step_1_status": "Completed",
            "step_2_title": "Set Account Holder",
            "step_2_status": "Completed",
            "step_3_title": "Identity Verification",
            "step_3_status": "Completed",
            "step_4_title": "Activate Business",
            "step_4_title_1": "",
            "step_4_status": "Completed",
            "step_5_title": "Account Credited",
            "step_5_status": "Pending Credit",
            "step_action_status": "To Complete",
            "business_dialog_title": "Activate Business",
            "business_ecommerce": "E-commerce Platform",
            "business_general_trade": "General Trade",
            "title_register_infinia": "Register Infinia Account",
            "text_no_transaction": "No Transactions",
            "title_user_confirm_info": "User Confirmation Info",
            "checkbox_agree_statement": "I have read and agree",
            "link_statement": "Declaration",
            "tips_description": "Total Assets: The aggregate balance of all multi-currency accounts, converted into CNH at the current exchange rate.",
            "menu_account_manager": "Account Holder Management",
            "nav_payment_batch": "Batch FX Settlement",
        },
        "createVa": {
            "title": "Apply Collection Account",
            "title_supplement": "Supplement Materials",
            "notice_1": "1. The payee name must match the bank account name, otherwise review may be rejected or collection may be delayed.",
            "notice_2": "2. We recommend using a primary bank card to avoid withdrawal issues with secondary cards.",
            "notice_3": "3. Review is expected to complete within 3-5 business days. Payments can be made to the payee after approval.",
            "section_basic": "Basic Information",
            "section_supplement": "Supplement Materials",
            "label_kyb": "Business Category",
            "label_account_name": "Collection Account Name",
            "label_holder": "Account Holder",
            "label_quantity": "Application Quantity",
            "label_va_region": "Collection Account Opening Region",
            "label_bank": "Opening Bank",
            "label_currency": "Application Currency",
            "label_description": "Description",
            "label_upload_material": "Upload Materials",
            "text_trade_material_upload": "trade authenticity materials",
            "text_material_later_tip": "The recipient has been added. If materials are not ready, you can supplement them later in recipient management.",
            "placeholder_select": "Please select",
            "placeholder_input": "Please enter",
            "text_agree": "I have read and agree to",
            "text_statement": "Declaration",
            "validation_select": "Please select",
            "validation_input": "Please enter",
            "validation_upload_material": "Please upload materials"
        },
        "payee": {
            "nav_collection": "Store List",
            "nav_store_manage": "Centralized Store Management",
            "nav_order_manage": "Collection Orders",
            "nav_business_open_record": "General Trade Activation Records",
            "nav_cross_border_ecommerce_record": "Cross-border E-commerce Activation Records",
            "nav_va_manage": "Collection Accounts",
            "tab_collection_account": "Collection Accounts",
            "tab_collection_account_detail": "Account Details",
            "column_va_account_no": "Account Number",
            "column_va_account_name": "Account Name",
            "column_open_account_count": "Opened Accounts",
            "column_payment_type": "Payment Method",
            "column_bank_country_region": "Bank Country/Region",
            "label_account_no": "Account No.",
            "placeholder_account_no": "Please enter account number",
            "label_account_holder_name": "Account Name",
            "placeholder_account_holder_name": "Please enter account name",
            "title_business_open_record": "Business Activation Record",
            "label_business_name": "Business Name:",
            "placeholder_business_name": "Please enter business or platform name",
            "label_business_type": "Business Type:",
            "label_business_type_plain": "Business Category:",
            "label_business_line": "Business Line:",
            "label_status_text": "Status:",
            "column_kyb_no": "KYB No.",
            "column_business_name": "Business Name",
            "column_business_type1": "Business Line",
            "column_business_type": "Business Type",
            "column_industry_category": "Industry Category",
            "column_bank_platform": "Bank/Region",
            "column_bank_region": "Receiving Bank Region",
            "column_bank_name": "Receiving Bank",
            "column_main_business_region": "Main Business Region",
            "column_apply_time": "Application Time",
            "action_continue_open": "Continue",
            "action_apply_va": "Apply Virtual Account",
            "action_resubmit": "Resubmit",
            "action_supplement": "Supplement",
            "status_passed": "Passed",
            "status_rejected": "Rejected",
            "status_pending_review": "Pending",
            "status_expired": "Expired",
            "business_status_init": "Initialized",
            "business_status_process": "Under Review",
            "business_status_passed": "Approved",
            "business_status_close": "Closed",
            "business_status_supplement": "Supplement",
            "business_status_rejected": "Rejected",
            "business_status_finished": "Success",
            "status_init_open_supplement": "Onboarding Pending Supplement",
            "status_init_va_supplement": "Account Opening Pending Supplement",
            "status_reject_open_supplement": "Onboarding Supplement Rejected",
            "status_reject_va_supplement": "Account Opening Supplement Rejected",
            "status_va_init": "Pending",
            "status_va_process": "Processing",
            "status_va_supplement_init": "Pending Supplement",
            "status_va_supplement_process": "Customer Pending Supplement",
            "status_va_supplement_pending": "Supplement Review",
            "status_va_supplement_reject": "Supplement Rejected",
            "status_va_finished": "Success",
            "status_va_failed": "Failed",
            "account_status_init": "Pending",
            "account_status_process": "Processing",
            "account_status_pending_doc": "Pending Documents",
            "account_status_success": "Success",
            "account_status_fail": "Failed",
            "account_status_close": "Closed",
            "business_line_goods": "Goods Trade",
            "business_line_services": "Service Trade",
            "nav_shop_holder_manage": "Store Holders",
            "table_amount": "Amount",
            "table_status": "Status",
            "action_edit": "Edit",
            "breadcrumb_collection": "Home / Collection",
            "kyc_tips_text": "KYC verification incomplete. Please complete the verification as soon as possible to avoid affecting fund deposits and related operations",
            "title_collection_store": "Collection Account/Store",
            "store_status_label": "Status:",
            "store_status_all": "All",
            "store_status_normal": "Normal",
            "store_status_pending": "Pending",
            "store_status_rejected": "Rejected",
            "label_platform": "Platform:",
            "label_currency": "Currency:",
            "label_search": "Account/Store Name:",
            "search_placeholder": "Please Enter",
            "button_search": "Search",
            "button_business_open": "Business Activation",
            "button_apply_overseas_account": "Opening Business",
            "button_bind_shop": "Bind Store",
            "button_apply_va": "Apply for VA",
            "store_overview": "Store Overview",
            "store_total_count": "You have 3 stores",
            "store_pending_count": "0 stores pending onboarding",
            "table_store_name": "Store Name",
            "table_shop_url": "Store URL",
            "table_currency": "Currency",
            "table_expected_month_turnover": "Estimated Monthly Turnover",
            "table_expected_year_turnover": "Estimated Annual Turnover",
            "table_business_scope": "Business Scope",
            "table_shop_holder": "Store Holder",
            "table_shop_screenshot": "Store Screenshot",
            "table_collection_account": "Collection Account",
            "table_platform_name": "Platform Name",
            "table_platform_name_b2b": "Business Line",
            "table_available_amount": "Withdrawable Amount",
            "table_quota": "FX settlement quota",
            "table_pending_amount": "Pending Amount",
            "table_store_status": "Account/Store Status",
            "table_actions": "Actions",
            "action_view_detail": "View Details",
            "message_no_detail_id": "Missing detail query parameter",
            "action_apply_collection_account": "Apply for Collection Account",
            "action_view_orders": "View Orders",
            "button_batch_close": "Batch Close",
            "confirm_close_title": "Close Confirmation",
            "confirm_close_message": "VA accounts cannot be used or recovered after closure. Are you sure you want to close?",
            "button_confirm_close": "Confirm Close",
            "message_batch_close_select_first": "Please select e-commerce platform stores to close",
            "message_batch_close_success": "Submitted successfully",
            "message_batch_close_fail": "Close failed. Please try again later",
            "pagination_page_1": 1,
            "b2b_text": "General Trade",
            "collection_text": "E-commerce Platform",
            "bindOther": {
                "id_card": "ID Card",
                "passport": "Passport",
                "message_upload_file": "Please upload file",
                "title": "Apply for Collection Account",
                "section_business_open": "Business Activation",
                "section_account_apply": "Collection Account Application",
                "section_supplement_material": "Supplemental KYC / Channel Required Materials",
                "section_business_supplement": "Business Supplementary Materials",
                "validation_enter_supplement_field": "Please complete {title}",
                "validation_upload_supplement_field": "Please upload {title}",
                "label_review_comment": "Review Comment:",
                "label_business_type": "Business Type",
                "label_main_business_country": "Main Business Country/Region",
                "label_expected_turnover": "Estimated Monthly Turnover",
                "placeholder_expected_turnover": "Please select an estimated monthly turnover range",
                "option_turnover_lt_50k": "Less than 50,000",
                "option_turnover_50k_200k": "50,000 - 200,000",
                "option_turnover_200k_500k": "200,000 - 500,000",
                "option_turnover_gt_500k": "More than 500,000",
                "label_shop_url": "Business Website",
                "placeholder_shop_url": "Please enter or paste the website URL",
                "label_fundin_country": "Most Frequent Fund-in Country",
                "label_fundout_country": "Most Frequent Fund-out Country",
                "label_account_name": "Collection Account Name",
                "placeholder_account_name": "Collection Account Name",
                "label_bank_region": "Receiving Bank Region",
                "placeholder_bank_region": "Please select receiving bank region",
                "label_bank_name": "Receiving Bank",
                "placeholder_bank_name": "Please select receiving bank",
                "label_account_currency": "Collection Account Currency",
                "placeholder_account_currency": "Please select the currency for the account",
                "label_region_address_en": "Registered Address in English",
                "placeholder_region_address_en": "Please enter registered address in English",
                "label_business_address_en": "Business Address in English",
                "placeholder_business_address_en": "Please enter business address in English",
                "label_trade_type": "Trade Type",
                "trade_type_self_export": "Self-operated Export",
                "trade_type_agent_export": "Agent Export",
                "label_qualification_upload": "Qualification Document Upload",
                "text_qualification_upload": "Please upload related qualification documents",
                "label_legal_hold_photo": "Legal Representative Holding ID Photo",
                "text_trade_material_upload": "trade authenticity materials",
                "text_material_later_tip": "The recipient has been added. If materials are not ready, you can supplement them later in recipient management.",
                "label_remark": "Remark",
                "label_supplement_legal_hold": "Supplement Legal Representative ID (Handheld)",
                "legal_person": "legal representative",
                "ubo_person": "beneficial owner",
                "auth_signer_person": "authorized signatory",
                "supplement_legal_hold_format": "{name}{category}'s handheld {type}",
                "text_supplement_legal_hold": "Please upload handheld ID photo of legal representative",
                "label_supplement_hk_corp_form": "Supplement Incorporation Form",
                "text_supplement_hk_corp_form": "Please upload Hong Kong Incorporation Form",
                "label_supplement_hk_equity_diagram": "Supplement Shareholding Structure Chart",
                "text_supplement_hk_equity_diagram": "Please upload shareholding structure chart",
                "text_agree": "I have read and agreed to",
                "text_statement": "Statement",
                "button_submit": "Submit Application",
                "message_submit_success": "Submitted Successfully",
                "message_submit_failed": "Submission Failed",
                "validation_agree_statement": "Please read and agree to the Statement",
                "validation_select_business_type": "Please select business type",
                "validation_select_main_business_country": "Please select main business country/region",
                "validation_select_expected_turnover": "Please select estimated monthly turnover",
                "validation_enter_shop_url": "Please enter business website",
                "validation_url_format": "Please enter a valid URL format",
                "validation_select_fundin_country": "Please select most frequent fund-in country",
                "validation_select_fundout_country": "Please select most frequent fund-out country",
                "validation_select_bank_region": "Please select receiving bank region",
                "validation_select_bank_name": "Please select receiving bank",
                "validation_select_currency": "Please select collection account currency",
                "validation_enter_region_address_en": "Please enter registered address in English",
                "validation_enter_business_address_en": "Please enter business address in English",
                "validation_enter_account_name": "Please enter collection account name",
                "validation_select_trade_type": "Please select trade type"
            },
            "businessOpenRecordDetail": {
                "title": "Details",
                "basic_info": "Basic Information",
                "address_info": "Address Information",
                "material_info": "Materials",
                "label_kyb_no": "KYB No.",
                "label_status": "Status",
                "label_business_type": "Business Type",
                "label_business_line": "Business Line",
                "label_industry_category": "Industry Category",
                "label_industry_subcategory": "Industry Subcategory",
                "label_account_name": "Collection Account Name",
                "label_main_business_country": "Main Business Country/Region",
                "label_shop_url": "Business Website",
                "label_fundin_country": "Most Frequent Fund-in Country",
                "label_fundout_country": "Most Frequent Fund-out Country",
                "label_trade_type": "Trade Type",
                "label_expected_turnover": "Estimated Monthly Turnover",
                "label_apply_time": "Application Time",
                "label_region_address_en": "Registered Address in English",
                "label_business_address_en": "Business Address in English",
                "label_remark": "Review Comment:",
                "label_remark_plain": "Remark",
                "action_open_file": "View",
                "action_back": "Back",
                "no_file": "No materials",
                "empty": "No details",
                "load_failed": "Failed to load details. Please try again later"
            },
            "button_upLoad": "Upload",
            "button_errorFileDownload": "Error File Download",
            "button_addQuota": "Add Quota",
            "validation": {
                "rule_select_payout_method": "Please select transfer method",
                "rule_input_payee_name": "Please enter recipient account name",
                "rule_select_type": "Please select corporate/personal",
                "rule_select_bank_country": "Please select bank country/region",
                "rule_select_currency": "Please select currency",
                "rule_input_bank_name": "Please enter beneficiary bank name",
                "rule_input_card_no": "Please enter bank account number",
                "rule_card_no_pattern": "Bank account number cannot contain special characters",
                "rule_input_swift": "Please enter SWIFT/BIC code",
                "rule_swift_pattern": "Invalid SWIFT format",
                "rule_input_branch": "Please enter detailed bank branch",
                "rule_input_legal_name": "Please enter legal representative's name",
                "rule_input_legal_id": "Please enter legal representative's ID number",
                "rule_select_legal_country": "Please select legal representative's nationality",
                "rule_input_bank_address": "Please enter bank address",
                "rule_input_payee_city": "Please enter city",
                "rule_input_postal_code": "Please enter postal code",
                "rule_postal_code_pattern": "Only numbers or English letters are allowed",
                "rule_input_bank_code_3digits": "Please enter 3 digits",
                "rule_beneficiary_half_width": "Use English letters, numbers, half-width spaces and - ? : ( ) . , ' + only. Full-width characters and a leading - are not allowed.",
                "rule_remit_invalid_chars": "Remittance info supports English letters, numbers, spaces, and the following symbols only: / - ? : ( ) . , ' +",
                "rule_remit_dash_start": "Cannot start with a dash (-)",
                "rule_remit_colon_start": "Cannot start with a colon (:)",
                "rule_cert_expire_min_today": "Expiry date cannot be earlier than today",
                "rule_fill_bank_name_first": "Please enter the beneficiary bank name first"
            },
            "bindShop": {
                "rule_platform_required": "Please enter the store platform",
                "rule_name_required": "Please enter the store name",
                "rule_url_required": "Please enter the store URL",
                "rule_owner_required": "Please select owner",
                "rule_currency_required": "Please select currency",
                "rule_agree_protocol": "Please read and agree to the Statement",
                "label_store_address": "Store address",
                "label_monthly_turnover": "Estimated monthly turnover",
                "label_annual_turnover": "Estimated annual turnover",
                "placeholder_annual_turnover": "Please enter estimated annual turnover ({currency})",
                "label_shop_holder": "Shop holder",
                "label_shop_screenshot": "Shop screenshot",
                "upload_suffix_shop_screenshot_with_url": "shop screenshot (including URL)",
                "label_owner": "Owner (text)",
                "label_operator": "Operator",
                "label_category": "Category",
                "rule_last_name_only_english": "Last name can only contain English letters",
                "rule_first_name_only_english": "First name can only contain English letters",
                "rule_address_required": "Please enter store address",
                "rule_address_invalid": "Please enter a valid URL (starts with http/https and ends with an allowed suffix)",
                "rule_monthly_turnover_required": "Please select estimated monthly turnover",
                "rule_annual_turnover_required": "Please enter estimated annual turnover",
                "rule_holder_required": "Please select shop holder",
                "confirm_apply_title": "Application confirmation",
                "confirm_apply_message": "Please confirm the shop information is correct before submitting.",
                "confirm_apply_fee_message": "Opening a VA account will incur related fees. Do you want to apply?\n({openFeeTypeDesc} {openFeeAmount} {openFeeCurrencyCode}/account, {mgmtFeeTypeDesc} {mgmtFeeAmount} {mgmtFeeTypeCurrencyCode}/account)",
                "fee_type_open": "Opening fee",
                "fee_type_mgmt": "Management fee",
                "confirm_apply_confirm": "Confirm",
                "confirm_apply_cancel": "Cancel",
                "turnover_lt_100k": "Monthly turnover below $100k",
                "turnover_100k_300k": "Monthly turnover $100k (incl.) - $300k",
                "turnover_300k_500k": "Monthly turnover $300k (incl.) - $500k",
                "turnover_gte_500k": "Monthly turnover $500k (incl.) and above",
                "label_expected_turnover_year": "Estimated annual turnover",
            },
        },
        "payment": {
            "page_title": "Payment",
            "label_available_amount": "Available payment amount:",
            "label_available_amount_b2b": "Available FX settlement quota:",
            "label_business_type": "Business Type",
            "label_platform": "Platform",
            "label_account_currency": "Account Currency",
            "section_amount_verify": "Amount Verification",
            "button_prev_step": "Previous Step",
            "breadcrumb_payment": "Home / Payment",
            "step_fill_info": "Fill in Payment Info",
            "step_verify_info": "Verify Payment Info",
            "step_complete": "Complete",
            "section_payment_info": "Payment Information",
            "label_select_business_type": "Please select business type",
            "label_select_platform": "Select Platform:",
            "platform_all": "All",
            "platform_trade": "General Trade",
            "platform_joom": "Joom Platform",
            "platform_wildberries": "Wildberries",
            "label_select_account": "Receiving Account:",
            "placeholder_select_account": "Please select a receiving account",
            "placeholder_select_shop": "Please select shop",
            "link_manage_recipient": "Recipient Management",
            "table_store_name": "Store Name",
            "table_available_balance": "Available Balance",
            "table_available_balance_label": "Available Balance",
            "table_payment_amount": "Payment Amount",
            "placeholder_amount": "Enter amount",
            "placeholder_enter_amount": "Select this row to enter amount",
            "label_order_note": "Order Notes:",
            "order_note": "Order Notes",
            "placeholder_order_note": "Add a note to help you identify this order later",
            "tip_order_note": "For your records only. Notes are not shared with the recipient.",
            "label_total_amount": "Total Payment Amount",
            "button_next": "Next",
            "credit_insufficient_title": "Notice",
            "credit_insufficient_message": "Insufficient FX settlement quota. Please upload order materials to supplement the quota.",
            "credit_insufficient_confirm": "Go",
            "title_verify_info": "Please verify your payment information before proceeding with security verification",
            "section_payee_info": "Payee Information",
            "section_payer_info": "Payer Information",
            "label_payee_name": "Payee Nickname:",
            "label_bank_account_name": "Bank Account Name:",
            "label_bank_name": "Bank Name:",
            "label_account_number": "Bank Account Number:",
            "section_amount_summary": "Amount Summary",
            "label_payment_amount": "Payment Amount:",
            "label_exchange_rate": "Exchange Rate:",
            "label_total_pay_amount": "Total payment amount:",
            "label_shop_total_amount": "Store Balance:",
            "label_credit_total_amount": "Store FX Settlement Quota:",
            "label_total_pay_count": "Total payment count:",
            "file_parse_fail_title": "File parsing failed",
            "file_parse_fail_text": "File parsing failed:",
            "download_error_file": "Download error file",
            "file_upload_success_title": "File uploaded successfully",
            "email_verify": "Email verification:",
            "send_verify_code": "Send verification code",
            "email_code_sent_tip": "Sent (valid for 5 minutes)",
            "send_success": "Sent",
            "label_fee": "Total Fee:",
            "section_date_note": "Date & Note",
            "label_transaction_date": "Transaction Date:",
            "label_security_code": "Security Verification Code",
            "placeholder_security_code": "Enter verification code",
            "button_get_code": "Verification Code",
            "link_resend_code": "Resend to another email",
            "note_code_sent": "For account security, the verification code will be  send to",
            "button_back_return": "Go Back",
            "label_total_payment": "Total Payment Amount:",
            "label_expected_arrival": "Net Amount Received:",
            "button_submit": "Submit",
            "breadcrumb_beneficiary_manage": "Home / Payment / Beneficiary Management",
            "title_beneficiary_manage": "Beneficiary Management",
            "status_all": "All",
            "status_approved": "Approved",
            "status_rejected": "Rejected",
            "status_pending": "Pending",
            "status_to_complete": "To Complete",
            "label_search": "Search:",
            "placeholder_enter_name": "Enter beneficiary name",
            "button_add_beneficiary": "Add Beneficiary",
            "table_beneficiary_id": "Beneficiary ID",
            "table_beneficiary_name": "Beneficiary Name",
            "table_bank_name": "Bank Name",
            "table_account_number": "Account Number",
            "table_status": "Status",
            "table_action": "Action",
            "action_delete": "Delete",
            "refuse_reason": "Reason for rejection",
            "reason_for_refuse": "Reason",
            "action_edit_info": "Edit Info",
            "action_edit_material": "Edit Materials",
            "action_submit_material": "Submit Docs",
            "title_add_beneficiary": "Add New Beneficiary",
            "note_approval_time": "Approval takes 3-5 business days. Once approved, payment can be made to the beneficiary.",
            "note_name_match_warning": "Beneficiary name must match account info, or approval will fail.",
            "note_use_primary_bank": "Use Tier-1 bank cards to avoid issues with withdrawal.",
            "section_basic_info": "Basic Information",
            "label_bank_country": "Bank Country",
            "label_account_name": "Account Name",
            "label_account_type": "Account Type",
            "option_corporate": "Corporate",
            "option_individual": "Individual",
            "label_remark_name": "Account Nickname",
            "section_bank_info": "Bank Account Info",
            "label_beneficiary_bank": "Bank Name",
            "label_account_number_full": "Bank Account Number",
            "label_branch_name": "Bank Branch",
            "label_currency": "Currency",
            "label_swift_code": "SWIFT Code",
            "section_beneficiary_info": "Beneficiary Info",
            "label_uscc": "Unified Social Credit Code",
            "label_legal_id": "Unified Business Code",
            "label_legal_name": "Legal Representative Name",
            "label_legal_id_number": "ID Number",
            "label_legal_nationality": "Nationality",
            "label_address": "Detailed Business Address",
            "button_cancel": "Cancel",
            "button_confirm_submit": "Confirm Add",
            "note_review_time": "Review expected within 3–5 business days. Payments can be made once approved.",
            "note_name_account_match": "Name must match bank account; otherwise approval may fail.",
            "note_use_tier1_card": "Use Tier 1 bank card to avoid withdrawal issues",
            "tab_beneficiary_info": "Beneficiary Info",
            "tab_trade_doc": "Upload Trade Materials",
            "note_trade_doc_required": "Required for newly added beneficiaries",
            "label_recipient": "Recipient",
            "label_note_choose_doc_type": "Select trade type and upload relevant documentation. Once approved, payment can proceed.",
            "placeholder_select_type": "Please Select",
            "label_upload_trade_doc": "Trade Documentation",
            "button_upload_doc": "Click to Upload Trade Documents",
            "note_file_types_supported": "Supported formats: jpg, jpeg, png, pdf, zip, rar; Max file size: 20MB",
            "button_assign_later": "Assign Later",
            "button_submit_now": "Submit Now",
            "note_upload_later": "The beneficiary has been added. If the required documents are not ready, you can upload them later in the Beneficiary Management List.",
            "title": "Supplementary Materials",
            "section_title": "Upload Trade Materials",
            "beneficiary_label": "Beneficiary",
            "bank_info_label": "China Merchants Bank (Last digit 1 | Bank Location: China)",
            "trade_type_label": "Trade Type",
            "trade_type_placeholder": "Please select the trade type with the beneficiary and submit relevant materials. Payment can be initiated after approval.",
            "trade_type_option": "E-commerce Platform Business",
            "upload_label": "Trade Documents",
            "upload_link_trade_doc": "Trade Authenticity Documents",
            "delete_button": "Delete",
            "download_link": "Download Uploaded Trade Documents",
            "cancel_button": "Cancel",
            "submit_button": "Submit",
            "footer_note": "Beneficiary has been added. If the documents are not yet ready, you may upload them later in the Beneficiary Management section.",
            "bank_address": "Bank Address",
            "beneficiary_info_label": "Beneficiary Info",
            "beneficiary_city": "Beneficiary City",
            "beneficiary_address": "Beneficiary Address",
            "postal_code": "Postal Code",
            "confirm_edit_button": "Confirm Edit",
            "bulk_upload": "Bulk FX Settlement",
            "bulk_upload_label": "Bulk Upload",
            "bulk_currency_cnh": "CNH",
            "single_payment": "Single Payment",
            "template_download": "Template Download",
            "store_list": "Store List",
            "store_list_placeholder": "payee account",
            "store_list_placeholder1": "Bulk FX Settlement File",
            "security_verification": "Security Verification",
            "security_input_placeholder": "Please enter verification code",
            "send_code_button": "Send Verification Code",
            "switch_to_email_verify": "Switch to Email Verification",
            "Switch_to_SMS_Verification": "Switch to SMS Verification",
            "sms_notice": "Verification code will be sent to ",
            "safety_tip": "For account security, please complete verification before proceeding",
            "account_currency": "Account's currency:",
            "label_payment_method": "Payment Method:",
            "add_account_transfer_recipient": "Add Infinia Internal Transfer Beneficiary",
            "greeting": "Dear Customer",
            "successMessage": "Operation successful",
            "returnButton": "Return",
            "infiniaAccountNo": "Infinia Account No: ",
            "paymentMethod": "Payment Method: ",
            "recipientName": "Recipient Name (Beneficiary): ",
            "accountToAccountTransfer": "Account-to-Account Transfer",
            "infiniaAccountTransfer": "Account-to-Account Transfer",
            "payMentSelect": "Payment",
            "tag_shop_expire": "Expired",
            "tag_shop_merge": "Fund Consolidation",
            "getVerificationCode": "Get Verification Code",
            "isPobo": "POBO",
            "isPobo_tooltip": "When the recipient receives the funds, the payer's name displayed is",
            "payer_name": "Payer Name",
            "payer_name_tip": "For same-name POBO payment, select a payer. If no payer is selected, PAYEASE and partner information will be displayed by default",
            "payer_name_default_display": "payease or payease partners",
            "payer_name_placeholder": "Please select payer name",
            "payer_management": "Payer Management",
            "add_payer": "Add Payer",
            "swift_payment_info_title": "SWIFT Payment Information",
            "pobo_payer_name": "Payer Name (POBO)",
            "specify_payer_name": "Specify Payer Name",
            "specify_payer_name_help": "When enabled, the beneficiary will see the payer name you specify. When disabled, no payer name is specified, and the visible name depends on the actual payment method.",
            "payer_picker_subtitle": "Use the current entity English name or an approved added payer",
            "payer_search": "Search",
            "payer_search_placeholder": "Enter company English name",
            "payer_current_entity": "Current Entity",
            "payer_added_payers": "Added Payers",
            "payer_registration_no": "Registration No.",
            "payer_current_entity_english_name": "Current entity English name",
            "payer_added": "Added",
            "payer_no_match": "No matching payer",
            "payer_name_unspecified": "Payer Name Not Specified",
            "payer_default_display_name": "PAYEASE or Partner Name",
            "payer_default_name_tip": "PAYEASE or the payment partner name is shown by default",
            "payer_verified_name_tip": "Verified entity English company name",
            "trade_material": "Trade Materials",
            "trade_material_help": "Upload contracts, invoices, or other documents between the payer and beneficiary to verify this transaction. You can continue after uploading without waiting for a review.",
            "trade_material_upload": "Transaction documents between the POBO payer and beneficiary, such as contracts or invoices signed or stamped by both parties",
            "trade_material_required": "Please upload trade materials",
            "payment_purpose": "Payment Purpose",
            "payment_purpose_help": "Select the payment purpose that accurately reflects this transaction.",
            "payment_purpose_placeholder": "Select a payment purpose",
            "payment_purpose_required": "Please select a payment purpose",
            "swift_remittance": "Payment Reference",
            "remittanceInfo": "Payment Reference:",
            "placeholder_remittance_info": "Enter a reference to help the recipient identify this payment",
            "tip_remittance_info": "This reference may appear on the recipient's bank statement. Avoid special characters to ensure it displays correctly.",
            "remittance_info_error": "Transaction remark contains sensitive content.",
            "default_label": "Default",

        },
        "poboPayer": {
            "management_title": "Payer Management",
            "add_button": "Add Payer",
            "search_label": "Search",
            "search_placeholder": "Company English name or registration number",
            "company_english_name": "Company English Name",
            "company_english_name_placeholder": "Enter the registered company English name",
            "company_english_name_invalid": "Use letters, numbers, spaces and / ( ) . , - ? : '; numbers only are not allowed",
            "company_original_name": "Original Company Name",
            "company_original_name_placeholder": "Enter the original legal name shown on the registration document",
            "country_region": "Country/Region",
            "country_registration": "Country/Region of Registration",
            "province": "Province",
            "province_state": "Province / State",
            "city": "City",
            "post_code": "Post Code",
            "registered_address": "Registered Address",
            "registered_address_placeholder": "Enter the registered address shown on the document (English)",
            "registered_address_invalid": "Use letters, numbers, spaces and / ( ) . , - ? : ' +; numbers only are not allowed",
            "registration_no": "Registration No.",
            "credit_code": "Unified Social Credit Code",
            "br_number": "Business Registration (BR) Number",
            "registration_date": "Registration Date",
            "business_license": "Business License",
            "business_registration_certificate": "Business Registration Certificate",
            "company_registration_certificate": "Certificate of Incorporation or equivalent official registration proof",
            "upload_hint": "JPG, JPEG, PNG or PDF, up to 20 MB.",
            "upload_required": "Please upload the registration document",
            "status": "Status",
            "status_all": "All",
            "status_approved": "Approved",
            "status_pending": "Processing",
            "status_rejected": "Rejected",
            "submitted_at": "Submitted",
            "action": "Action",
            "reject_reason": "Rejection Reason",
            "edit_resubmit": "Edit and Resubmit",
            "review_comments": "Review Comments",
            "no_data": "No payer profiles",
            "add_page_title": "Add POBO Payer",
            "edit_page_title": "Edit Payer Profile",
            "submit": "Submit for Review",
            "resubmit": "Resubmit for Review",
            "load_failed": "Failed to load payer profiles",
            "detail_load_failed": "Failed to load payer profile",
            "submit_success": "Payer profile submitted for review",
            "submit_failed": "Failed to submit payer profile"
        },
        "shopManage": {
            "nav_store_central_manage": "Store Centralized Management",
            "breadcrumb_store_central": "Home / Collection / Store Centralized Management",
            "page_title_store_manage": "Store Centralized Management",
            "page_subtitle": "Without changing the ownership of the store, the authorized store’s incoming funds under User A can be transferred in real time to User B, enabling centralized fund management under User B.",

            "section_tips_title": "Fund Consolidation Rules",
            "tip_1": "Real-Time Transfer: Funds collected from the managed store will be automatically and instantly transferred to the designated recipient account",
            "tip_2": "Real-Name Verification Required: Both the initiating party and the recipient must complete real-name verification before initiating fund consolidation",
            "tip_3": "No In-Transit Transactions: The store must have passed the account review and have no funds currently in transit or under withdrawal",
            "tip_4": "Independent Fee Structure: The transaction fee rate of the initiating party will remain independent and will not be applied to the recipient",
            "tip_5": "Independent Credit Allocation: The store’s credit quota under the initiating party will remain independent and will not be carried over to the recipient",
            "tip_6": "Exclusive Roles: The same entity cannot act as both the initiating party and the recipient in any fund consolidation relationship",

            "section_manage_tips_title": "Operation Process",
            "tip_1_1": 'The initiating party submits a Fund Consolidation Request.',
            "tip_1_2": 'The recipient must confirm the request in the [View Management Records] section.',
            "tip_1_3": 'Once confirmed, the recipient can manage the store under [View Managed Stores] and may revoke consolidation permissions at any time.',


            "tab_initiate_manage": "Initiate Centralized Management",
            "tab_view_managed_store": "View Managed Stores",
            "tab_view_manage_records": "View Management Records",
            "search_placeholder": "Enter store name or account number",
            "select_all_button": "Select All",
            "table_column_owner": "Entity Name",
            "table_column_store": "Store Name",
            "table_column_account": "Account",
            "table_column_manageable": "Manageable",
            "table_value_yes": "Yes",
            "table_value_no": "No",
            "selected_count_info": "0 selected",
            "button_initiate": "Initiate",
            "column_store_name": "Store Name",
            "column_platform": "Platform",
            "column_store_status": "Store Status",
            "column_pending_amount": "Pending Amount",
            "column_action": "Action",
            "label_time": "Time",
            "placeholder_start_date": "Start Date",
            "placeholder_end_date": "End Date",
            "label_store_name": "Store Name",
            "label_status": "Status",
            "dropdown_placeholder": "Please Select",
            "button_query": "Query",
            "column_initiator_info": "Initiator Info",
            "column_receiver_info": "Receiver Info",
            "column_operation_type": "Operation Type",
            "column_status": "Status",
            "column_creation_time": "Creation Time",

            "confirm_dialog_title": "Centralization Confirmation",
            "column_entity_name": "Entity Name",
            "column_account": "Account",
            "column_phone_placeholder": "Recipient’s Mobile Number",
            "column_entity_name_placeholder": "Recipient’s Entity Name",
            "column_verification_code_placeholder": "Verification Code",
            "note_declaration": "Statement: By submitting this authorization, you grant us permission to update and continue providing related services. In addition, you must ensure that your company remains active. Even after authorization, if your company’s account is closed, we will stop the relevant services, and the store’s funds will be returned to the main account.",
            "button_confirm_initiate": "Confirm",
            "button_cancel_initiate": "Cancel",
            "agree_declaration": "I agree to the above declaration and policy terms",

            "rule_phone_placeholder": "Please enter the recipient’s mobile number.",
            "rule_phone_error": "The recipient’s mobile number format is invalid.",
            "rule_phone_required": "The recipient’s mobile number cannot be empty.",
            "rule_entity_name_placeholder": "Recipient entity name cannot be empty.",
            "rule_agree_declaration": "Please read and agree to the above statement and policy terms.",
            "rule_phone_code_placeholder": "The recipient’s mobile country/area code cannot be empty.",
            "status_pending": "Pending",
            "status_confirmed": "Confirmed",
            "status_rejected": "Rejected",
            "table_column_control_cancel": "Cancel Central Management",
            "table_column_control_manage": "Manage Store",
            "confirm_dialog_title_cancel": "Confirm Cancel Central Management?",
            "approve_dialog_title": "Review Confirmation",
            "approve_section_security": "Security Verification",
            "approve_verification_tip": "For account security, please complete verification to proceed. The verification code will be sent to {maskUserInfo}",
            "approve_code_label": "Verification Code",
            "approve_code_placeholder": "Please enter verification code",
            "approve_declaration": "Statement: During the authorized agency period, we still require you to provide necessary materials in accordance with compliance requirements. If you fail to provide relevant information or materials to us, we have the right to terminate your authorized agency.",
            "approve_agree": "I agree to the above declaration and policy terms",
            "approve_btn_cancel": "Cancel",
            "approve_btn_confirm": "Agree",
            "operatorTypeMap": {
                "BIND": "Bind",
                "UNBIND": "Unbind"
            },
            "please_read_and_agree": "Please read and agree to the above statement and policy terms.",
            "please_input_verification_code": "Please enter verification code",
            "send_verification_code": "Send verification code",
            "operation_success": "Operation successful",
            "confirm_reject": "Confirm reject?",
            "button_agree": "Agree",
            "button_reject": "Reject",
        },
        tradeSeach: {
            "menu_transaction_detail": "Transaction Details",
            "menu_balance_detail": "Balance Details",
            "breadcrumb_transaction_detail": "Home / Transaction Inquiry",
            "tab_refund": "Refund",
            "label_deposit_time": "Collection Time:",
            "placeholder_start_date": "Start Date",
            "placeholder_end_date": "End Date",
            "label_platform_type": "Platform Type:",
            "label_deposit_account": "Receiving Account:",
            "label_store": "Store:",
            "table_order_number": "Order No",
            "table_deposit_time": "Collection Time",
            "table_bizType_name": "Business Type",
            "table_platform_name": "Platform Name",
            "table_store": "Store",
            "table_payer": "Payer",
            "table_deposit_account": "Receiving Account",
            "table_deposit_amount1": "Payment Amount",
            "table_collection_amount": "Collection Amount",
            "table_fee": "Fee",
            "table_deposit_amount": "Collection Amount",
            "table_status": "Status",
            "pagination_total": "Total 4",
            "pagination_page_1": 1,
            "title_balance_detail": "Balance Details",
            "label_record_time": "Posting Time:",
            "label_fund_direction": "Direction:",
            "option_all": "All",
            "table_record_time": "Posting Time",
            "table_direction": "Direction",
            "table_amount": "Amount",
            "table_balance": "Account Balance",
            "table_currency": "Currency",
            "table_fund_type": "Fund Type",
            "table_transaction_type": "Transaction Type",
            "value_outbound": "Outbound",
            "value_inbound": "Inbound",
            "value_cash": "Cash",
            "value_fee": "Fee",
            "value_payment_cny": "CNY Payment",
            "value_withdrawal_cny": "CNY Withdrawal",
            "value_collection": "Collection",
            "page_title_transaction_detail": "Transaction Details",
            "tab_deposit": "Collection",
            "tab_withdraw": "Withdraw",
            "tab_payment": "Payment",
            "tab_account_fee": "Account Fee",
            "tab_transfer": "Transfer",
            "label_withdraw_time": "Withdrawal Time: ",
            "label_currency": "Currency:",
            "label_status": "Status: ",
            "label_receiver": "Payee:",
            "button_search": "Search",
            "button_export": "Export",
            "column_order_number": "Withdrawal Order No.",
            "column_withdraw_time": "Withdrawal Time",
            "column_bank_account": "Bank Account",
            "column_receiver_bank": "Receiving Bank",
            "column_fee": "Transaction Fee",
            "column_received_amount": "Amount Received",
            "column_status": "Status ",
            "column_status1": "Status: ",
            "column_action": "Action",
            "label_payment_time": "Payment Time: ",
            "label_account_fee_order_time": "Order Time:",
            "label_account_fee_type": "Fee Type:",
            "label_account_fee_status": "Order Status:",
            "label_account_fee_va_currency": "VA Currency:",
            "label_transfer_time": "Transfer Time: ",
            "label_currency_out": "Currency: ",
            "label_store_name": "Store: ",
            "label_store_name1": "Store",
            "label_sender": "From/To: ",
            "column_payment_order_number": "Payment Order No",
            "column_account_fee_order_no": "Fee Order No",
            "column_account_fee_va_account": "VA Account",
            "column_account_fee_va_currency": "VA Currency",
            "column_account_fee_type": "Fee Type",
            "column_account_fee_amount": "Amount",
            "column_account_fee_status": "Order Status",
            "column_account_fee_repaid_amount": "Repaid Amount",
            "column_account_fee_order_time": "Order Time",
            "column_account_fee_repay_time": "Repayment Time",
            "column_payment_time": "Payment Time",
            "column_payment_amount": "Payment Amount",
            "column_transfer_order_number": "Transfer No",
            "column_transfer_time": "Transfer Time",
            "column_sender": "From",
            "column_receiver": "To:",
            "column_receiver1": "To",
            "column_amount": "Transfer Amount",
            "empty_text": "No transaction records available",
            "fee_type_open": "Account Opening Fee",
            "fee_type_mgmt": "Account Management Fee",
            "status_pending_repayment": "Pending Repayment",
            "status_repaid": "Repaid",
            "label_platform_order": "Platform Order Number",
            "beneficiary_bank": "Beneficiary Bank",
            "beneficiary_account_no": "Beneficiary Account No.",
            "payment_amount_original_currency": "Payment Amount (Original Currency)",
            "refund_fee_wallet_currency": "Refund Fee (Wallet Currency)",
            "refund_net_amount_wallet_currency": "Refund Net Amount (Wallet Currency)",
            "payment_initiated_at": "Payment Initiated At",
            "refund_credited_at": "Refund Credited At",
            "status": "Status",
            "remark_bank_response_code": "Remark / Bank Response Code",
            "payment_initiation_time_from_to": "Payment Initiation Time",
            "refund_credited_time_from_to_optional": "Refund Credited Time",
            "payment_id": "Payment ID",
            "refund_id": "Refund ID",
            "payment_currency_multi_select": "Payment Currency",
            "status_success_processing_failed": "Status",
            "beneficiary_name": "Beneficiary Name",
            "status_desc": {
                "NEW": "Created",
                "PENDING": "Pending",
                "PROCESSING": "Processing",
                "SUCCESS": "Successful",
                "FAIL": "Failed",
                "CANCEL": "Refunded"
            },
            "page_title_batch_detail": "Batch Details",
            "tips_timeRange": "Please select the time range",
            "export_confirm": "Are you sure you want to export?",
            "export_success": "Operation successful, please check the file download status in the upper right corner",
            "export_fail": "Operation failed",
            "export_button": "Export",
            "export_button_confirm": "Confirm",
            "export_button_cancel": "Cancel",
            "see_export_file": "See export file",
            "download_center": "Download Center",
            "no_download_task": "No download task",
            "delete_confirm": "Are you sure you want to delete?",
            "delete_button": "Delete",
            "download_button": "Download",
            "status_unknown": "Unknown status",
            "status_success": "Success",
            "status_processing": "Processing",
            "status_failed": "Failed",
            "start_download_file": "Start downloading file: ",
            "delete_success": "Delete successfully",
            "delete_fail": "Delete failed",
            "button_change_card": "Change card",
            "button_download_receipt": "Download receipt",
            "button_download_receipt_batch": "Batch download receipts",
            "button_select_all_receipt": "Select all downloadable",
            "download_fail": "Download failed",
            "shortcut_today": "Today",
            "shortcut_last_1_month": "Last 1 month",
            "shortcut_last_3_months": "Last 3 months",
            "shortcut_last_6_months": "Last 6 months",
        },
        "kycList": {
            "breadcrumb_realname": "User Center / Real-name Verification",
            "title_realname_auth": "Real-name Verification",
            "button_create_realname_info": "Create New Real-name Info",
            "table_column_nickname": "Account Nickname",
            "table_column_realname_info": "Real-name Info",
            "table_column_create_time": "Creation Time",
            "table_column_business_scene": "Activated Business Scenario",
            "table_column_status": "Status",
            "table_column_error_reason": "Error Reason",
            "table_column_action": "Action",
            "tag_unverified": "Unverified",
            "tag_pending": "Pending",
            "tag_verified": "Verified",
            "tag_rejected": "Rejected",
            "tag_processing": "Processing",
            "button_start_verification": "Verify Now",
            "title_add_account": "Add Account",
            "label_nickname": "Account Nickname",
            "label_registration_location": "Business/Individual Registration Location",
            "placeholder_select_location": "Please Select",
            "label_user_type": "User Type",
            "placeholder_select_user_type": "Please select user type",
            "checkbox_consent_statement": "I consent to provide identity information for real-name verification",
            "button_cancel": "Cancel",
            "button_confirm": "Confirm",
            "option_enterprise": "Enterprise",
            "option_individual": "Individual",
            "doc_hint_enterprise": "Please prepare the following documents:",
            "doc_business_license": "Business License",
            "doc_legal_id": "ID photo of the legal representative (ID card or passport)",
            "doc_agent_id": "ID photo of the authorized agent (ID card or passport) (if you are an authorized agent)",
            "type_joint_stock": "Joint Stock Limited Company",
            "type_individual_business": "Individual Business",
            "type_wholly_owned": "Wholly Owned Enterprise",
            "type_limited_liability": "Limited Liability Company",
            "type_partnership": "Partnership",
            "doc_hint_individual": "Please prepare the following documents:",
            "doc_mainland_id_photos": "Front and back photo of the Mainland Permanent Resident ID/Passport",
            "step_authentication": "Real-name Verification",
            "step_start": "Start",
            "step_basic_info": "Basic Information",
            "step_business_info": "Business Information",
            "section_enterprise_cert": "Enterprise Certificates",
            "label_business_license": "Business License",
            "upload_hint_business_license": "Click to upload Business License + Drag here",
            "upload_format_hint": "Supported formats: jpg, jpeg, png. Max file size: 20MB",
            "label_cert_number": "Certificate Number",
            "label_cert_issuance_date": "Registration Date",
            "label_cert_expiry_date": "Expiry Date",
            "label_cert_long_term": "Long-term",
            "section_basic_info": "Enterprise Basic Information",
            "label_company_name_cn": "Chinese Company Name",
            "placeholder_company_name_cn": "Please enter Chinese company name",
            "label_company_name_en": "English Company Name",
            "placeholder_company_name_en": "Please enter English company name, or Pinyin if not available",
            "label_registered_country_area": "Registration Country/Region",
            "label_registered_province_city": "Registration City",
            "label_registered_address": "Registered Address",
            "placeholder_registered_address": "Please enter registered address",
            "label_operational_same_as_registered": "Is the business address the same as the registered address?",
            "option_yes": "Yes",
            "option_no": "No",
            "label_operational_country_area": "Business Address Country/Region",
            "label_operational_province_city": "Business Address City",
            "label_operational_address": "Business Address",
            "placeholder_operational_address": "Please enter business address",
            "section_attachments": "Attachments",
            "label_authorization_doc": "Authorization Document (Optional)",
            "label_other_doc": "Other Attachments (Optional)",
            "upload_hint_general": "Click to upload Attachments + Drag here",
            "upload_format_hint_general": "Supported formats: jpg, jpeg, png, pdf. Max file size: 20MB",
            "section_legal_person_info": "Legal Representative Information",
            "label_legal_nationality": "Nationality of Legal Representative",
            "label_legal_last_name": "Surname of Legal Representative",
            "label_legal_first_name": "Given Name of Legal Representative",
            "label_legal_id_type": "ID Type",
            "label_legal_id_number": "ID Number",
            "label_id_number": "ID Number",
            "label_legal_id_expiry": "ID Validity",
            "label_legal_id_long_term": "Long-term",
            "label_legal_birthdate": "Birthdate of Legal Representative",
            "label_legal_country_region": "Nationality/Region",
            "label_legal_city": "City",
            "section_ubo_info": "Ultimate Beneficial Owner (UBO) Information",
            "hint_ubo_info": "Ultimate Beneficial Owner Information (All individuals holding ≥25% shares or control. Enterprises must provide at least natural person information.)",
            "label_ubo_nationality": "Nationality of UBO",
            "label_ubo_id_type": "ID Type",
            "label_ubo_id_number": "ID Number",
            "label_ubo_id_expiry": "ID Validity",
            "label_ubo_id_long_term": "Long-term",
            "label_ubo_birthdate": "Birthdate of UBO",
            "label_ubo_last_name": "Surname of UBO",
            "label_ubo_first_name": "Given Name of UBO",
            "label_ubo_country_region": "Nationality/Region",
            "label_ubo_city": "City",
            "section_agent_info": "Authorized Agent Information",
            "radio_submitter_role": "Identity of Information Submitter",
            "option_legal_representative": "Legal Representative",
            "option_authorized_agent": "Authorized Agent",
            "label_ubo2_nationality": "Nationality of UBO",
            "label_ubo2_id_type": "ID Type",
            "label_ubo2_id_number": "ID Number",
            "label_ubo2_id_expiry": "ID Validity",
            "label_ubo2_id_long_term": "Long-term",
            "label_ubo2_birthdate": "Birthdate of UBO",
            "label_ubo2_last_name": "Surname of UBO",
            "label_ubo2_first_name": "Given Name of UBO",
            "label_ubo2_country_region": "Nationality/Region",
            "label_ubo2_city": "City",
            "label_agent_nationality": "Nationality of Agent",
            "label_agent_id_type": "ID Type",
            "label_agent_id_number": "ID Number",
            "label_agent_id_expiry": "ID Validity",
            "label_agent_id_long_term": "Long-term",
            "label_agent_name": "Name of Agent",
            "label_agent_birthdate": "Birthdate of Agent",
            "label_agent_country_region": "Nationality/Region",
            "label_agent_city": "City",
            "section_agent_doc_upload": "Power of Attorney Upload",
            "upload_hint_power_of_attorney": "Click to upload Power of Attorney + Drag here",
            "upload_format_hint_pdf": "Supported formats: jpg, jpeg, png, pdf. Max file size: 20MB",
            "button_prev_step": "Previous Step",
            "button_next_submit": "Submit",
            "modal_title_success": "Submission Successful",
            "step_register": "Registration",
            "step_submit_review": "Submit for Review (Pending)",
            "step_account_activated": "Account Activation",
            "status_success": "Submission Successful",
            "tip_review_notice": "We will review your information. Please wait patiently. The result will be notified via both the platform and email. Please check in a timely manner!",
            "button_back_home": "Back to Home",
            "button_update_document": "Update Document",
            "Verification_Status": "Verification Status",
            "tag_audit_success": "Audit Success",
            "tag_audit_failed": "Audit Failed",
            "tag_audit_processing": "Audit Processing",
            "tag_audit_not_audit": "Not Audit",
            "no_need_to_upload_document": "The updated document is under review"
        },
        withdraw: {
            "page_title": "Withdrawal",
            "title_withdraw_now": "Withdraw Now",
            "label_select_currency": "Please select withdrawal currency:",
            "option_cnh": "Offshore RMB / CNH",
            "option_other": "Other",
            "label_select_platform": "Please select withdrawal platform:",
            "label_total_available": "Total Withdrawable Amount:",
            "table_column_store_name": "Store Name",
            "table_column_balance": "Balance",
            "table_column_withdraw_amount": "Withdrawal Amount",
            "placeholder_amount": "Enter amount",
            "placeholder_enter_amount": "Please select this row before entering amount",
            "button_select_all": "Select All",
            "label_total_withdraw_amount": "Total Withdrawal Amount:",
            "label_total_withdraw_amount1": "Total Withdrawable Amount:",
            "button_next_step": "Next Step",
            "breadcrumb_withdraw_select_account": "Home / My Account / Withdraw Now",
            "title_select_account": "Please select your receiving account",
            "button_add_new_account": "Add New Receiving Account",
            "table_column_select": "Select",
            "table_column_bank_name": "Bank Name",
            "table_column_bank_account_name": "Account Name",
            "table_column_account_type": "Account Type",
            "table_column_bank_location": "Account Location",
            "table_column_currency": "Account Currency",
            "table_column_account_number": "Bank Account Number",
            "label_withdraw_amount": "Withdrawal Amount:",
            "label_total_credit_amount": "Forex Quota:",
            "label_total_fee": "Total Fees:",
            "label_exchange_rate": "Exchange Rate:",
            "label_estimated_amount": "Estimated Amount:",
            "label_security_code": "Security Verification:",
            "placeholder_enter_code": "Enter Verification Code",
            "button_get_code": "Get Verification Code",
            "link_resend_email_code": "Switch to Email Verification",
            "link_resend_sms_code": "Switch to SMS Verification",
            "note_verification_tip": "For account security, please complete verification to proceed. Code will be send to",
            "button_back": "Back",
            "button_confirm_withdraw": "Confirm Withdrawal"
        },
        shopHolder: {
            "holdType": "Holder Type",
            "holdType_personal": "Personal",
            "holdType_company": "Company",
            "add_page_title": "Add Shop Holder",
            "detail_page_title": "Shop Holder Details",
            "label_holder_type": "Holder Type",
            "holder_type_personal": "Personal",
            "holder_type_enterprise": "Enterprise",
            "label_id_number": "ID No.",
            "label_country": "Country/Region",
            "label_city": "City",
            "label_address": "Address",
            "label_address_en": "Address in English",
            "label_id_front": "ID Card (Portrait Side)",
            "label_id_photo": "ID Photo",
            "label_id_photo_hk": "Hong Kong Permanent Identity Card",
            "label_id_photo_other": "Passport / ID Card / Driver's License",
            "label_id_back": "ID Card (Emblem Side)",
            "label_company_name": "Company Name",
            "label_company_name_en": "Company Name in English",
            "label_registration_no": "Certification No.",
            "cert_no_tip_cn": "Please enter the Unified Social Credit Code.",
            "cert_no_tip_non_cn": "Please enter the overseas company ID (e.g., registration number).",
            "label_business_license": "Business License",
            "hint_select_country_for_docs": "Please select country/region before uploading documents",
            "hint_formats_image_pdf": "Supported formats: jpg, jpeg, png, pdf",
            "hint_formats_other_materials": "Supported formats: jpg, jpeg, png, pdf, zip, rar",
            "label_reject_reason": "Reject Reason",
            "button_submit_apply": "Submit Application",
            "button_back": "Back",
            "button_view_file": "View",
            "button_download_file": "Download",
            "label_last_name": "Last Name",
            "label_last_name_en": "Last Name in English",
            "label_first_name": "First Name",
            "label_first_name_en": "First Name in English",
            "label_status": "Status",
            "button_search": "Search",
            "button_reset": "Reset",
            "button_add": "Add Holder",
            "button_view_detail": "View Details",
            "button_confirm": "Confirm",
            "drawer_detail_title": "Holder Details",
            "dialog_add_title": "Add Holder",
            "message_add_success": "Added successfully",
            "column_last_name": "Last Name",
            "column_first_name": "First Name",
            "rule_no_chinese": "Chinese characters are not allowed",
            "column_email": "Email",
            "column_status": "Status",
            "column_create_time": "Created Time",
            "column_remark": "Remark",
            "status_pending": "Pending",
            "status_normal": "Normal",
            "status_rejected": "Rejected",
            "button_edit": "Edit",
        },
        addWithdrawAccount: {
            "breadcrumb_add_withdraw_account": "Home / My Account / Add Withdrawal Account",
            "title_add_new_account": "Add New Withdrawal Bank Account",
            "note_security_reminder": "Bank account info must match verified identity",
            "note_account_match_warning": "Recipient name must match bank account holder, otherwise approval may be rejected or delayed",
            "note": "note",
            "note_doc_warning": "Use Tier 1 bank accounts to avoid withdrawal issues",
            "label_account_type": "Account Type",
            "option_corporate": "Corporate",
            "option_personal": "Personal",
            "label_bank_country": "Bank Country/Region",
            "label_bank_name": "Bank Name",
            "label_bank_branch": "Bank Branch Name",
            "label_account_name": "Account Holder Name",
            "label_swift_code": "SWIFT/BIC Code",
            "label_bank_account_number": "Bank Account Number",
            "label_bank_iban": "IBAN",
            "label_bank_phone_number": "Bank Reserved Phone Number",
            "label_bank_address": "Bank Branch Address",
            "label_beneficiary_city": "Beneficiary City",
            "label_beneficiary_address": "Beneficiary Address",
            "label_beneficiary_postal_code": "Beneficiary Postal Code",
            "button_back": "Back",
            "button_submit": "Submit",
            "bank_branch_detail": "Bank Branch Details",
            "label_is_legal": "Is legal person information required in account name?",
            "label_is_legal_yes": "Yes",
            "label_is_legal_no": "No",
            "label_transfer_method": "Transfer Method",
            "option_local_transfer": "Local Transfer",
            "option_swift_transfer": "SWIFT Transfer",
            "tip_local_transfer": "Local bank transfer method, arrival time 0-1 business day",
            "tip_swift_transfer": "International bank transfer method, arrival time 0-3 business days",
            "label_bank_code": "Bank Code",
            "rule_select_payout_method": "Please select transfer method",
            "rule_select_common": "Please select",
            "rule_input_card_no": "Please enter bank account number",
            "rule_card_no_pattern": "Bank account number cannot contain special characters",
            "rule_input_tel": "Please enter phone number",
            "rule_tel_pattern": "Digits only",
            "rule_input_bank_name": "Please enter bank name",
            "rule_input_swift": "Please enter SWIFT/BIC code",
            "rule_swift_pattern": "Invalid SWIFT format",
            "rule_input_branch": "Please enter detailed branch name",
            "rule_input_bank_address": "Please enter bank branch address",
            "rule_input_payee_city": "Please enter city",
            "rule_input_bank_code_3digits": "Please enter 3 digits",
            "rule_input_postal_code": "Please enter postal code",
            "rule_postal_code_pattern": "Only numbers or English letters are allowed",
            "card_bin_confirm_title": "Please check the recipient’s card number",
            "card_bin_confirm_desc": "The card number you entered does not match the selected bank. Please check that the card number is correct.",
            "card_bin_confirm_selected_bank": "Selected bank",
            "card_bin_confirm_card_no": "Card number",
            "card_bin_confirm_tip": "If the bank and card number are correct, you may proceed with submission. The card will be reviewed and can only be used once approved.",
            "card_bin_confirm_back": "Go back and edit",
            "card_bin_confirm_submit": "Confirm and submit"
        },
        myShop: {
            "breadcrumb_my_store": "Home / Collections / My Stores",
            "title_my_store": "My Stores",
            "label_store_name": "Store Name:",
            "label_account_number": "Account:",
            "label_platform": "Platform:",
            "label_pending_settlement": "Pending Settlement Funds",
            "label_withdrawable_balance": "Withdrawable Balance",
            "currency_cnh": "CNH 0.00",
            "breadcrumb_pending_details": "Home / Collections / Pending Transactions",
            "title_pending_details": "Pending Transactions",
            "table_column_collection_time": "Collection Time",
            "table_column_platform": "Platform",
            "table_column_store_name": "Store Name",
            "table_column_order_number": "Platform Order No.",
            "table_column_total_amount": "Collection Amount",
            "table_column_pending_amount": "Pending Amount",
            "table_column_payer": "Payer",
            "table_column_audit_remark": "Audit Remark",
            "table_column_actions": "Actions",
            "table_no_data": "No Data",
            "modal_title_upload_trade_doc": "Upload Trade Documents",
            "label_platform1": "Platform",
            "label_store": "Store",
            "label_upload_order": "Upload Trade Documents",
            "label_upload_withdraw_screenshot": "Upload Withdrawal Screenshot",
            "text_upload_requirement": "File size ≤10MB. Supported formats: xlsx, csv, zip, rar",
            "link_template_download": "Download Template",
            "button_upload_order_doc": " \"Order File\"",
            "note_fill_and_upload": "Please download the template, fill it out, and upload",
            "button_upload_other_doc": " \"Contracts, Invoices, Logistics Docs, Customs Declarations\"",
            "button_upload_withdraw_screenshot": " \"Platform Withdrawal Screenshot (including VA account)\"",
            "note_upload_other_doc": "Upload relevant contracts, invoices, or settlement documents between sellers",
            "validation_upload_material": "Please upload supporting material",
            "validation_upload_withdraw_screenshot": "Please upload the withdrawal screenshot",
            "modal_title_upload_trade_material": "Upload Transaction Materials",
            "section_store_info": "Store Information",
            "section_material_info": "Material Information",
            "label_store_name_required": "Store Name",
            "label_store_url": "Store URL",
            "label_currency": "Currency",
            "label_gmv_month": "Estimated Monthly Turnover",
            "label_gmv_year": "Estimated Annual Turnover",
            "label_product_category": "Business Scope",
            "label_store_owner": "Store Holder",
            "label_shop_screenshot": "Store Screenshot",
            "label_withdraw_screenshot": "Withdrawal Screenshot",
            "label_other_attachment": "Other Attachments (Optional)",
            "upload_suffix_other_attachment": "Other Attachments",
            "placeholder_input": "Please enter",
            "placeholder_store_name": "Please select store name",
            "placeholder_gmv_month": "Monthly volume USD 100k (inclusive) - 300k",
            "upload_suffix_shop_screenshot_with_url": "\"Store Screenshot (including URL)\"",
            "upload_suffix_withdraw_screenshot_with_va": "\"Platform Withdrawal Screenshot (including VA account)\"",
            "action_add_store": "Add Store",
            "action_edit_store": "Edit Store",
            "action_cancel_store_edit": "Cancel",
            "action_save_store": "Save Store",
            "hint_store_select": "Select an existing store or add a new store before submitting these transaction materials",
            "validation_platform": "Please select a platform",
            "validation_store_name": "Please select store name",
            "validation_store_url": "Please enter store URL",
            "validation_currency": "Please enter currency",
            "validation_gmv_month": "Please enter estimated monthly turnover",
            "validation_gmv_year": "Please enter estimated annual turnover",
            "validation_product_category": "Please select business scope",
            "validation_store_owner": "Please enter store holder",
            "validation_upload_shop_screenshot": "Please upload store screenshot",
            "validation_save_store_first": "Please save the store information first",
            "validation_missing_kyb_id": "KYB ID is missing, so the branch list cannot be queried",
            "message_store_list_failed": "Failed to query branch list. Please try again later.",
            "message_store_save_success": "Store saved successfully",
            "message_store_save_failed": "Failed to save store. Please try again later.",
            "modal_title_supplement_material": "Supplement Materials",
            "text_transaction": "Transaction",
            "text_supplement_subtitle": "Please complete branch information and upload materials",
            "section_branch_info": "Branch Information",
            "label_select_branch": "Select Branch",
            "placeholder_select_branch": "Please select a branch",
            "action_add_branch": "Add Branch",
            "action_confirm_add_branch": "Confirm Add",
            "placeholder_branch_name": "Branch Name",
            "placeholder_branch_code": "Branch Code",
            "placeholder_branch_region": "Region",
            "placeholder_branch_contact": "Contact",
            "placeholder_branch_phone": "Phone",
            "placeholder_branch_address": "Detailed Address",
            "section_branch_attrs": "Branch Attributes",
            "status_branch_editable": "Editable",
            "status_branch_locked": "Locked",
            "hint_branch_select": "You can switch branches at any time. Attribute editability depends on branch status.",
            "hint_branch_editable": "The current branch allows editing attributes except branch name.",
            "hint_branch_locked": "The current branch is locked, so attributes cannot be edited. You can still select another branch.",
            "section_supplement_material": "Supplement Materials",
            "label_material_type": "Material Type",
            "placeholder_select": "Please select",
            "material_invoice": "Invoice / Receipt",
            "material_contract": "Contract / Agreement",
            "material_id": "Identity Document",
            "material_bank": "Bank Statement",
            "material_other": "Other",
            "label_supplement_remark": "Supplement Notes",
            "placeholder_supplement_remark": "Briefly describe the material purpose or review focus",
            "label_upload_attachment": "Upload Attachment",
            "button_upload_supplement_material": "Upload Supplement Materials",
            "validation_select_branch": "Please select a branch",
            "validation_select_material_type": "Please select a material type",
            "validation_branch_name": "Please enter branch name",
            "validation_branch_name_exists": "Branch name already exists",
            "validation_upload_supplement_material": "Please upload supplement materials",
            "message_supplement_check_failed": "Supplement material check failed. Please try again later.",
            "text_current_store": "Current Store",
            "button_submit_doc": "Confirm",
            "button_cancel_upload": "Cancel",
            "breadcrumb_pending_upload": "Home / Collections / Pending Transactions",
            "title_pending_upload": "Pending Transactions",
            "column_collection_time": "Collection Time",
            "column_platform": "Platform",
            "column_store_name": "Store Name",
            "column_order_number": "Platform Order No.",
            "column_amount": "Pending Amount",
            "column_currency": "Pending Currency",
            "column_payer": "Payer",
            "column_action": "Action",
            "action_pending_review": "Pending Review",
            "action_upload": "Upload",
            "upFile_tis1": 'Please make sure that each value in the Excel sheet is in text format.',
            "label_account_info": "My Account",


            "form_label_1": "Account Holder Name",
            "form_label_2": "Account Number",
            "form_label_3": "Currency",
            "form_label_4": "Payment Type",
            "form_label_5": "Bank Name",
            "form_label_6": "Bank Country",
            "form_label_7": "Bank Address",
            "form_label_8": "Routing Code",
            "form_label_9": "Routing Code Type",
            "label_account_status": "Account Status",
            "table_column_fee": "Fee",
            "table_column_exchange_rate": "Collection Rate",
        },
        shopBinding: {
            "title_bind_account": "Bind Infinia Account",
            "modal_title_confirm_info": "Confirm Information",
            "text_confirm_id": "Please confirm the business ID number used on the e-commerce platform:",
            "text_change_id_notice": "If you need to use a different ID, please update it in the e-commerce platform backend and reinitiate account binding.",
            "button_cancel": "Cancel",
            "button_confirm": "Confirm",
            "button_bind_now": "Confirm Bind",
            "title_pre_bind_submitted": "Account Pre-Binding Submitted!",
            "text_pre_bind_notice": "We will prioritize processing within 1 business day. Please pay attention to related email or SMS notifications.",
            "text_auto_assign_notice": "Once your identity verification passes and info matches, we will assign a collection account and enable access/payment services automatically.",
            "button_back_home": "Return to Home",
            "msg_binding_done": "This store has been successfully bound. Please return to the e-commerce platform for confirmation",
            "button_return_platform": "Return to Platform",
            "button_return_home": "Return to Home",
            "message_loading": 'Page is loading, please wait patiently'
        },
        userSettings: {
            "menu_user_settings": "User Settings",
            "menu_account_manager": "Dedicated Business Manager",
            "section_entity_info": "Entity Information",
            "section_user_info": "User Information",
            "label_entity_name": "Entity Name",
            "label_account_nickname": "Account Nickname",
            "label_merchant_no": "Merchant No",
            "label_bound_phone": "Bound Phone",
            "label_bound_email": "Bound Email",
            "label_login_password": "Login Password",
            "button_edit": "Edit",
            "modal_bind_email_title": "Bind Email",
            "label_email": "Email",
            "button_cancel": "Cancel",
            "button_confirm": "Confirm",
            "modal_reset_password_title": "Reset Login Password",
            "label_current_password": "Current Password",
            "label_new_password": "New Password",
            "label_confirm_password": "Confirm Password",
            "label_verification_code": "Verification Code",
            "button_send_code": "Send Verification Code",
            "notification_code_sent": "Verification code will be sent to",
            "page_title_account_manager": "Dedicated Account Manager",
            "label_customer_hotline": "Customer Hotline",
            "label_contact_method": "Contact Number",
            "label_biz_manager_wechat": "Business Manager WeChat",
            "label_customer_wechat": "Account Manager WeChat",
            "step_0_5_status": "To Complete",
            "label_identity_status": "The current user is not verified",
            "prompt_nickname_title": "Please enter nickname",
            "prompt_nickname_tip": "Notice",
            "prompt_nickname_error": "Invalid nickname format",
            "message_nickname_success": "Updated successfully",
            "message_nickname_fail": "Update failed",
            "validation_input_new_password": "Please enter new password",
            "validation_new_password_format_error": "Invalid password format",
            "validation_input_confirm_password": "Please enter confirm password",
            "validation_confirm_password_format_error": "Invalid confirm password format",
            "validation_confirm_password_not_equal": "Confirm password must match new password",
            "validation_input_sms_code": "Please enter verification code",
            "validation_input_current_password": "Please enter current password",
            "validation_get_code_first": "Please get verification code first",
            "message_reset_success": "Password updated successfully",
            "message_reset_fail": "Submit failed",
            "validation_input_new_password_placeholder": "Please enter new password",
            "validation_input_confirm_password_placeholder": "Please enter confirm password",
            "message_get_user_info_fail": "Failed to get user information",
        },
        accountHolder: {
            "page_title": "Account Holder Management",
            "form_label_name": "Name",
            "form_placeholder_name": "Please enter name",
            "form_label_nationality": "Nationality",
            "form_placeholder_nationality": "Please select nationality",
            "form_label_phone": "Phone Number",
            "form_hint_phone": "Registered phone number (non-editable, with prefix)",
            "form_label_id_number": "ID Number",
            "form_label_passport_number": "ID Number",
            "form_placeholder_id_number": "Please enter ID number",
            "form_placeholder_passport_number": "Please enter ID number",
            "form_hint_id_number": "If nationality is China, ID card is required; otherwise, any valid ID is acceptable",
            "form_label_verify_code": "Image Verification Code",
            "form_placeholder_verify_code": "Please enter image verification code",
            "button_submit": "Submit",
            "china": "China",
            "validation_name_required": "Please enter name",
            "validation_nationality_required": "Please select nationality",
            "validation_id_required": "Please enter ID number",
            "validation_id_format_invalid": "Please enter a valid 18-digit ID card number",
            "validation_passport_required": "Please enter ID number",
            "validation_id_china_required": "ID card is required for Chinese nationality",
            "validation_verify_code_required": "Please enter verification code",
            "modal_guarantee_title": "Guarantee Letter on Confirmation of Mobile Number Ownership",
            "modal_content_intro": "I [Account Holder Name],[holding ID Card/Passport][Document Number] hereby make the following confirmations and guarantees to PayEase Technology (Hong Kong) Limited and the INFINIA platform:",
            "modal_content_item1": "1. I am the legal and sole holder of the mobile number [Mobile Number] (hereinafter referred to as 'the Number').",
            "modal_content_item2": "2. I have complete and exclusive control over the Number and the SIM card bound to it.",
            "modal_content_item3_title": "3. I take full responsibility for all activities conducted using the Number, including but not limited to receiving SMS, phone calls, and two-factor authentication messages related to my INFINIA platform account.",
            "modal_content_item3_content": "I take full responsibility for all activities conducted using the Number, including but not limited to receiving SMS, phone calls, and two-factor authentication messages related to my INFINIA platform account.",
            "modal_content_item4": "4. All the information provided above is true and accurate. I acknowledge that deliberately providing false information may result in my account being suspended or closed, and I will bear corresponding legal responsibilities.",
            "modal_content_item5": "5. I agree that PayEase Technology (Hong Kong) Limited and the INFINIA platform may use the Number for the purposes of identity verification, communication, and account security.",
            "modal_content_item6": "6. I hereby consent to the processing of my personal data, including mobile number, ID document copies, personal images, and other relevant data, provided by PayEase Technology (Hong Kong) Limited and the INFINIA platform for the purpose of identity verification, in accordance with the terms of the platform.",
            "modal_checkbox_item1": "I take full responsibility for all activities conducted using the Number, including but not limited to receiving SMS, phone calls, and two-factor authentication messages related to my INFINIA platform account.",
            "modal_checkbox_item2": "All the information provided above is true and accurate. I acknowledge that deliberately providing false information may result in my account being suspended or closed, and I will bear corresponding legal responsibilities.",
            "modal_checkbox_item3": "I agree that PayEase Technology (Hong Kong) Limited and the INFINIA platform may use the Number for the purposes of identity verification, communication, and account security.",
            "modal_checkbox_item4": "I hereby consent to the processing of my personal data, including mobile number, ID document copies, personal images, and other relevant data, provided by PayEase Technology (Hong Kong) Limited and the INFINIA platform for the purpose of identity verification, in accordance with the terms of the platform.",
            "modal_button_confirm": "Confirm",
            "modal_button_cancel": "Cancel",
            "confirm_submit_title": "Confirm",
            "confirm_submit_tip": "The name and ID number must match the registered mobile phone number.",
            "message_code_sent": "Verification code sent",
            "message_submit_success": "Submitted successfully",
            "message_all_checkboxes_required": "Please check all confirmation items",
            "description_text": "Please complete the account holder information so that we can better serve you. If you are not a mainland China national, you need to confirm mobile number ownership."
        },
        subAccount: {
            "menu_sub_account_manager": "Sub Account Management",
            "page_title": "Sub Account Management",
            "page_desc": "Sub accounts belong to the current merchant admin account, with configurable KYC visibility and action scope.",
            "button_add": "Add Sub Account",
            "button_search": "Search",
            "button_reset": "Reset",
            "button_cancel": "Cancel",
            "button_confirm": "Confirm",
            "button_save": "Save",
            "filter_keyword": "Mobile / Email",
            "filter_role": "Role",
            "filter_status": "Status",
            "filter_entity": "KYC Entity",
            "placeholder_keyword": "Please enter mobile or email",
            "placeholder_role": "All",
            "placeholder_status": "All",
            "placeholder_entity": "All",
            "column_user_name": "User Name",
            "column_name": "Name",
            "column_mobile": "Mobile",
            "column_email": "Email",
            "column_role": "Role",
            "column_scene": "Scenario",
            "column_entities": "Operable KYC Entities",
            "column_status": "Status",
            "column_last_login": "Last Login",
            "column_action": "Action",
            "action_edit": "Edit",
            "action_enable": "Enable",
            "action_disable": "Disable",
            "footer_tip": "Note: Sub accounts belong to the merchant admin account, and KYC entities control visibility and operation scope.",
            "drawer_create_title": "Create Sub Account",
            "drawer_edit_title": "Edit Sub Account",
            "section_basic": "Basic Information",
            "section_permission": "Permission Settings",
            "form_user_name": "User Name",
            "form_name": "Name",
            "form_mobile": "Mobile",
            "form_email": "Email",
            "form_password": "Initial Password",
            "form_role": "Role",
            "form_scene": "Scenario Permission",
            "form_entities": "KYC Entities",
            "form_status": "Status",
            "placeholder_user_name": "Please enter user name (letters and numbers only)",
            "placeholder_name": "Please enter name",
            "placeholder_mobile": "Please enter mobile",
            "placeholder_email": "Please enter email",
            "placeholder_password": "Please enter initial password",
            "placeholder_scene": "Scenario permission",
            "placeholder_entity_select": "Please select at least one KYC entity",
            "role_operator": "Operator",
            "role_auditor": "Auditor",
            "status_enabled": "Enabled",
            "status_disabled": "Disabled",
            "rule_title": "Validation Rules",
            "rule_1": "Mobile number and email should be unique.",
            "rule_2": "Only one role can be selected.",
            "rule_3": "Select at least one KYC entity.",
            "rule_4": "Disabled accounts cannot log in.",
            "rule_5": "Role or KYC permission changes should be logged.",
            "validation_user_name": "Please enter user name",
            "validation_user_name_format": "User name can only contain letters and numbers",
            "validation_name": "Please enter name",
            "validation_mobile": "Please enter mobile",
            "validation_email": "Please enter email",
            "validation_email_invalid": "Please enter a valid email address",
            "validation_password": "Please enter initial password",
            "validation_password_length": "Password length must be 6-32 characters",
            "validation_role": "Please select a role",
            "validation_entity": "Please select at least one KYC entity",
            "message_save_success": "Saved successfully",
            "message_status_success": "Status updated successfully",
            "confirm_title": "Confirm",
            "confirm_status": "Are you sure you want to {action} this sub account?"
        },
        batchDetail: {
            "page_title_batch_detail": "Batch Details",
            "label_payment_time": "Payment Time",
            "label_status": "Status",
            "button_search": "Search",
            "column_batch_number": "Batch Number",
            "column_time": "Time",
            "column_uploaded_file": "Uploaded File",
            "column_store_name": "Store Name",
            "column_amount": "Amount",
            "column_total_count": "Total",
            "column_success_count": "Success Count",
            "column_failure_count": "Failure Count",
            "column_status": "Status",
            "column_details": "Details",
            "column_action": "Action",
            "summary_total": "Total",
            "action_detail": "Details",
            "action_approve": "Approve",
            "action_reject": "Reject",
            "action_input_captcha": "Enter Verification Code",
            "action_send_captcha": "Send Verification Code",
            "dialog_captcha_title": "Security Verification",
            "dialog_detail_title": "Payment Details",
            "dialog_approve_title": "Approve Batch",
            "dialog_reject_title": "Reject Batch",
            "label_captcha_code": "Verification Code",
            "label_email_code": "Email Verification Code",
            "label_current_balance": "Current Entity Balance",
            "label_current_shop_balance": "Current Store Balance",
            "label_credit_total_amount": "Store Available FX Quota",
            "label_kyc_entity": "KYC Entity",
            "label_batch_total_amount": "Total Payment Amount",
            "label_batch_total_count": "Total Payment Count",
            "button_send_captcha": "Send Verification Code",
            "button_confirm_submit": "Confirm",
            "button_confirm_approve": "Confirm Approve",
            "button_confirm_reject": "Confirm Reject",
            "tip_captcha_valid_time": "The verification code is valid for 5 minutes. Please submit in time.",
            "placeholder_email_code": "Please enter verification code",
            "reject_confirm_text": "Confirm rejection?",
            "warning_enter_captcha": "Please enter verification code",
            "warning_enter_reject_remark": "Please enter remark",
            "detail_column_business_type": "Business Type",
            "detail_column_payment_number": "Payment No.",
            "detail_column_payment_time": "Payment Time",
            "detail_column_amount": "Payment Amount",
            "detail_column_payer": "Payer",
            "detail_column_receive_bank": "Receiving Bank",
            "detail_column_fee": "Transaction Fee",
            "detail_column_received_amount": "Received Amount",
            "detail_column_remark": "Remark",
            "status_success": "Success",
            "status_all": "All",
            "status_new": "New",
            "status_pending": "Pending",
            "status_pass": "Approved",
            "status_reject": "Audit Rejected",
            "status_processing": "Processing",
            "message_approve_success": "Approved successfully",
            "message_reject_success": "Rejected successfully",
            "status_success1": "Successful",
            "status_failed": "Failed",
            "status_partial_success": "Partially Successful",
            "status_complete": "Complete",
            "status_expired": "Expired"
        },
        "commonStatus": {
            "option_status_new": "New",
            "option_status_pending": "Pending",
            "option_status_processing": "Processing",
            "option_status_success": "Success",
            "option_status_failed": "Failed",
            "option_status_refunded": "Refunded",
            "option_status_partial_success": "Partially Successful",
            "option_currency_hkd": "HKD",
            "option_currency_eur": "EUR",
            "option_currency_gbp": "GBP",
            "option_currency_usd": "USD",
            "option_currency_cnh": "CNH",
            "option_currency_rub": "RUB",
            "option_fund_direction_all": "All",
            "option_fund_direction_income": "Funds In",
            "option_fund_direction_expense": "Funds Out",
            "dropdown_status_new": "New",
            "button_select_all": "Select All",
            "button_deselect_all": "Deselect All"
        },
        "withdrawAccount": {
            "page_title_withdraw_account_list": "Withdrawal Account List",
            "label_bank_name": "Bank Name",
            "label_bank_account_name": "Account Name",
            "label_account_type": "Account Type",
            "label_bank_location": "Bank Location",
            "label_currency": "Account Currency",
            "label_bank_account_number": "Bank Account Number",
            "button_add_beneficiary": "Add Beneficiary",
            "button_search": "Search",
            "column_bank_name": "Bank Name",
            "column_account_name": "Account Name",
            "column_account_type": "Account Type",
            "column_bank_location": "Bank Location",
            "column_currency": "Account Currency",
            "column_account_number": "Bank Account Number",
            "column_status": "Status",
            "column_remarks": "Remarks",
            "status_new": "Initial",
            "status_pending": "Pending Review",
            "status_approved": "Approved",
            "status_rejected": "Rejected",
            "remark_rejected": "This payee bank account cannot be added at the moment. Please use another payee account and submit again.",
            "column_action": "Action",
            "action_delete": "Delete",
            "option_corporate": "Corporate",
            "option_personal": "Personal",
            "breadcrumb_path_account": "Home/My Account/Withdrawal Account",
        },
    },
    public: {
        solgan1: 'Connect Globally Pay Effortlessly',
        solgan2: 'A Global Payments Leader Driving Innovation',
        infoSave: 'Save',
        OnlineService: 'Online Service',
        next: 'Next step',
        pleaseEnter: 'Please enter ',
        pleaseSelect: 'Please select ',
        unit_ten_thousand: '10k',
        unit_ten_thousand1: '10k',
        retry: 'Retry',
        retryAgain: 'Please try again',
        loginSuccess: 'Log in successfully',
        verificationcodesent: 'verification code has been sent',
        backHome: 'Home',
        filter: 'Filter',
        status: 'Status',
        downloadList: 'Download List',
        noData: 'No matches',
        reset: 'Reset',
        apply: 'Apply',
        startDate: 'From',
        endDate: 'to',
        actions: 'Actions',
        jilufilter: 'Record filter',
        Logout: 'Logout',
        nextStep: 'Next step',
        edit: 'Edit',
        logoutSuccess: 'Log out successfully',
        Globalacquiring: 'Global acquiring',
        Marketplacepayout: 'Global Collection',
        Marketplacepayout2: 'Global Disbursement',
        Aboutus: 'About us',
        submit: 'Confirm',
        querying: 'querying',
        back: 'Back',
        Contactus: 'Contact us',
        backTo: 'Back to ',
        start: 'Verify Now',
        deleteFile: 'Delete this file?',
        Uploading: 'Uploading',
        all: 'ALL',
        Accountlist: 'Account list',
        Transactionlist: 'Transaction list',
        Changemailbox: 'Change binding email',
        ChangePhone: 'Change binding phone',
        Mobileverification: 'Mobile phone verification',
        Returncenter: 'Return to security center',
        Useemailauthentication: 'Use email verification',
        Verifysent: 'Validation email has been sent',
        notreceivedyoucan: 'If you have not received the email, you can',
        Changephonenumber: 'Change email / mobile phone number',
        reregister: 'Re-register',
        or: 'or',
        delivered1: 'You are modifying your payment password and the activation email has been delivered',
        delivered2: 'You are setting the payment password, and the activation mail has been delivered',
        delivered3: 'You are modifying your login password. The activation email has been delivered',
        delivered4: 'You are changing the binding mailbox, and the activation mail has been delivered',
        delivered5: 'You are replacing the binding mobile phone, and the activation mail has been delivered',
        delivered6: 'You are resetting your login password. The activation message has been delivered',
        delivered7: '',
        delivered8: 'You are in the process of resetting your payment password. The system verifies that the email has been sent to',
        Sendwhile: 'Send the mail, and please wait for a while...',
        Emailsuccessfully: 'Email sent successfully',
        Emailverification: 'Email verification',
        Pleaseverificationemail: 'Please enter verification email',
        Verifyphone: 'Verify with mobile phone',
        enteraddress: 'Please enter the verification email address',
        Accountsuccessfully: 'Account password set successfully',
        Thankregistering: 'Thank you for registering to use the ipaylinks collection service. You can log in by email or mobile phone number',
        Accountfailed: 'Account password setting failed',
        Startnow: "Start now",
        uploadFollowFile: 'Please upload the following file',
        uploadClick: 'Click upload file',
        supportJPG: 'Support no more than 10 files, a total of no more than 20MB, JPG, PNG, JPEG, BMP, PDF, zip, rar format files',
        supportJPG2: 'Support no more than 10 files, a total of no more than 20MB, PNG, JPEG, PDF format files',
        uploadSuccess: 'Uploaded successfully',
        recharge: 'Recharge',
        collection: 'Collection',
        noArea: 'No area',
        telPhone: 'Contact',
        complete: 'Complete',
        close: 'Close',
        download: 'Download',
        switchtoversion: 'Switch to new version',
        autoLogin: 'login...',
        tradeManager: "Transactions",
        Resendcaptcha: 'Resend Captcha',
        systemError: 'System Error',
        confirm: 'Confirm',
        cancel: 'Cancel',
        correct_id_card: 'correct ID card number',
    },
    otherPage: {
        Sorryregisterorlogin: 'Sorry, the current link is invalid. Please re register or login.',
        characters20: '8 ~ 20 characters',
        includingonlyletters: 'The password is composed of characters that can be supported by the system, and must include numbers, letters and special characters at the same time ( ! # @ ? . + ; = ~ ` )',
        pleaseenterboundMobile: 'Please enter mobile number',
        Confirmloginpassword: 'Confirm the login password',
        Newpasswordempty: 'New password cannot be empty',
        Verificationtoyourmobile: 'Verification code will be  send to your mobile',
        setLoginPw: 'Please set the login password',
        ConfirmLoginPwagain: 'Confirm the login password again',
        cannotEmpty: 'mobile number can not be empty',
        signup: 'Sign up',
        confirmPw: 'Confirm the password',
        expired: 'The link has been expired. Please back to sign up or login ',
        setPWtitle: 'Set password',
        accounts: 'Accounts',
        doubleEnter: 'Enter the password again',
        strong: 'Strong',
        middle: 'Middle',
        low: 'Weak',
        registeredsuccessfully: 'Registered Successfully',
        accountnumber: 'Account number',
        pc: 'For a more secure and convenient operation,',
        mobile: 'please login on your computer',
        Emailssuccessfully: 'Emails has been sent successfully',
        Thankyou: 'Thank you for registering iPayLinks. The activation link has been emailed to you',
        Please24hours: 'Please login your email and finishing the registration via the activation link The link is valid within 24 hours.',
        Notreceiveanyemail: 'Not receive any email?',
        Pleaseemail: '1. Please check the spam of your email',
        Ifcorrect: '2. If still not found,',
        resent: '3.please check whether the email is correct.',
        Pleasehours: 'Please check the email and complete the verification. The verification link will be valid within 24 hours',
        Mailspamadmail: 'Mail may be moved to spam/admail',
        lxkf: 'If you have any questions, please contact the account manager or call',
        lxkf2: 'the customer service hotline  ',
        lxkf3: 'We will serve you wholeheartedly!',
        lxkf4: 'Computer terminal address: https://mp.ipaylinks.com',
        kyc1: 'You have not carried out real name authentication!',
        kyc2: 'Sorry, your real name authentication failed!',
        kyc3: 'Your real name certification is still under review!',
        kyc4: 'To ensure your use experience, please log in to the computer for relevant operations.',
        kyc5: 'According to relevant laws and regulations, to ensure your account security and use experience, please log in to the computer for real name authentication.',
        kyc6: 'In order to ensure your use experience, please re-authenticate your real name on the computer as soon as possible.',
        kyc7: 'In order to ensure your use experience, please log in to the computer to check the audit status.'
    },
    notice: {
        unreadmesages: 'unread messages',
        current: '',
        Announcements: 'Announcements',
        markallasread: 'mark all as read',
        NoAnnouncement: 'No Announcement',
        gotit: 'got it',
        Viewallannouncements: 'All announcements',
        BacktoHome: 'Back to Home',
        enterkeywords: 'enter keywords',
        submit: 'Submit',
        querying: 'Querying……',
        back: 'Back to ',
        selectDate: 'select a date',
        qwcl: 'Go to process'
    },
    loginPage: {
        Login: 'Log in',
        LogOut: 'Log out',
        PhoneNumberEmail: 'Phone Number or E-mail',
        Password: 'Password',
        VerificationCode: 'Verification Code',
        merchantNo: 'Merchant No',
        enterMerchantNo: 'Please enter merchant no',
        LoginEmail: 'Login Email',
        noAccount: '',
        Signupnow: 'Sign up now',
        ForgetPassword: 'Forget Password',
        pleaseenter1: 'please enter phone number or e-mail',
        enterEmail: 'please enter email',
        enterpassword: 'please enter password',
        enterVerificationCode: 'please enter verification code',
        subUserLogin: 'Sub-user Login',
        loginSubAccount: 'Log in sub account',
        adminLogin: 'Back to admin login',
        rules: 'Please set the password according to setting rules'
    },

    forgetPasswordPage: {
        ResetPassword: 'Reset Password',
        PhoneNumber: 'Phone Number',
        email: 'E-mail',
        VerificationCode: 'Verification Code',
        Sendverificationcode: 'Verification code',
        NextResetPassword: 'Next',
        back: 'Return',
        Login: 'Log in',
        enterpassword1: 'please enter verification Code',
        enterpassword2: 'please enter email',
        enterpassword3: 'please enter Phone Number',
        PhoneNumbercorrect: 'Phone Number is not correct',
        emailcorrect: 'E-mail is not correct',
        passwordRules: 'The password must contain both letters and numbers, cannot include special characters, and must be 8–20 characters long.',
        passwordRules2: 'Please re-enter your password.',
        passwordRules3: 'Please enter your password.',
        passwordRules4: 'The two password entries do not match.',
    },

    registerPage: {
        Signup: 'Sign up',
        PhoneNumberEmail: 'E-mail or Phone Number',
        ContactNumber: 'Contact Number',
        UserName: 'User Name',
        PhoneNumber: 'Phone Number',
        password: 'Password',
        email: "Email",
        enterPasswword: "Please enter password",
        enterPasswword2: "Please enter password again",
        ConfirmNewPassword: 'Confirm New Password',
        Pleaseenterusername: 'Please enter username',
        PleaseenteremailPhone: 'Please enter e-mail or phone Number',
        PleaseenterePhone: 'Please enter phone Number',
        PleaseentercontactNumber: 'Please enter contact Number',
        registrationAgreement: 'I have read and agree to ',
        agreement: '“User registration agreement”',
        agreementys: '“Privacy agreement”',
        LoginNow: '',
        Login: 'Log in Now',
        PleaseenterNumber: 'Please enter Nubmer',
        VerificationCode: 'Verification Code',
        emailUsed: 'this email has been used',
        max50characters: 'max: 50characters',
        max512characters: 'max: 512characters',
        max100characters: 'max: 100characters',
        tishi: "We don\'t accept this phone，please change it and re-submit your request !"
    },

    homePage: {
        QuickStart: 'Quick Start',
        Add1stMoney: 'Add 1st Money',
        Send1stMoney: 'Send 1st Money',
        Open1stCollectionAccount: 'Open 1st Collection Account',
        Link1stStore: 'Link 1st Store',
        QuickStartD1: 'You can use the balance for exchange and payment',
        QuickStartD2: 'Save recipien’s bank account information before you send money to them',
        QuickStartD3: 'Set up collection account for collecting funds from e-commerce platforms',
        QuickStartD4: 'Link stores and get orders data ready for sending funds into China mainland',
        Balance: 'Balance',
        MyCurrencyWatchlist: 'My Currency Watchlist',
        TransactionCountsin30Days: 'Transaction Counts in 30 Days',
        Shownfluctuations: 'Reference exchange rate: for reference only, the actual applicable exchange rate shall be subject to the exchange rate shown on the payment / Exchange page.(CNY: Onshore RMB; CNH: Offshore RMB)',
        SendMoney: 'Send Money',
        Exchange: 'Exchange',
        Collections: 'Collections',
        AddMoney: 'Add Money',
        ManageMyWatchlist: 'Manage My Watchlist',
        TransatcionAmountSummary: 'Transatcion Amount Summary',
        Incoming: 'Incoming',
        Outcoming: 'Outcoming',
        toChinaMainland: 'Need to send money to China Mainland?',
        Weknowregulations: 'We know regulations are complicated, so we’re here to help.Simply link your online stores and leave the rest to us.',
        more: 'Balance Details',
        more2: 'Show Me More',
        Commonexchange: 'You can display the common currency onshore / offshore RMB currency pairs in the list, which is convenient to view the latest exchange rate at any time',
        save: 'save',
        cancel: 'cancel',
        sell: 'sell',
        buy: 'buy',
        Removefromwatchlist: 'Remove from the watchlist',
        Addupto5: 'Add up to 5',
        Youraccountinprogress: 'Your account verification is in progress',
        notcompletedverification: 'You have not completed the real-name verification of your account',
        completeverificationfirst: 'Please complete the account verification first',
        nopermission: 'You have no permission to view',
        contactaccountadmin: 'Please contact the account admin',
        waitamoment: 'Please wait a moment',
        message: 'Message',
        stores: 'stores',
        CollectionAccount: 'Collection Account',
        movedaccount: 'have been moved to your account',
        saveSuccess: 'Save successfully',
        dbsx: 'To-do list',
        mores: 'More',
        zwdbsx: 'No to-do items',
        a1: 'Account Verification has been submitted, please back to HOME and refresh the page'
    },

    kyc: {
        quickCopy: 'Quick Copy: Legal Representative & Director Information',
        nar1: 'NAR1',
        businessRegistercertificateNumber: 'Business Registration Certificate Number',
        verifyFail: "Your verification was declined",
        verifyFail2: "Please revise it and submit again",
        modifyKyc: 'Modify',
        AccountVerification: 'Activate Your Account',
        toverifyyouraccount: 'It will take a few minutes  to verify your account before you start trading.',
        Youraccountprogress: 'Your account verification is in progress',
        Wearereviewingyourmaterials: 'We are reviewing your materials, and you will be informed via email or SMS as soon as possible',
        Verifying: 'Verifying',
        Toverify: 'To verify',
        latterVerify: 'Verify later',
        Confirm: 'Confirm',
        startVerify: 'Start your verification',
        tip: 'In accordance with relevant financial regulatory requirements and to ensure the safety of your account funds, iPayLinks needs to verify your true identity information. iPayLinks promises to keep the real-name information provided by you strictly confidential and will not use your information for other purposes!',
        entityType: 'Entity type',
        region: 'Country/Region',
        upload: 'Credential upload',
        idCard: "ID card",
        passport: 'Passport',
        personalDoc: 'Personal documents',
        idNumber: 'ID number',
        basicInfo: 'Basic Information',
        uploadImg: 'Ensure that the uploaded image text is clearly visible, the maximum size is no more than 10M, and supports JPG, PNG, JPEG',
        qiyeInfo: 'Corporate Information',
        ziliaoUp: 'Data upload',
        businessCer: 'Business certificate',
        infoCheck: "Information check",
        zuizhongSyr: 'Ultimate Beneficial Owner',
        deleteSyr: 'Remove',
        addSyr: 'Add ultimate beneficiary Owner',
        tongFaren: 'Same as the above "legal representative" information.',
        tongSyr: 'Same as the above "authorized person" information.',
        countryOrRegion: 'Visa issuance country or region',
        a1: 'Please provide a copy of the ID card of the legal representative, authorized person and ultimate beneficiary (if applicable). Ultimate beneficiaries are individuals who directly or indirectly hold more than 25% of the company’s shares.',
        a2: "The legal representative is also the ultimate beneficiary",
        a3: 'The authorized person is also the ultimate beneficiary',
        gudongFile: 'Shareholder documents',
        farenDb: 'legal representative',
        Corporatestructure: 'Corporate structure',
        Legalperson: 'Legal person',
        Tofollowingdocuments: 'To set up an account, please provide the following documents',
        businesslicense: 'business license',
        LegalrepresentativeID: 'Legal representative ID',
        BusinessRegistrationCertificate: 'Business Registration Certificate',
        YourpersonalID: 'Your personal ID',
        personalID: 'Personal ID',
        Companycertificate: 'Company registration certificate',
        uploadCompanycertificate: 'Please upload the company registration certificate',
        Partnershipagreement: 'Partnership agreement',
        Ifnotmanagingpartner: 'Personal ID of the ultimate beneficiary who holds more than 25% of the company’s shares. If not, please provide the ID of the managing partner',
        Iconfirmfillcompany: 'I confirm that I am the authorized administrator of the enterprise account，and fill in the form',
        uploadbusinesslicense: 'Please upload a copy of the business license',
        uploadPartnershipagreement: 'Please upload partnership agreement',
        uploadbusinessregistrationcertificate: 'Please upload a copy of the business registration certificate',
        LegalrepresentativeYOU: 'Legal representative (you)',
        LegalpersonYOU: 'Legal person (you)',
        providesupervisorshares: 'Please provide a copy of the ID of the supervisor, the authorized person and the ultimate beneficiary (if applicable). Ultimate beneficiaries are individuals who directly or indirectly hold more than 25% of the company’s shares.',
        supervisoralsobeneficiary: 'The supervisor is also the ultimate beneficiary',
        FrontphotoIDcard: 'Front photo of ID card',
        PhotobackID: 'Photo of the back of the ID',
        Passportpersonalinformation: 'Passport personal information',
        idcardPhoto: 'Photo of ID card',
        IDperson: 'ID of authorized person',
        notnecessary: 'not necessary',
        Maximum10Msupportziprar: 'Maximum 10M, support zip, rar',
        personaldocuments: 'personal documents',
        provideapplicableshares: 'Please provide a copy of your personal ID and the ID of the ultimate beneficiary (if applicable). Ultimate beneficiaries are individuals who directly or indirectly hold more than 25% of the company’s shares.',
        Licenseedocuments: 'Licensee documents',
        Corporatedocuments: 'Corporate documents',
        UltimateBeneficialOwner: 'Ultimate Beneficial Owner',
        Samelegal: 'Same as the above "legal representative" information',
        Sameperson: 'Same as the above "authorized person" information.',
        Samelegal2: 'Same as the above "legal representative" information',
        enteIDnumber: 'Please enter the ID number',
        uploadallfiles: 'Please upload all files',
        alreadyused: 'This certificate has already been used, please replace it',
        verificationsubmitted: 'Real-name information verification submitted successfully',
        reviewiscompleted: 'We are reviewing your materials and will notify you by email or SMS as soon as the review is completed',
        Forexample: 'For example',
        Businessempty: 'Business registration certificate is empty',
        China: 'China',
        ChinaHongKong: 'Hong Kong (China)',
        Personalholdsshares: 'Personal ID of the ultimate beneficiary who holds more than 25% of the company’s shares',
        providepersonalID: 'Please provide a copy of your personal ID',
        Theindividualbeneficiary: 'The individual is also the ultimate beneficiary',
        AuthorizedpersonYOU: 'Authorized person (you)',
        Individualmerchants: 'Individual merchants',
        partner: 'partner',
        company: 'company',
        Legalpersonfile: 'Legal person file',
        Authorizedperson: 'Authorized person',
        Licensedphoto: 'Licensed photo',
        Examplescertificatestyles: 'Examples of certificate styles',
        Verificationstatus: 'Verification status',
        Pleaseupload: 'Please upload',
        Pleaseconfirmandcheck: 'Please confirm and check',
        uploadIDphoto: 'Please upload ID photo (passport personal information page)',
        uploadIDphoto2: 'passport personal information page',
        uploadJPGPNGJPEG1: 'Please upload a copy of the business registration certificate to ensure that the uploaded image and text are clearly visible, the maximum size does not exceed 10M, and supports JPG, PNG, JPEG',
        uploadJPGPNGJPEG2: 'Please upload company registration certificate to ensure that the uploaded image and text are clearly visible, the maximum size does not exceed 10M, and supports JPG, PNG, JPEG',
        uploadJPGPNGJPEG3: 'Please upload Partnership agreement to ensure that the uploaded image and text are clearly visible, the maximum size does not exceed 10M, and supports JPG, PNG, JPEG',
        uploadJPGPNGJPEG4: 'Please upload Personal ID that the uploaded image and text are clearly visible, the maximum size does not exceed 10M, and supports JPG, PNG, JPEG',
        Pleaseshares2: 'Please provide a copy of the ID card of the legal representative, authorized person and ultimate beneficiary (if applicable). Ultimate beneficiaries are individuals who directly or indirectly hold more than 25% of the company’s shares.',
        Countryissued: 'Country or region where the certificate is issued',
        uploadPhotoID: 'Please upload Photo of ID card that the uploaded image and text are clearly visible, the maximum size does not exceed 10M, and supports JPG, PNG, JPEG',
        passportPhoto: 'Photo of Passport',
        Countryorregion: 'Country or region',
        IDphoto: 'ID photo (passport personal information page)',
        Greatcreated: 'Great, new account has been created',
        Greatready: 'Great, your new account is ready',
        Youhavethe: 'You just created the',
        masteraccount: 'master account',
        Accountreview: 'Account verification information is under review',
        expecteddays: 'Estimated to take 1~2 working days',
        Stayaccount: 'Stay in current account',
        Switchaccount: 'Switch to new account',
        Accountverificationinformation: 'Account verification information',
        Validationstatus: 'Validation status',
        Verificationpassed: 'Verified',
        pngOnly: 'Only supports jpeg、png、jpg ',
        zipOnly: 'Only supports zip、rar',
        bncg: 'The file size cannot exceed',
        exampleDescribe: {
            a1: 'Upload a complete picture of the original business license. The information in the picture is complete, clear, identifiable, true and effective.',
            a2: 'Upload a complete picture of the company registration certificate. The information in the picture is complete, clear, recognizable, true and effective.',
            a3: 'Upload a complete picture of business registration certificate. The information in the picture is complete, clear, recognizable, true and effective.',
            a4: 'Upload a complete picture of the passport. The information in the picture is complete, clear, recognizable, true and effective.',
            a5: 'Upload a complete picture of the front of the ID card, the information in the picture is complete, clear, recognizable, real and effective.',
            a6: 'Upload a complete picture of the reverse side of the ID card. The information in the picture is complete, clear, recognizable, true and effective.',
            a7: 'Upload a complete picture of the handheld ID card. The information in the picture is complete, clear, recognizable, real and effective.',
            a8: 'Upload the complete picture of ID card, the information in the picture is complete, clear, recognizable, real and effective.',
            a9: 'Correct example'
        },
        zlxg: 'Data modification',
        userOverdue1: 'Your account',
        userOverdue2: ', please click the Modify Authentication Information button below to update your certificate, we will review the re-submission of the information, you can give priority to account operations, so as not to affect the use of your account within the review time If you have any questions, you can contact your sales manager for assistance, thank you.',
        userOverdue3: ', and the account cannot be used temporarily. Please click the Modify authentication information button below to update your certificate. We will review the resubmission of the information. After passing the account, the account will be restored. If you have any questions, please contact Your sales manager assists in processing, thank you.',
        guoqi1: 'Real-name certification materials have expired',
        guoqi2: 'Please follow the prompts to update the information and submit',
        OCRMesJsonKey: {
            certExpirationBegin: 'Validity start time',
            certExpirationEnd: "Expiration date",
            certificateNumber: "ID number",
            dateOfBirth: "Birthday",
            gender: "Gender",
            issuingAuthority: "Issuing authority",
            companyName: "Name",
            nationality: "Nation",
            specificAddress: "Address",
            sfsbxx: 'Identification information'
        },
        companyDto: {
            PostCode: 'Post Code',
            Individual: 'User Type',
            region: "Region",
            certificateofIncorporation: 'Certificate of Incorporation',
            CertificateNo: 'Certificate.No',
            BusinessActivityLicense: 'Business Activity License',
            CountryRegionoftheRegisteredAddress: 'Country/Region of the Registered Address',
            CompanyName: 'Company English Name',
            CompanyOriginalName: 'Company  Name',
            ProvinceStateoftheRegisteredAddress: 'Province/State of the Registered Address',
            CityoftheRegisteredAddress: 'City of the Registered Address',
            Theregisteredaddressofthecompany: 'The registered address of the company',
            sameBusiness: 'Is the business address the same as the registered address?',
            CountryRegionoftheBusinessOperationAddress: 'Country/Region of the Business Operation Address',
            ProvinceStateoftheBusinessOperationAddress: 'Province/State of the Business Operation Address',
            CityoftheBusinessOperationAddress: 'City of the Business Operation Address',
            Thebusinessoperationaddressofthecompany: 'The business operation address of the company',
            CertificateofBusinessAddress: 'Certificate of Business Address',
            BusinessAddressProof: 'Business Address Proof',
            BusinessWebsite: 'Business Website',
            ArticlesofAssociation: 'Articles of Association',
            NumberofShares: 'Number of Shares',
            ShareholdingStructure: 'Shareholding Structure',
            Other: 'Other',
            BankAccountOpeningDocuments: 'Bank Account Opening Documents',
            TaxPaymentCertificate: 'Tax Payment Certificate',
            holdingRatio: 'Percentage of shareholding',
            holdingRatioMinError: 'Shareholding ratio cannot be less than 25',
            holdingRatioMaxError: 'Shareholding ratio cannot be greater than 100',
            holdingRatioNotNumberError: 'Shareholding ratio must be a number',

            // step3
            NationalityoftheDirector: 'Nationality of the Director',
            FirstName: 'First Name',
            LastName: 'Last Name',
            EnglishFirstName: 'English First Name',
            EnglishLastName: 'English Last Name',
            TypeofCertificate: 'Type of Certificate',
            TheDirectorCertificate: 'The Director‘s Certificate',
            CertificateNumber: 'Certificate Number',
            Certificateexpirationdate: 'Certificate expiration date',
            CertificateregistrationDate: 'Certificate registration Date',
            CertificateexpirationdatePermanent: 'permanent ',
            Thedirectordateofbirth: `The director's date of birth`,
            CountryRegionoftheResidentialAddress: 'Country/Region of the Residential Address',
            ProvinceStateoftheResidentialAddress: 'Province/State of the Residential Address',
            CityoftheResidentialAddress: 'City of the Residential Address',
            ResidentialAddress: 'Residential Address',
            NationalityoftheUltimateBeneficialOwner: 'Nationality of the Ultimate Beneficial Owner',
            TheUBOCertificate: 'The UBO‘s Certificate',
            uboFirstName: 'First Name',
            uboLastName: 'Last Name',
            uboEnglishFirstName: 'English First Name',
            uboEnglishLastName: 'English Last Name',
            DateofBirthoftheUltimateBeneficialOwner: 'Date of Birth of the Ultimate Beneficial Owner',
            AuthorizedAgent: 'Authorized Agent',
            authFirstName: 'First Name',
            authLastName: 'Last Name',
            authEnglishFirstName: 'English First Name',
            authEnglishLastName: 'English Last Name',
            DateofBirthoftheAgent: 'Date of Birth of the Agent',
            PowerofAttorney: 'Power of Attorney',
            CertifiedTrueCopy: 'Certified True Copy（CTC）',
            CTCdocuments: 'CTC documents',
            lastUboInfoTitle: `最终受益人信息（ 所有持有≥25%股权或股份的个人，企业持股需追溯到最终自然人股东 ）`,

            // placeholder
            inputPlaceholder: 'Please enter',
            selectPlaceholder: 'Please select',
            registerAmount: 'Register Capital (ten thousand yuan)',

            // 侧边栏
            registeLocation: `Company/Individual Registration Location`,
            companyType: `Company Type`,
            step1: 'Start',
            step1Desc: 'Select Region and Type',
            step2: 'Basic Information',
            step2Desc: 'Company Information and Documents',
            step3: 'Personal Information',
            step3Desc: 'Director, Ultimate Beneficial Owner, Authorized Representative',
            step4: 'CTC',
            step4Desc: 'Certified True Copy (CTC)',
            agreeInformation: `I agree to provide my identification information for real-name verification.`,
            nextStep: 'Next Step',

            docuDesByCompany: {
                doc1: 'Please prepare the following documents:',
                doc2: 'Certificate of Incorporation',
                doc3: 'Business Activity License (if applicable) – A document specifying the nature and scope of the business activities.',
                doc4: 'Articles of Association',
                doc5: 'Number of Shares',
                doc6: 'Certificate of Business Address – Proof of address from the past three months (e.g., legal documents or utility bills). If using a home office, the address must match the director’s or UBO’s address.',
                doc7: 'Shareholding Structure',
                doc8: 'Director’s ID',
                doc9: 'UBO’s (Ultimate Beneficial Owner with more than 25% shares) ID',
                doc10: 'Notarial Certificate (CTC only)',
                doc11: 'If any of the above documents are not in Chinese or English, please provide a Certified True Copy (CTC). The CTC must be issued by a Certified Public Accountant (CPA) firm that is qualified and experienced in certifying such documents.',
            },
            docuDesBySelfProprietor: {
                doc1: 'Business Registration Certificate – Mandatory',
                doc2: 'Business Activity License (if applicable) – A document specifying the nature and scope of the business activities.',
                doc3: 'Proof of Business Address – Recent utility bill or lease agreement (within the past 3 months).',
                doc4: 'Bank Account Opening Documents – Bank account confirmation letter or account opening certificate.',
                doc5: 'Tax Payment Certificate (if available) – Optional',
                doc6: 'Proof of Address for All Individuals (within the past 3 months):',
                doc7: 'Business owner:',
                doc8: 'Identification document',
                doc9: 'recent utility bill (within 3 months), or bank statement, etc.',
                doc10: 'If any of the above documents are not in Chinese or English, please provide a Certified True Copy (CTC). The CTC must be issued by a Certified Public Accountant (CPA) firm that is qualified and experienced in certifying such documents.',
            },
            docuDesByHK: {
                enterprise_doc1: 'Certificate of Incorporation',
                enterprise_doc2: 'Business Registration Certificate',
                enterprise_doc3: 'Incorporation Form NNC1 and Annual Return NAR1 (company over 1 year)',
                enterprise_doc4: "Director's ID document (HKID / ID Card / Passport)",
                enterprise_doc5: "Authorized agent's ID document (HKID / ID Card / Passport) (if you are an authorized agent)",
                personal_doc1: 'Front and back photos of HKID / Passport',
            },


            CompanyDocuments: `Company Documents`,
            CompanyBasicInformation: `Company Basic Information`,
            Attachment: "Attachment",
            yes: 'Yes',
            no: 'No',
            LegalRepresentativeInformation: `Legal Representative Information`,
            IdentityInformation: 'Identity Information',
            UltimateBeneficialOwner: `Ultimate Beneficial Owner (UBO)`,
            selfProdisUBOS: `Any entity holding 25% or more of the shares or equity is considered one of the UBOs.`,
            uboAllProd: `UBO Information (All individuals holding 25% or more of the shares or equity; corporate shareholders must be traced to the ultimate natural person shareholder)`,
            ubo: 'Ultimate Beneficial Owner',
            addUbo: `Add UBO Information`,
            AuthorizedRepresentativeInformation: `Authorized Representative Information`,
            LegalRepresentative: `Legal Representative`,
            AuthorizedRepresentative: `Authorized Representative`,
            RepresentativeNationality: `Nationality of the Agent`,
            clickDownLoad: `(click to download),`,
            pleaseTip1: 'Please complete the power of attorney signed by the company’s legal representative ',
            plaseTip2: `or a board resolution with equivalent legal effect. Affix the company seal and upload a clear image or PDF of the authorization letter.`,
            ArethedocumentsinChineseorEnglish: `Are the documents in Chinese or English`,
            prevStep: `Previous Step`,
            delete: 'Delete',
            Identityverification: 'Identity verification',
            Director: 'Director',
            IsthistheUBO: 'Is this the UBO',
            Addinformationofdirectors: 'Add information of other company directors',
            Nameofultimatebeneficialowner: 'Name of ultimate beneficial owner',
            EnglishNameofultimatebeneficialowner: 'English name of ultimate beneficial owner',
            Provinceofresidence: 'Province of residence',
            Cityofresidence: 'City of residence',
            Englishname: 'English name',
            Name: 'Name',
            Authorizedaccountoperator: 'Authorized account operator',
            Clicktoupload: 'Click to upload',
            Or: 'Or',
            Draganddrophere: 'Drag and drop here',
            Supportedattachments: 'Supported attachments',
            Filesizemustnotexceed: 'File size must not exceed {size}MB',
            fileTypeNotSupported: 'Only {types} files are supported. Please select another file.',
            uploadFailed: 'Upload failed',
            imageMaxDimension: 'Image dimensions must not exceed {width}px*{height}px',
            reloadUpload: 'Re-upload',

            NotarialCertificate: "Notarial Certificate ",
            Proofofaddress: "Proof of address",

            passport: 'Passport',
            Idcard: 'ID CARD',
            IDCardFrontPage: 'ID Card Front Page',
            IDCardBackPage: 'ID Card Back Page',
            IDCardHoldPage: 'ID Card Hold Page',
            IDCardHoldPageTips:'Please upload the hand-held ID card photo when opening B2B business.',
            IDCardHoldPage2: 'Hand-held ID photo',
            submit: 'Submit',

            successDialog: {
                title: 'Submission Successful',
                first: 'Register',
                second: 'Submit Information',
                secondInfo: `Under Review`,
                third: 'Activate Account',
                content: "Submission Successful",
                tips: `We will review your information as soon as possible. Please be patient.
      The result will be sent to you via SMS and email. Please stay updated!`,
                returnHome: "Return to Homepage",
            }



        }
    },

    //    多账户
    multipleAccounts: {
        hasOneAccount: 'Currently there is only 1 account',
        noPermission: 'You do not have permission to create under the current account, please switch to an account you have permission to create',
        switchAccount: 'Switch account',
        selectAccount: 'Select account',
        audited: 'Audited',
        underReview: 'under review',
        accountNo: 'Account no',
        role: 'Role',
        createNewAcc: 'Create new account',
        basicInfo: 'Basic Information',
        accountVerify: 'Account verification',
        createAcc: 'Confirm submit',
        setNickName: 'Set an account nickname',
        accountNickName: 'Account nickname',
        pleaseSet: 'Please set an account nickname for easy search and switch accounts',
        a1: 'Whether the new account is used for existing company or personal information',
        nextStep1: 'Next step: verify account',
        a2: 'The company or personal information under review is temporarily unavailable',
        a3: 'Submit new company or personal information',
        back: 'Back to the previous step',
        chooseHasAccount: {
            b1: 'Verification information for the new account',
            b3: 'Please confirm the following information and create an account',
            accountType: 'Account type',
            location: 'Location',
            entityName: 'Entity name',
            idNumber: 'Identification Number',
            legalPerson: 'Name of legal person',
            b2: 'I confirm that I am the administrator of this enterprise account and have been authorized to open a new account on behalf of the enterprise',
            nextStep: 'Next step: confirm the account information',
            nextStep2: 'Next step: Upload legal person certificate'
        },
        chooseNewAccount: {
            baseInfo: 'Please provide basic information',
            pleaseSelectLocation: 'Please select the location',
            type: 'Type',
            a1: 'You need to provide the following materials for verification:',
            a2: '1) Photo of front and back of ID card',
            a3: '2) Photo of holding ID card',
            a4: 'iPayLinks is required to verify your real identity information according to relevant financial regulatory requirements and to ensure the security of account funds. iPayLinks promises to keep the real name information provided by you strictly confidential and will not be used for other purposes.',
            a5: 'Please provide verification materials',
            cardPhoto: 'Photo of ID card',
            a6: 'Please upload the latest second generation ID card to ensure that the uploaded image text is clear and visible, with a maximum of 10m, and supports JPG, PNG and JPEG',
            holdCard: 'Photo of holding ID card',
            a7: 'Please upload the photo of the front of your ID card to ensure that the face and the front information of the ID card are clear and visible, with a maximum of 10m. It supports JPG, PNG and JPEG',
            a8: 'Please input the above ID number',
            personDoc: 'Personal documents',
            a9: 'The above verification materials shall be reviewed within 1 ~ 2 working days after submission',
            id: 'ID',
            passport: 'Passport',
            industryCategory: "Industry category",
            website: 'Website address',
            pleaseEnterWeb: 'Please enter the website address',
            selectIdentity: 'Please select your identity',
            legalRepresentative: 'Legal representative',
            a10: 'You are authorized by the company to sign binding contracts on behalf of the company in accordance with the law or the articles of association',
            authorizedPerson: 'Authorized person',
            a11: 'You are authorized to handle business on behalf of the enterprise',
            a12: '1) Business license',
            a13: '2) ID card of legal representative',
            a14: "3) Personal identity documents of the ultimate beneficiary holding more than 25% of the company's shares",
            a15: 'iPayLinks is required to verify your real identity information according to relevant financial regulatory requirements and to ensure the security of account funds.iPayLinks promises to keep the real name information provided by you strictly confidential and will not be used for other purposes.',
            businessLicense: 'Business license'
        },
        tip: 'No permission for this account, please switch to other accounts',
        setDefault: 'Set as default',
        isDefault: 'Default',
        v0429: {
            a1: ' (A major web site that can see the product details)',
            a2: ' (Select a major platform or type of your business.)',
            a3: ' (Tax identifier number not cert number)',
            a4: ' (Keep the image clear with four corners, no cover and hide)',
            a5: 'All the certificates of shareholders with more than 25% shares are needed.'
        }
    },
    //    收款
    collection: {
        collectionAccountLocation: 'Collection Account Location',
        collectionAmount: 'Collection Amount',
        otherInfo: 'Other Information',
        amountInfo: 'Amount Information',
        collectionAccount: 'Collection Account',
        PleasebindFirst: 'Please go to the collection account list to bind the store first',
        a1: 'Receiving money from marketplaces easily',
        a2: 'Our collection bank accounts allow you to receive money worldwide and it only takes a few minutes to create one.',
        learnMore: 'Learn more',
        addAccount: 'Add Collection Account',
        addAccount2: 'Add Collection Account',
        firstAccount: 'First Collection Account',
        currency: 'Currency',
        accountNickName: 'Nickname',
        location: 'Account Location',
        bankAccount: 'Bank account Number',
        basicInfo: 'Basic Information',
        accountName: 'Account Name',
        accountNameHl: 'Store Holder Name',
        createTime: 'Create at',
        accountTime: 'Account Status',
        bankMes: 'Bank Account Details',
        accountCurrency: 'Account Currency',
        bankLocation: 'Bank Account Location',
        bankName: 'Bank Name',
        bankNo: 'Bank Account No',
        accountType: 'Account Type',
        bankAdd: 'Bank Address',
        bankPost: 'Bank Address Postcode',
        tips: 'Collection Tips',
        time: 'Collection Date',
        transactionId: 'Transaction ID',
        amount: 'Amount',
        a3: 'Account Statement',
        a4: 'Which purpose is this statement',
        a5: 'Statement for Amazon',
        a6: 'General Statement',
        a7: 'Please confirm information below',
        a8: 'Amazon Registered Name',
        a9: 'Amazon Registered Email',
        add: 'Registered Address',
        postCode: 'Postcode',
        a10: 'I confirm the information above is accurate and consistent with Amazon registered details.I agree and authorise  iPayLinks to use details above in account statement.',
        a11: 'Download Statement',
        add2: 'Account Holder’s Address',
        a12: 'What currency you receive',
        a13: 'Please select receiving currency',
        a14: 'Which account location you prefer',
        a15: 'How do choose account？',
        a16: 'Give your account a nickname',
        back: ' collection account list',
        a17: 'To quickly retrieve the collection account, such as store name, account , etc',
        a18: '(Platform registration name recommended)',
        a181: '（Select the store you registered on the platform）',
        a182: 'As required by the Bank of Hong Kong, the account name must use the English name at the time of your authentication. If you need to change your account name, please contact your account manager.',
        a19: 'Purpose of collection account',
        a20: ' (in order to ensure your subsequent normal collection, please select according to your actual collection purpose)',
        queryNickName: 'Quick search nickname',
        b1: 'Bank code',
        b2: 'Branch code',
        city: 'City',
        b4: 'If this account has not been recorded for more than 90 days, in order not to affect your normal use, it is recommended that you apply for a new account for collection',
        b5: 'If you need to use it again, please contact your account manager to re open your account;',
        b6: 'Store Holder Name',
        // b8: 'Your collection account name is the one registered in iPayLinks by default. When collecting funds from e-commerce platforms such as Amazon, please use the platform registration name as the collection account name.',
        b8: 'This is used to name you Collection Bank account, so you can easily recognize which store the fund is from.',
        b9: 'The collection account supports both local payment and swift payment',
        b11: '(the account does not support swift transfer)',
        b13: 'The collection account can only accept swift payment',
        b14: 'Please enter the detailed address',
        b15: 'Country / Region',
        Province: 'Province',
        modifyNickName: 'Modify account nickname',
        modifyAccName: 'Modify account name',
        jyms: 'Transaction description',
        sczl: 'Upload information',
        sc: 'Upload',
        creatSuccess: 'Created successfully',
        than90days: 'Account has been more than 90 days without account, in order not to affect your normal use, it is recommended that you apply for a new account for collection.',
        AmazonenterTip: 'If your Amazon cannot use full width Katakana, please use half width Katakana when filling in the account holder',
        AmazonenterTip1: 'Half width Katakana',
        Duringmanager: 'During the creation of global collection account, it will be issued within 10 minutes. You can view it on the Global Collection - Account Management. If you have any questions, please consult your account manager',
        Transferaccount: 'Transfer confirmation of collection account',
        TransferSuccess: 'Successfully',
        CollectionAccount: 'collection account',
        b16: 'Please select whether to associate with the store',
        b17: 'Associate new store',
        b18: 'Associated with existing stores',
        b19: 'No store',
        b20: 'Associated with existing stores',
        c1: 'Associated bank account number',
        c2: 'Apply for a new account',
        c3: 'Bind / switch failure feedback',
        c4: 'Binding failure reason',
        c5: 'Sorry, the current collection account cannot be associated with the store',
        c6: 'Account detail',
        c7: 'Please choose the purpose of the collection account correctly. If the fund is returned due to the wrong choice, the refund cost will be borne by you. The refund deduction is 1 ~ 30USD / GBP, which is subject to the actual bank charges;',
        c8: 'If the currently applied  account number cannot be bound / switched when it is added to the e-commerce platform, you can click here to enter the failure reason fed back by the platform, and then a new bank account number will be allocated for you to use again;',
        c9: 'Add Collection Account',
        c10: 'This virtual account has not been activated, and it can only receive fund after being activated.',
        c11: 'Reactivate',
        c12: 'Failure reason',
        c13: 'Method',
        c14: 'Update store info',
        c15: 'Change new store',
        c16: 'Change existing store',
        c17: 'Store address',
        c18: 'Please keep the name of the store consistent with the address of the store, so as to avoid the activation failure of the collection account due to filling in errors.',
        c19: 'Please go to the add store page to bind the new store first, then enter this page and select "change existing store" to replace and bind the store with the newly added store.',
        c20: 'Please select a store',
        c21: 'Shop selection',
        c22: 'Failed to bind the collection account on the plat form?',
        bankAccountName: 'Collection Account',
        shopnames: 'Shop Name',
        realFundinAmount: 'Real Fundin Amount',
        c23: 'Single transaction limit ：individual households <i style="font-family:Lato-Regular">≤</i> 100000, enterprise households <i style="font-family:Lato-Regular">≤</i> 300000. Please split If it exceeds. The expenses for collection and return beyond the limit shall be borne by the customer.',
        c24: 'Note: ',
        c25: '1. IDR receivables will be settled in SGD Singapore dollars. If you need other currencies, please exchange the currency after settlement. ',
        c26: '2. If IDR receivables are recorded for the first time, the income statement of this receivables account in Shopee store shall be uploaded to prove the source of funds; Otherwise, the funds will be returned.',
        drzzj: 'Unenter Transaction',
        hkrmc: 'Payer Name',
        drzzl: 'Material',
        ddsm: 'Compliance  Explain',
        ddshsm: 'Compliance  Audit Explain',
        rejectedMes: 'The return of funds generally takes 2 ~ 5 working days, and the specific arrival time shall be subject to the bank.',
        rejectedMes2: 'We have received your payment and will record it to you later. If you need additional information, we will notify you',
        nameOfRemitter: 'Payer Name',
        jiesuanInfo: {
            title: 'Settlement Information',
            amount: 'Settlement Amount',
            fee: 'Total Commission',
            rate: 'Settlement Exchange Rate'
        },
        cksl: 'View examples',
        qxzskzhyt: 'Please select a payment account',
        returnShui: 'Payment account is used for tax rebates',
        returnCare: 'Local tax refunds are only supported in Europe, the UK and the US, but not in other regions.',
        saleCategory: 'Sales category',
        platReceviable: 'Platform collection',
        standReceviable: 'Independent stand collection',
        other: 'other',
        payeeMethod: 'Payment methods',
        stsk: 'Collect tax refunds',
        kjmy: 'Cross-border trade',
        taxCare: 'Tax refunds only accept tax bureau to, and only in iPayLinks tax rebates can be used for the settlement of exchange.'
    },
    //    换汇
    exchange: {
        exchange: 'Exchange',
        exchange2: 'Confirm Exchange',
        sell: 'Sell',
        buy: 'Buy',
        rate: 'Reference Rate',
        rate2: 'Rate',
        date: 'Exchange Date',
        a1: 'The exchange rate will be automatically refreshed and may fluctuate. Please refer to the exchange rate at the time of final submission.',
        createDate: 'Creation Date',
        sellAmount: 'Sell Amount',
        sellCurrency: 'Sell Currency',
        buyAmount: 'Buy Amount',
        buyCurrency: 'Buy Currency',
        download: 'Download',
        comDate: 'Completion date',
        a2: 'Please ensure sufficient balance before exchange deadline at 2020-07-15 18:00',
        a3: 'Exchange has closed because of Unsufficient balance',
        to: 'to',
        exchangeDetail: 'Exchange Details',
        unsufficientBalance: 'Unsufficient Balance',
        sufficientBalance: 'Sufficient Balance',
        balance: 'Balance',
        a4: 'Sell amount is less than the minimum amount',
        a5: 'Exchange Confirmation',
        a6: 'Guaranteed exchange rate.',
        a7: 'The exchange rate of the page may change, please pay attention to the change in the amount.',
        success: 'Great,all done!',
        again: 'Exchange More',
        toList: 'Check My Exchanges',
        a8: 'You just sold ',
        a9: 'for',
        attentionmanagementlist: 'Please pay attention to the change of order status in the transaction management list',
        Selectsellingcurrency: 'Select selling currency',
        Selectbuyingcurrency: 'Select buying currency',
        Selectdate: 'Select date',
        Exchangeraterefreshed: 'Exchange rate refreshed',
        noteratefluctuation: 'Please note that the exchange rate has been changed due to exchange rate fluctuation',
        Incorrectformat: 'Incorrect format',
        Scaleerror: 'Scale error',
        Pendinginquiries: 'Pending inquiries',
        Queryexchangerate: 'Query rate',
        copySuccess: 'Copy succeeded',
        copyFailed: 'Copy failed',
        exchangeList: 'My Exchanges'
    },
    //店铺
    store: {
        a1: 'Transfer funds to China mainland',
        a2: 'Regulations may be complicated,but we can make them easier. Simply provide order information via linking your e-commerce stores so you have enough proof of fund source for transferring funds into China.',
        a3: 'Saved order information that can be used for sending funds into countries with inbound regulations.',
        a4: 'Available Order Quota',
        learnMore: 'Learn More',
        payToChina: 'Send Money to China',
        storeName: 'Store name',
        plat: 'E-commerce platform',
        sync: 'Order Data Sync',
        sync2: 'Sync Order Data',
        sync3: 'Upload order data',
        update: 'Update Store',
        authSuccess: 'Authorized',
        reBind: 'Rebind',
        authFail: 'Fail to Authorize',
        auto: 'Automatic',
        shoudong: 'Manual',
        addNewStore: 'New Store',
        choosePlat: 'Please select the store platform',
        addStore: 'Add Stores',
        searchName: 'Quick search store name',
        a5: 'Check stores that require updates',
        firstStore: 'Add First Store',
        storeFilter: 'Store Filter',
        a6: 'User guide on how to manually synchronize order data',
        a7: 'Authorization failed or expired, please update your store information and re-authorize. After authorization, orders within 90 days will be automatically obtained.',
        a8: 'Add your e-commerce stores and authorise iPayLinks to obtain order information.',
        a9: 'Newly athorised store may take some time to finish order data synchronization.',
        a10: 'You have ',
        a11: 'store failed to authorise.Please update the authorisation in order to update order data.',
        a12: 'Authorise store',
        change: 'Change',
        storeDetail: 'Store details',
        sellerId: 'Seller ID',
        auth: 'Authorisation',
        devName: 'Developer’s Name',
        devId: 'Developer ID',
        mwsToken: 'MWS Token',
        a13: 'To allow us automatically obtain order information,you’ll need to authorise iPayLinks in platform using information below',
        a14: 'What is this and how do I authorise?',
        a15: 'To allow us automatically obtain order information,you’ll be redirected to ebay webpage to authorise  iPayLinks .',
        a15shopee: 'To allow us automatically obtain order information,you’ll be redirected to Shopee webpage to authorise  iPayLinks .',
        a15shopify: 'To allow us automatically obtain order information,you’ll be redirected to Shopify webpage to authorise  iPayLinks .',
        a16: 'After you authorize in eBay, the store will be successfully linked and save relevant information.',
        a16shopee: 'After you authorize in Shopee, the store will be successfully linked and save relevant information.',
        a16shopify: 'After you authorize in Shopify, the store will be successfully linked and save relevant information.',
        a17: 'You‘ll be redirected to ',
        website: ' website',
        url: 'Store URL',
        verify: 'Verification',
        area: 'Main sales area',
        order: 'Order Information',
        a18: 'To verify store information,please provide your email registered on Noon platform.',
        getEmail: 'How do I get email?',
        a19: 'Noon Registration Email',
        tip: 'Warm Tips:',
        a20: 'Noon stores need manually synchronise order data',
        b1: 'After add your Noon store，please manually synchronise your store order data according to our user guide.',
        guide: 'User Guide',
        updateStore: 'Update Store',
        addSuc: 'Success!',
        storeManagement: 'Store management',
        orderManagement: 'Order management',
        b2: 'Being authorized.',
        b3: 'Please do not leave or close the screen',
        b4: 'Do not close the window until authorization is complete',
        b5: 'Validation complete',
        b6: 'Authorization failed. Please try again!',
        close: 'Close',
        reQuery: 'Re-query',
        b9: 'In order to automatically obtain order information, please go to your Cdiscount seller page to set up an API account and provide API related information below.',
        b20: "In order to automatically obtain the order information, please go to your onbuy seller\'s background to view the API information, and provide the API related information below.",
        b10: 'How to get store API information?',
        b11: 'Please enter the correct store address',
        b12: 'Input values cannot all be spaces',
        b13: 'Vendor number must be numeric',
        b14: 'The length is 1-64 bits',
        b18: 'The length is 1-200 bits',
        b15: 'Please enter the correct email address',
        b16: 'Successfully added!',
        b17: 'Store update authorization successful!',
        bRebind: 'The store is bound successfully！',
        b19: 'Because the store orders sent to the supervision department cannot be split, the total amount of data orders sent to the supervision department may be larger than the payment amount',
        c1: 'Please select whether to create a collection account',
        c2: 'NO',
        c3: 'YES',
        c4: 'The store authorized successfully，the assigned bank account number is',
        c5: 'View bank account information',
        c6: 'Store authorization succeeded. Please return to the previous page and continue to complete',
        c61: 'Store authorization failed, please contact your account manager.',
        c7: 'Associated bank account number',
        c10: 'Associated',
        c8: 'API account number',
        c9: 'API password',
        c11: 'The assigned bank account number is ',
        shopOrderManagement: {
            tranId: 'Batch number',
            quickSFName: 'Quick search for file name',
            upTime: 'Upload time',
            plat: 'Order type',
            fileName: 'File name',
            edu: 'Generate order quota',
            status: 'Status',
            up: 'Upload orders',
            a1: 'Do not add / delete / modify the header fields and their order (including Chinese header and English header) in the template;',
            a2: 'The same order number + logistics order number will be regarded as the same order. If your order contains multiple sub orders, please export the sub order or mark - 1 / - 2 on the main order number;',
            a3: 'According to the regulatory requirements, the order information will be used as the basis for RMB exchange settlement. Please ensure the authenticity of the information, otherwise the payment will be affected.',
            a4: 'It supports. XLS and. Xlsx files of no more than 20MB, and only one file can be added at a time',
            a5: 'Please upload order file',
            a6: 'Please download the template file ',
            a7: 'Drag the file over here, or',
            a8: 'Order type',
            a9: 'Platform name',
            submit: 'Submit order documents',
            a10: 'Great. The order has been submitted',
            a11: 'It may take some time to process the order file. Please wait patiently and check the details in the order management record after the file is processed.',
            a12: 'Continue to upload order',
            a13: 'View order List',
            a14: 'Download result file',
            a15: 'Your order ',
            a16: 'Numbers of success/failure parsing',
            a17: 'Failed to parse data download',
            d1: 'The order validity period for the quota is 180 days (about six natural months), please pay attention to the quota validity period in time. Avoid the amount of expired invalid affect normal use;'
        },
        c12: 'Please select the currency of collection account',
        c13: 'Please select the region to open the collection account',
        d1: 'Store registration information screenshot upload',
        d2: 'Make sure that the uploaded pictures are clearly visible, not exceeding 10M, supporting JPG, PNG and JPEG.',
        d3: 'How to view Amazon store registration information?',
        d4: 'Store registration information screenshot',
        d5: 'Audit rejection',
        cared5: 'Store audit failed, please rebind stores',
        d6: 'Collection account application submitted successfully. Please check the account later in the Global Collection- Bank Account Management.',
        d7: 'Collection account assigned successfully. Please check the account later in the Global Collection- Bank Account Management.',
        d8: 'Store binding successfully',
        d81: 'Store binding',
        d9: 'The store is successfully bound, please check the newly assigned bank account information in the Global collection-Account list later.',
        d10: 'Pending',
        d11: 'How to get Token information?',
        d12: 'Collection account assigned successfully.',
        d13: 'What is the effective order quota?',
        d14: 'it will be expired in 30 days. Please use it reasonably',
        d15: 'How to get order quota?',
        d16: 'Shop list',
        d17: "To meet the Chinese mainland\'s foreign exchange supervision policy, when you withdraw cash / payment, you need to provide the order information of the 180 days corresponding account to prove the rationality of the source of funds.",
        d18: 'iPayLinks will collect and generate your effective order quota in real time according to the rules in the past 180 days according to the order details obtained. You can initiate withdrawal / payment within the effective order quota; If the initiated amount exceeds the existing valid order amount, you need to obtain the order details again to update the amount.',
        d19: 'In view of the above rules, ',
        d20: 'it is recommended that you complete the withdrawal / payment within 180 days after the funds are recorded, otherwise your RMB payment experience may be affected.',
        d21: 'You can get it in the following four ways:',
        d22: '1、Bind your store to your iPayLinks account to get the quota, ',
        d23: '2、If you are bound with UAE and Saudi Arabia stores, you can obtain the quota by manually synchronizing the order data ,',
        d24: '3、If you are still unable to complete the above two ways, you can upload the order to obtain the quota through "order management",',
        d25: '4、You can always contact your account manager or online customers for assistance',
        d26: 'Payment order number',
        d27: 'Order creation time',
        d28: 'Status',
        d29: 'Quota',
        d30: 'Go to add',
        d31: 'Go to upload',
        d32: 'How to get the store info?',
        d33: 'How to add "Store info"',
        howAddShopUrl: 'How to get the store url',
        d34: 'Click add store, you need to log in to Amazon seller account, check the authorization agreement, and click continue to complete.',
        d34re: 'Click add collection account, you need to log in to Amazon seller account, check the authorization agreement, and click continue to complete.',
        d35: 'Please ensure that your authorization operation is performed in the common IP environment  to avoid Store Association.',
        d36: 'Jump authorization',
        d37: 'Fill in authorization information',
        d39: 'Go to Amazon for authorization',
        d40: 'E-commerce platform',
        d41: 'Independent stand',
        d42: 'Name of e-commerce platform',
        d43: 'Independent station name',
    },

    //账户设置
    accountSetting: {
        AccountName: 'Account Name',
        AccountNumber: 'Account Number',
        Website: 'Website',
        Individual: 'Individual',
        Enterprise: 'Enterprise',
        EntityInformation: 'Entity Information',
        EntityName: 'Entity name',
        farenzl: 'Legal person information',
        EntityInformation2: 'Entity Information',
        Industrytype: 'Industry type',
        EnterpriseFile: 'Enterprise File',
        EntityFile: 'Entity File',
        IDCard: 'ID Card/ Passport',
        Verified: 'Verified',
        country: 'Country',
        Youridentityfilling: 'Your identity for filling in the form',
        registerCountry: 'register Country',
        BusinessLicense: 'Business License / Company registration Certificate / Business Registration Certificate / Partnership Agreement Picture',
        AddNewUser: 'Add New User',
        AddNewRoles: 'Add New Roles',
        editUser: 'Edit User',
        editRoles: 'edit Roles',
        Operations: 'Operations',
        Email: 'E-mail',
        Username: 'Username',
        Roles: 'Roles',
        Users: 'Users',
        Role: 'Role',
        ModifiedTime: 'Modified Time',
        Status: 'Status',
        Edit: 'Edit',
        Delete: 'Delete',
        Choosearole: 'Choose a role',
        Noroleyouneeded: 'No role you needed? Add roles in “Roles”',
        RoleName: 'Role Name',
        RoleDescription: 'Role Description',
        Operablepermissions: 'Operable permissions',
        AccountSecurity: 'Account Security',
        Securityverification1: 'Security verification has been enabled, and dynamic verification code will be sent to',
        Securityverification2: 'Security verification is disabled, dynamic verification code will be sent to your email or mobile phone before tranactions',
        Securityverification3: 'Security verification is disabled, and dynamic verification code will not be sent to',
        Edit2: 'Edit',
        verificationsentto: 'verification code will be sent to',
        verificationcode: 'verification code',
        Confirm: 'Confirm',
        Cancel: 'Cancel',
        UserInfo: 'User Info',
        Basicinfo: 'Basic info',
        PhoneNumber: 'Phone Number',
        ResetPassword: 'Reset Password',
        characters: '8 ~ 20 characters, including only letters, numbers, and punctuation marks (except spaces). Letters, numbers and symbols contain at least 2 kinds. Letters are case sensitive',
        newcharacters: 'The password length must be at least 8 characters. The password is composed of characters that can be supported by the system and must include numbers, letters and special characters at the same time（!#@?.+;=~`）',
        manager: 'For the account security, security verification cannot be modified, if necessary you can contact your customer manager.',
        Toensure: 'To ensure the safety of your funds, the verification will be sent to',
        enterRolesName: 'please enter role name',
        enterRolesDescription: 'please enter role description',
        reSent: 'resend',
        // pleasesetphonenumber: 'please set phone number / e-mail as the security verification method',
        pleasesetphonenumber: 'please set phone number as the security verification method',
        choosepermissions: 'choose permissions',
        enabledsuccessfully: 'enabled successfully',
        disabledsuccessfully: 'disabled successfully',
        cannotbemodified: 'cannot be modified',
        gotit: 'got it',
        Newuserscreatedsuccessfully: 'New users created successfully',
        Pleaseremindpassword: 'Please remind the user to check email and he/she can login after setting the password',
        Deletecontinue: 'Delete this user? continue?',
        Deletecontinue2: 'Delete this roles? continue?',
        Permissions: 'Permissions',
        successfully: 'successfully',
        tips: 'Tips',
        deleteSuccess: 'Delete Successfully',
        next: 'Next',
        Mobileboundsuccessfully: 'Mobile phone bound successfully',
        Unbound: 'Unbound',
        Verifymailbox: 'Verify the original mailbox',
        Verifymobilephone: 'Verify the original mobile phone',
        Isavailable: 'Is the original mailbox available?',
        CanSMS: 'Can the original mobile phone receive SMS?',
        Cannotreceive: 'Cannot receive',
        Contactforhelp: 'Contact your account manager for help.',
        Canreceive: 'Can receive',
        bindmailbox: 'Bind mailbox',
        Modifymailbox: 'Modify mailbox',
        bindPhone: 'Bind Phone',
        ModifyPhone: 'Modify Phone',
        ModifySuccess: 'modify successfully',
        modifyUsername: 'Modify Username',
        modifyAccountName: 'Modify Account Name',
        Passwordupdated: 'Password has been updated',
        CurrentPassword: 'Current Password',
        NewPassword: 'New Password',
        Newpasswordcurrentone: 'New password cannot be the same to the current one',
        NewPasswordempty: 'New Password cannot be empty',
        passwordaboveone: 'The password is not different from the above one',
        entercurrentpassword: 'Please enter the current password',
        enternewpassword: 'Please enter the new password',
        confirmNewPass: 'confirm new password',
        Inorderfirstly: 'In order to keep you normally use iPayLinks services, please verify the account firstly',
        View: 'View',
        completedverification: 'Completed the real-name verification of your account',
    },
    //店铺迁移
    storeTransfer: {
        trans: 'Store transfer',
        chooseTrans: 'Please select the store to be transferred',
        chooseTrans2: 'Please select the store platform you want to transfer first',
        selectPlat: 'Platform site',
        searchName: 'Quick search shop name',
        a1: 'Store to be transferred',
        a2: 'Please select the store to be transferred from the left',
        a3: 'Please fill in the recipient account information',
        a4: "After submitting the transfer application, the store and the corresponding available order quota will be transferred to the receiver's account(if the store has an associated collection account number, the corresponding collection account number and unrecorded funds will also be transferred). Please confirm that the account number of the receiving party is filled in accurately and check the name of the receiving party carefully.",
        a5: 'How to check account number?',
        a6: 'Recipient account number',
        a7: "Please fill in the recipient\'s account number",
        recipientName: 'Recipient name',
        a8: 'Please fill in the account number and check',
        confirmTrans: 'Confirm Transfer',
        a9: 'Recipient account information',
        a10: 'After logging in to iPayLinks, you can view the account number at the top left of the menu, or enter the "Account Settings-Account Information" page to view the account number:',
        a11: 'Check the recipient name',
        a12: "After accurately filling in the recipient\'s account number, please check the recipient\'s personal or company name (the name is subject to the account information page).",
        know: 'I know',
        confirmStore: 'Store transfer confirmation',
        a13: 'You can apply to transfer your store to another iPayLinks account.',
        a14: "The available order limit of the transferred store will be added to the recipient\'s account after the transfer is completed.",
        a19: "When a store has an associated collection account number, the store, its collection account number and unrecorded funds will all be transferred to the receiver's account.",
        apply: 'Apply for store transfer',
        in: 'Transfer in record',
        out: 'Transfer out record',
        qysh: 'STORE CHECKING',
        faqi: "Sponsor",
        jieshou: 'Receiver',
        time: 'Time',
        status: 'Status',
        plat: 'Platform site',
        a15: 'The receiver account number',
        a16: 'The Sponsor account number',
        backList: ' the store transfer list',
        a17: 'Confirm to transfer ',
        shop: ' store',
        modify: 'Back to modify',
        suc: 'Success',
        a18: 'Transfer failed. The corresponding collection account in the store to be transferred is also associated with other stores',
        transferReason: 'Transfer reason',
        a20: 'No relation between your two entity, please upload relationship files such as agreement.',
        a21: '仅支持png,jep,jpeg,pdf',
        a22: '最大不超过2M',
        a23: 'Store migration description',
        a24: '1)  Notes on Collection Account Number / Store transferring ',
        a25: 'If the collection account is bound to the store, the two will be transferred together when the account / store is transfered ;If multiple stores are bound under a collection account, you can not only transfer some stores, but only all of them;',
        a26: '2) Notes on the rate of "collection account number / store transferring"',
        a27: 'The system will automatically select the optimal rate between the rate of account a and that of account B. if the rate cannot be selected successfully (possibly due to different rate modes), the rate of account B will be maintained. If you need to adjust, you can contact your account manager.',
        a28: '3) Notes on the preferential policy of "collection account number / store transferring"',
        a29: 'The relevant preferential benefits are limited to the current account and will not change with the account number / store transferring.',
        a30: '4) Notes on the entry of "collection account number / store transferring":',
        a31: 'After the collection account number is transferred, the collection entry will belong to the new account. If only the store is transferred and the collection account number is not transferred, the collection will be recorded in the original account. If the recorded funds of the original collection account number want to be transferred to the new account, please operate through "transfer".',
        a32: '5)Notes on CNY Quota ',
        a33: 'After the store is transferred, the unused   CNY Quota of the store will also be transferred to the new account.',
        a34: 'Description',
        a35: 'Submitted successfully',
        a36: 'Please describe the reason',
        a37: 'Shop ID',
        a38: 'Please upload the information',
        a39: 'Approved'
    },
    //    收款账号迁移
    accountTransfer: {
        trans: 'Collection account transfer',
        a1: 'You can apply to transfer your collection accounts to another iPayLinks account.',
        a2: 'Quick search bank account',
        a3: 'Please enter the Sponsor account number',
        a4: 'Please enter bank account',
        a5: 'Currency',
        a6: 'Nickname',
        a7: 'Apply for collection account transfer',
        a8: 'Quickly search for nickname or bank account',
        a9: 'All collection accounts',
        a10: 'Collection account to be transferred',
        a11: 'Please select the collection account to transfer from the left',
        a12: 'Please fill in the recipient account information',
        a13: 'After submitting the transfer application, the corresponding collection account (and the collection amount not yet recorded) will be moved to the receiver\'s account (if the collection account number is associated with the store, the corresponding store and the corresponding available order amount will also be transferred). Please confirm that the account number is filled in accurately and check the account name and other relevant information carefully.',
        transferList: 'Collection account transfer list',
        a14: 'Please select the collection account to be Transferred',
        collectionaccount: 'collection account',
        Selected: 'Selected',
        a15: 'Why stores need to be bound?',
        a16: 'I know',
        a17: "1. The purpose of binding stores is to meet the compliance requirements of China\'s foreign exchange supervision. All funds entering the country need to prove the legal source of funds.",
        a18: '2. iPayLinks promises to keep all the business information provided by your store strictly confidential, and will not provide the information to any unit or individual that has nothing to do with your collection service, or use the business information for any other business purpose other than collection. For details, please refer to "user registration agreement" and "privacy agreement"'
    },
    //钱包
    wallet: {
        walletDetail: 'Wallet details',
        balance: 'Balance',
        recharge: 'Add Money',
        set: 'Currency Display Settings',
        tranId: 'Transaction ID',
        tranType: 'Transaction Type',
        fundType: 'Fund Type',
        time: 'Settlement Time',
        amount: 'Transaction Amount',
        miaoshu: 'Description',
        yue: 'Balance After',
        keyongyue: 'Available',
        dongjie: 'On Hold',
        a1: 'Balance that can be used for sending money or exchange',
        a2: 'Balance that temporarily locked and cannot be used',
        transactionId: 'Transaction ID',
        tranAmount: 'Transaction Amount',
        holdDetail: 'On Hold Balance Detail',
        downloadLiu: 'Balance History',
        download: 'Download',
        holdTime: 'Creation Time',
        holdReason: 'Description',
        quickSearch1: 'Quick search transaction ID',
        quickSearch2: 'Quick search transaction ID',
        addBalance: 'Add Money to Balance',
        chooseCurrency: 'Which balance you want to add',
        available: 'Available balance ',
        a3: 'To add balance, please transfer sufficient amount to the following bank account via your own bank. ',
        newa3: 'If you use this function for the first time, please be sure to contact the account manager to make a report, so as to ensure that your funds can be smoothly transferred to the account. Otherwise it may be returned and refund commission will be incurred.',
        bankLocation: 'Bank Location',
        accountName: 'Bank Account Name',
        swift: 'SWIFT Code',
        bankCode: 'Bank Code',
        branchCode: 'Branch Code',
        accountNumber: 'Bank Account Number',
        Reference: 'Reference',
        a4: 'Reference is how we locate your balance account, it must be written correctly when you transfer funds.',
        newa4: 'We will confirm the account to which you recharge through the postscript. Please be sure to fill in the postscript correctly when transferring the account.',
        a5: 'It usually takes 2~3 days for funds to arrive, please transfer funds a few days in acvance to avoid any transaction delays.',
        a6: 'Your bank may charge transfer fees, please make sure that the transfer amount is sufficient to avoid insufficient balance.',
        a7: 'We will add your balance immediatly once receiving bank settlement confirmation.',
        a11: 'Please fill in the bank account information correctly. If the funds are returned due to your wrong operation, the refund cost will be borne by you.',
        a12: 'The refund deduction is 1 ~ 30USD / GBP, which is subject to the actual expenses incurred by the bank;',
        toExchange: 'Go to Exchange',
        turnover: 'Turnover',
        display: 'Balance Display',
        currencyBalance: 'Currency with Balance',
        a8: 'To avoid missing important information, currencies with available balance will be automatically displayed in balance list.',
        otherCurrency: 'Currency',
        a9: 'You can choose whether to display the following currencies in the balance list',
        jl: ' Statement',
        a10: 'For the smooth entry of your funds, please use the bank account with the same name as the registrant to make payment to the recharge account we provided to you.',
        newa10: 'In order to deposit your funds smoothly, please use ',
        newa11: 'the bank account with the same name as the registrant ',
        newa12: 'to transfer the funds to the bank account provided by us through online banking or offline transfer. The funds charged to the bank account without the same name will be returned.',
        szlx: 'Debit/Credit type'
    },
    // 付款
    sendMoney: {
        my: 'Myself',
        other: 'Others',
        pleaseSElect: 'Please select beneficiary account ',
        addNew: 'Add New',
        addNew2: 'Add New',
        send: 'Send Money',
        recipient: 'Recipient',
        amount: 'Amount',
        detail: 'Details',
        send2: 'Send',
        toChina: 'Send money to China mainland',
        guide: 'User Guide',
        regulation: 'Please be aware of regulations:',
        a1: 'Order information that proves the source of funds is required to meet the regulatory requirement to send fund into China.',
        a2: 'You can provide this information by linking your e-commerce store to your iPayLinks account.',
        next: 'Next: amount',
        sendTo: 'Send money to ',
        a3: 'Your current order limit',
        a4: 'Bank Account of other person or company',
        a5: 'Bank Account of your own or your company',
        a6: 'How much are you sending',
        buchongxinxi: 'Supplementary Details',
        date: 'Sending Date',
        purpose: 'Purpose',
        reference: 'Reference',
        nextDetail: 'Next: Details',
        nextSend: 'Next: Review and Send',
        receive: 'Estimated Receiving',
        sendAmount: 'Sending Amount',
        receiveAmount: 'Estimated Receiving Amount',
        total: 'Your Total',
        feeDetail: ' Fee Details',
        nickName: 'Recipient Nickname',
        bankName: 'Recipient Bank Account Name',
        currency: 'Sending Currency',
        bankLocation: 'Recipient Bank Location',
        recipientInfo: 'Recipient Information',
        bankAccountName: 'Bank Account Name',
        totalFee: 'Total fee',
        a7: 'Fee paid by payer',
        fee1: 'Fixed Fee',
        fee2: 'Percentage Fee',
        fee3: 'Extra charge',
        Coupons11: 'Coupons Discounted Amount',
        a8: 'Confirm your sending details',
        payMethod: 'Payment Method',
        amountSum: 'Amount Summary',
        rate: 'Exchange Rate',
        a9: 'Order information required',
        a10: 'Please provide order information for sending fund  to China mainland before continue',
        a11: 'Provide Order',
        a12: 'Total Fee',
        a13: 'Your Total',
        a14: 'Date and Reference',
        a15: 'Great, send money submitted',
        a16: 'You just sent',
        a17: 'to',
        a18: 'Your totally paid from balance',
        a19: 'Please confirm amount before sending',
        a20: 'Fee Amount',
        b1: 'Exchanged rate has been refreshed',
        b2: 'Back to Edit',
        b3: 'Confirm and Send',
        download: 'Download History',
        max: 'Max',
        maxTitle: 'Max Sending Amount',
        maxMes: 'Maximum sending amount according to available balance (including fee).',
        normallyTake: 'Normally take',
        // daoZhang:'and with',
        daoZhang: '',
        daoZhangEnd: 'limit',
        noAccounts: 'No Accounts, please add an account firstly',
        addNewAccount: 'Add a New Account',
        brmc: 'The name below will be displayed on the beneficiary\'s statement',
        brmc1: 'Charged function,pease check it in "total expenses" next page',
        defaultIpl: 'iPayLinks will be default as the payer\'s name, if you want to change to your name, please check the box.',
        fkfmc: 'Payer\'s name',
        sufficientBalance: 'Sufficient Balance',
        insufficientBalance: 'Insufficient Balance',
        rmbedzg: 'CNY Quota is sufficient',
        rmbedbz: 'CNY Quota is insufficient',
        purposeDesc: 'Purpose Description',
        taxNo: 'Purpose Description  please describe the purpose',
        branchName: 'Branch Name',
        paymentPurpose: 'Payment Purpose',
        paymentReference: 'Payment Reference',
        paymentReferencex: 'Payment Reference(Optional)',
        sdhl: 'This payment provides you with a locked exchange rate',
        hldjs: 'Exchange rate may change after the countdown, please pay attention on amount changes',
        gzddztbh: 'Estimated received on',
        yjdjs: 'You can check the status in payment history',
        continuePayment: 'Create Payment',
        viewDetails: 'View details',
        yzmfsz: 'For your account security, verification code will be sent to',
        securityVerification: 'Security Verification',
        inputVerificationCode: 'Please enter verification code',
        srzzs: 'Please enter positive integer amount',
        srlwxs: 'Please enter the amount with two decimal places',
        jyfy: 'Please input transaction reference',
        onlyAllowed: 'Spaces need to be in English half width',
        Supportnumbersandspaces: 'English letters, numbers, spaces only',
        VerificationCode: 'Verification Code',
        pstpc: 'Please select the payment currency',
        qxzskbz: 'Please select  beneficiairy\'s account currency',
        qxzskr: 'Please select the beneficiary',
        qxzjyyt: 'Please select the payment purpose',
        cdbcg255: 'Cannot exceed 255 characters',
        qsrytms: 'Please enter the purpose description',
        qsrswsbhm: 'Please enter the ',
        cdbcg20: 'Cannot exceed 20 characters',
        transactionID: 'Transaction ID',
        BatchPaymentID: 'Batch Payment ID',
        to: 'to',
        payerNickName: 'Payer Nickname',
        bankNameOnly: 'Bank Name',
        fkbz: 'Receiving Currency',
        fkrq: 'Sending Date',
        yhszd: 'Bank Location',
        upTo31Days: 'Up to 31 days',
        processing: 'Processing',
        fkjr: 'Payment History',
        all: 'All',
        fkg: 'Pay to',
        jsz: 'Tax to',
        fkpz: 'Payment Files',
        ddjcxx: 'Basic Information',
        ddzt: 'Order Status',
        sbyy: 'Reasons',
        fkrxx: 'Payer Information',
        fkrmc: 'Payer\'s Name',
        tpje: 'Refund Amount',
        tpxx: 'Refund Information',
        tksxf: 'Refund Fee',
        tpsj: 'Refund Time',
        tpyy: 'Refund Reason',
        qxzbz: 'Please select currency',
        Personal: 'Personal',
        enterprise: 'Enterprise',
        zbzcxclxskrfk: 'Cannot pay to Beneficiary of this type',
        qsrqbnr: 'Please submit after filling all the info',
        sjcf: 'Duplicate date is not allowed',
        xzcg: 'Download successfully',
        qxzskdq: 'Please select location',
        qxzskrlx: 'Please select beneficiary type',
        tj: 'Add New',
        rechargecontinuing: 'Please recharge before continuing',
        dbfk: 'Single Send Money',
        b4: 'Min: ',
        b5: 'Max:',
        b6: 'Min: ',
        b7: 'Max:',
        ddcjsj: '订单创建时间',
        ddlx: '订单类型',
        //    批量付款
        bulkPayment: {
            Paymentlist: 'Payment list',
            returnBack: 'Back to List',
            bulkPayment: 'Batch Payment',
            id: 'Batch Id',
            time: 'Upload Date',
            fileName: 'File Name',
            num: 'Numbers of files',
            status: 'Status',
            create: 'Create New',
            pId: 'Batch Id',
            createNew: 'Create New Batch',
            uploadFile: 'Upload Batch Files',
            p1: 'Check Details',
            p2: 'Payment maybe failed for exchangerate fluctuations and balance issufficience .Please check details on payment list.',
            p3: 'Processing, please check the detail later',
            a1: 'Befer filling the excel, please refer to the requirements and examples in the batch payment file template you downloaded.',
            a2: 'If there is no file template or payment country, payment currency and other information has been changed, please firstly add',
            a3: 'Download the template',
            a4: 'Upload the file',
            a5: 'Support no more than 20MB. Xlsx format file, support up to 1000 batch payments',
            pTemp: 'Batch Payment Template',
            a6: 'Different payment countries, payment methods and payee types require different payment information. Please select and download the template below',
            a7: 'Certain Payment Amount',
            a8: 'Certain Payment Amount',
            No: 'No',
            payTo: 'Pay to',
            accCurrency: 'Account Currency',
            accType: 'Account Type',
            noData: '',
            pleaseAdd: 'Please Add',
            downTem: 'Download Template',
            downing: 'Processing',
            uping: 'Uploading',
            a9: 'Considering the exchange rate fluctuations, payment fees and other factors, Please make sure that the balance issufficient . If payment is to China mainland , please ensure that the available CNYquota is enough to avoid payment failure.',
            a10: 'After submitting the batch payment file, please check the payment details and final result in the list.',
            submit: 'Submit',
            a11: 'Upload',
            sucTitle: 'Amazing, You have submited the batch successfully',
            a12: 'Your batch payment ',
            a13: ' is in process.',
            payNum: 'Files in the batch',
            a14: 'It will take some time to process this batch, please press the button “Check the details” below.',
            toPay: 'Create New Batch',
            toDetail: 'Check Details',
            a15: 'Duplicate file name, please check and modify the name.',
            qck: 'Please enter the info by following <span style="color: #34495e;font-weight: bold">the rules in the template</span>',
            tips: 'Tips',
            zzjc: 'Checking details...',
            zzjy: 'The system is checking the details, please donot leave or close this page',
            plfkqr: 'Confirm the batch payment',
            wjjywc: 'Checking finished,you will pay',
            bh: 'including',
            bi: '', //就是空
            fk: 'payment.',
            wlzhaq: 'For your account security, please submit it after verification. The verification code will be sent to ',
            qsryzm: 'Please enter verification code',
            tj: 'Submit',
            bfk: 'payments',
            qclcw: 'Please modifying the incorrect payments',
            cwfkxx: 'Wrong payment information, such as wrong format, missing required fields and other reasons.',
            qxzjgwj: 'Please Download the result file, and reupload the file again after modifying it according to the failure reason',
            xzjgwj: 'Download Result File',
            wjbncg100MB: 'Up to 20MB',
            wjbncg2MB: 'Up to 2MB',
            xlsxOnly: 'only supports.XLSX',
            Processing: 'Processing',
            verificationCode: 'Verification Code',
            retryAfter: ' seconds retry',
            VerificationCode: 'Verification Code',
            ksssplfkwjm: 'Quick search for batch payment file name',
            submitPay: 'Confirm',
            batchpaymentfilename: 'batch payment file name',
            confirmSubmit: 'Confirm',
            plfklb: 'List',
            a16: 'Please check the balance before uploading.'
        },
        b8: 'No more than 10M, support ZIP, RAR format',
        b9: ' file compression package',
        b10: 'Payment of large amount could be split into several smaller amount\n',
        b11: 'Coupons discounted',
        b12: 'Donot use coupons',
        SHA: 'SHA：Both share the charges of intermediary bank;（different charges for different intermediary banks)',
        OUR: 'OUR：Payer bears the intermediary bank charges;（different charges for different intermediary banks)',
        BEN: 'BEN：Payee bears all intermediary bank charges;（different charges for different intermediary banks)',
        b13: 'Insufficient quota',
        b14: 'Reasons for your insufficient quota:',
        b15: "5.If you can\'t confirm the reason for your insufficient quota, please contact customer service (right sidebar) to deal with it",
        b16: 'Bank processing'
    },
    //    收款人
    payee: {
        recipients: 'Recipients',
        newPayee: 'New Recipients',
        bankLocation: 'Bank Account Location',
        type: 'Recipient Type',
        currency: 'Account currency',
        bankNo: 'Bank Account No',
        bankInfo: 'Bank Account Information',
        a1: 'Bank Recipient Phone No',
        phone: 'Recipient’s Phone Number',
        email: 'Recipient’s Email',
        add: 'Recipient’s Address',
        addressRequired: "Please enter recipient's address",
        addressInvalid: 'Only letters (A-Z, a-z), numbers, spaces, and the following symbols are allowed: / ( ) . , - ? : #. Line breaks are not allowed and it cannot be numbers only.',
        post: 'Recipient’s Postcode',
        option: ' (Optional)',
        contactInfo: 'Contact Information',
        identityInfo: 'Identity Information',
        occ: 'Recipient Occupation',
        idType: 'ID Type',
        deleteP: 'Delete Recipient',
        delete: 'Delete',
        newPayees: "New Recipient",
        a2: 'Please set a nickname for your own quick research',
        a3: 'Recipient’s nickname',
        save: 'Save',
        a4: 'Please input account location and currency first to check available payment methods',
        p1: 'Edit payee',
        p2: 'Beneficiraies in China Mainland is required to provide ID certificate.',
        p3: 'Size:up to 5 MB and please make sure the picture is clear and the four sides are clearly exposed',
        p4: 'Example',
        p5: 'Please confirm the ID number',
        p6: 'Business License',
        p7: 'Please enter business license',
        p8: 'Please upload the front and back image of your ID card',
        p9: 'Please upload the business license',
        p10: 'Please upload the image of your ID card',
        p11: 'View all',
        p12: 'Please choose the name of legal person',
        p13: 'Enter the correct account name',
        p14: 'other beneficiries',
        p15: 'pay to individual account of China Mainland, please enter the account of legal person\'s account, and make sure the account name and account number are correct.',
        p16: 'only can pay to your own company account of China Mainland, and please add the account in "my own account"',
        list: 'Recipients list',
        accountDetail: 'Account detail',
        payeeDetail: ' detail',
        onlySpace: 'Spaces, special characters, etc. also need to be in English format',
        onlySpace2: 'Spaces need to be in English half width',
        classify: 'Classification of payee',
        classify2: 'Classification',
        //    缴税机构
        taxpayer: {
            newTaxpayer: 'New Tax Institute',
            editTaxpayer: 'Edit Tax Institute',
            addTaxpayer: 'Add Tax Institute',
            taxpayer: 'Tax Institute',
            taxType: 'Tax Institute Account type',
            taxLocal: 'Location',
            taxCurrency: 'Tax Currency',
            taxpayerName: 'Tax Institute Account Name',
            placeEnterTaxpayerName: 'Please enter ',
        }
    },
    // 提现
    withdraw: {
        w1: 'Create My Own Account',
        editAccount: 'Edit My Own Account',
        AccountNickname: 'Account Nickname',
        w2: 'Please give a nickname for convenience',
        w3: 'please enter the first name',
        BeneficiaryType: 'Beneficiary Type',
        enterprise: 'Enterprise',
        personal: 'Personal',
        companyName: 'Company Name',
        inputCompanyName: 'Please Input Company Name',
        zhangsan: 'Zhang San',
        firstName: 'First Name',
        lastName: 'Last Name',
        w4: 'Please enter the last name',
        w5: 'Account Location',
        w6: 'Please select the location',
        accountCurrency: 'Currency',
        w7: 'Please select the currency',
        w8: 'Please select the currency and location to check the payment method',
        w9: 'Payment to this country is not supported at this time',
        w10: 'Beneficiary ID certificate is required',
        w11: 'Please upload beneficiary ID certificate',
        w12: 'Please select the Account Name',
        w13: 'Please select the Bank Name',
        w14: 'Please enter bank\'s full name ',
        branchName: 'Branch Name',
        w15: 'Please select the branch name',
        w16: 'Bank Phone No',
        w17: 'Please input the bank phone No',
        w18: 'Please input',
        w19: 'English Characters only',
        w20: 'CNAPS CODE  search CNAPS CODE',
        w21: 'If you only have IBAN, please enter the last 8 number.',
        w22: 'Please input the branch number together',
        w23: 'Identification Info',
        occupation: 'Occupation',
        w24: 'Select occupation',
        w25: 'ID card information',
        w26: 'Front image of ID card',
        w27: 'Back image of ID card',
        w28: 'Invalid ID card',
        w29: 'ID number',
        w30: 'Please enter ID number',
        w31: 'Only for citizens of China Mainland',
        w32: 'Company Info',
        w33: 'Image of License',
        w34: 'License Number',
        w35: 'Please Input License Number',
        w36: 'Only China Mainland companies',
        w37: 'Contact info',
        w38: 'Phone Number',
        w39: 'Please enter the phone Number',
        w40: 'Email(Optional)',
        w41: 'Please enter the email',
        w42: 'Address',
        w43: 'select Countries',
        w44: 'Select state/ Province',
        w45: 'Select cities',
        w46: 'Please enter the address',
        w47: 'Postcode',
        w48: 'Please enter the postcode',
        save: 'Save',
        w49: 'Enter phone number',
        w50: 'Enter the correct phone number',
        w51: 'Cannot enter Chinese Characters',
        w52: 'Only upper and lower case letters, numbers, spaces',
        w53: 'Please input englis chracter',
        w54: 'Only upper and lower case letters, numbers, spaces and-,.',
        w55: 'Please enter the nick name',
        w56: 'Up to 50',
        w57: 'Please enter the company name',
        w58: 'Up to 256',
        w59: 'Up to 20',
        w60: 'Please enter address',
        w61: 'Please enter email',
        w62: 'Select the id type',
        w63: 'Please the id number',
        w64: 'Select',
        w65: 'Select currency',
        w66: 'Please enter bank name',
        w67: 'Please enter branch name',
        w68: 'Please enter account number',
        w69: 'Please enter phone number',
        w70: 'Please select payment method',
        w71: 'Please select occupation',
        w72: 'Create successfully',
        w73: 'Please enter the password',
        w74: 'Please input correct ',
        w75: 'Verifying, please wait a few minutes',
        w76: 'Verification in progress',
        w77: 'Bank info verified failed, please check the details',
        w78: 'Failed',
        w79: 'Basic Info',
        w80: 'First Name',
        w81: 'Last Name',
        w82: 'Delete?',
        w83: 'Tips',
        w84: 'Confirm',
        w85: 'Cancel',
        w86: 'Processing',
        w87: 'Deleted successfully',
        w88: 'My Own Account',
        a4: 'Please input account location and currency first to check available payment methods',
        Onlyspaces: 'Only supports English letters, numbers, spaces and',
        enterregistrationemail: 'please enter email',
        entername: 'please enter the name',
        w89: 'Only upper and lower case letters, numbers, spaces and,.',
        w90: 'Only Chinese Characters, upper and lower case letters, numbers, spaces and,.',
        w91: 'Only Chinese Characters, upper and lower case letters, numbers, spaces and,. :&()@*;_- — ——',
        w92: 'Only upper and lower case letters, numbers, spaces and,.: &()@*;_- — ——',
        w93: 'Only Chinese Characters, upper and lower case letters, numbers, spaces and,.: &()@*;',
        w95: 'Only upper and lower case letters, numbers, spaces and,.: &()@*;',
        w94: 'Some special characters are not supported in some banks, for your payment  sent timely, we will automatically move these chacters.'
    },

    transfer: {
        Transfer: 'Transfer',
        TransferAmount: 'Transfer Amount',
        Purpose: 'Purpose',
        Confirmyourtransferdetails: 'Confirm your transfer details',
        Transferto: 'Transfer to Other IPL Account',
        Transferto2: 'Transfer to',
        enterAccountNo: 'Please enter the Account No',
        BeneficiaryName: 'Beneficiary Name',
        Max: 'Max',
        maxfee: 'the max amount is the amount that deduct the fee',
        Totalamount: 'Total amount',
        Accountbalance: 'Account balance',
        Sufficientbalance: 'Sufficient balance',
        Insufficientbalance: 'Insufficient balance',
        Details: 'Details',
        Pleaseselectpurpose: 'Please select purpose',
        PurposeDescription: 'Purpose Description',
        enterpurposedescription: 'Please enter purpose description',
        TransferDate: 'Transfer Date',
        TransferingDetails: 'Transfering Details',
        DateReference: 'Date and Reference',
        Transfersuccessfully: 'Transfer submitted successfully',
        Transferfailed: 'Transfer failed, please try again',
        TransferHistory: 'Please check the status in Transfer History',
        CNYtogether: 'CNY quota will be transfered together.',
        CreateTransfer: 'Create Transfer',
        Checkdetails: 'Check details',
        Backto: 'Back to',
        verificationsentto: 'For your account security, verification code will sent to',
        VerificationCode: 'Verification Code',
        Cancel: 'Cancel',
        Submit: 'Submit',
        Pleaseenteramount: 'Please enter a correct amount',
        Pleaseenteplaces: 'Please enter the amount to two decimal places',
        Transferthan0: 'Transfer Amount must be greater than 0',
        Pleaseenterreferences: 'Please enter references',
        Onlyallowed: 'Only half width spaces are allowed',
        Supportnumbersspaces: 'Support upper and lower case English letters, numbers, spaces',
        Transferreference: 'Transaction reference',
        TotalAmount: 'Total Amount',
        FailedReason: 'Failed Reason',
        BeneficairyInfo: 'Beneficairy Info',
        BeneficiaryEntityName: 'Counterparty name',
        ReceivingAmount: 'Receiving Amount',
        enterBeneficiaryname: 'Please enter Counterparty name',
        searchbeneficiaryname: 'Search Counterparty name',
        sizetotally: 'size:up to 10M totally',
        upto10files: 'up to 10 files',
        max31days: 'date range：max 31 days',
        History: 'History',
        enterTransferreference: 'Transaction reference',
        transferdetails: 'Transfer details',
        BeneficiaryAccountNo: 'Counterparty Account No',
        enterBeneficiaryAccountNo: 'Counterparty Account No',
        enterOrderId: 'transaction ID',
        selectStatus: 'please select status',
        a4: 'Please input account location and currency first to check available payment methods',
        a5: 'Transfer transaction list',
        AccountStatement: 'Account Statement',
        dbzz: 'Single transfer',
        a6: 'Transfer to IPL Account',
        dsfmc: 'Counterparty name',
        dsfzhhm: 'Counterparty Account No',
        zhjy: 'Transfer Transaction',
        dbzjdd: 'Fund order to be replenished',
        yydh: 'Reservation Number',
        sxsj: 'Invalid Time',
        qxyy: 'Cancel',
        ckyylb: 'Viewing the Reservation List',
        qxyy2: 'Cancellation Reasons',
        qxyy3: 'Please enter cancellation reason (less than 100 words)',
        xybc: 'You need to supplement now：',
        yyzzts: 'Please make up the balance as soon as possible, and the transaction will be closed automatically after 72 hours',
        ckzzlb: 'Transfer list'
    },
    //    账户关系 -- 平台账户
    merchants: {
        myMerchantsList: 'My Merchants',
        myMerchants: 'Merchants',
        addMerchants: 'Add Merchant',
        registerLink: 'Reference Link',
        quickQuery: 'Quick Search Account No',
        accountNo: 'Merchant Account No',
        shitiName: 'Merchants Name',
        faqiMethod: 'Registration Method',
        faqiPerson: 'Creator',
        faqiTime: 'Creation Time',
        lookAll: 'Check Details',
        a1: 'Check All the transactions',
        a2: 'You can check all the states and balances of your merchants.',
        a3: 'Send Reference Link to your merchants, aftering signed up, you can see them here.',
        zhuLink: '主子账户链接 ',
        daiLink: '代理与商户链接 ',
        saccountNo: 'Merchant Account No',
        accountType: 'Account Relation Type',
        shouquan: 'Authorization',
        cshouquan: 'Check',
        balance: 'Account Balance',
        turnover: 'Account Statement',
        currency: 'Currency',
        keyongBalance: 'Available Balance',
        yezhlx: 'Account Type',
        frozen: 'Available Balance',
        daijiesuan: 'Balance',
        baozhengjin: 'Deposit Balance',
        dingdanhao: 'Transation ID',
        yewuType: 'Business type',
        ruzhangTime: 'Settlement Time',
        jiaoyiAmount: 'Transaction Amount',
        zijinmiaoshu: 'Description',
        shouquanManagement: 'Authorizations',
        shouquanren: 'Operator',
        checkAuth: 'Check',
        reAuthorization: 'Renew',
        qrReAuth: 'Confirm',
        a4: 'After renewing, the merchant can check the new authorizaion.Please confirm the operation',
        agree: 'Accept',
        reject: 'Reject',
        ljsq: 'Authorize',
        ysq: 'Authorized',
        yjj: 'Rejected',
        operateSuccess: 'Successfully',
        jcsq: 'Cancel Auth',
        cxsq: 'Renew',
        shzc: 'Merchant registration',
        jylx: 'Transaction Type',
        rzrq: 'Settlement Date',
        zjlx: 'Fund Type',
        returnList: 'Return List',
        goCreate: 'Continue',
        a5: 'Confrim to delete?',
        zhyelx: 'Balance Type',
        a6: 'Please confirm the operation.'
    },
    agreement: {
        a1: 'How to bind Shopify stores',
        a2: '1. Open the store management page and click the <b>“+ add new store”</b> button: ',
        a3: '2. To view the list of platform sites, select <b>"Shopify:</b>',
        a4: '3.Enter your store URL and click the <b>"add store" </b> button: ',
        a5: '4.You will automatically jump to the Shopify login page, enter the password and click the login button to login:',
        a6: 'Note:',
        a7: 'If you have been associated with Shopify stores in ipaylinks, click "+ add new store" to directly log in to the associated Shopify stores. When you continue to associate with the second store, you only need to exit the current store on the Shopify platform and enter the account number and password of the store to be associated for authorization.',
        a8: '5. View the information and agreement content, and click the ”install unlisted app ”button to authorize:',
        a9: '6.The authorization is successful, and the association with Shopify platform is successful. You can view the binding platform information in store management:',
        amazon: {
            a1: 'How to obtain MWS authorization token',
            a2: 'Step 1:',
            a3: 'Log in to Amazon seller center with the corresponding computer environment of your store:',
            a4: 'Step 2:',
            a5: 'Click 「Partner Network」Manage Your Apps;',
            a6: 'Step 3:',
            a7: 'Click「 Authorise new developer」to enter the authorization page;',
            a8: 'Step 4:',
            a9: 'Fill in the developer name and developer id provided by ipaylinks to Amazon background, and click next;',
            a10: 'Step 5:',
            a11: "Check agree to Amazon's official agreement and click next to get the seller's number and MWS authorization token;",
            a12: 'Step 6:',
            a13: 'Please fill in the corresponding input box of ipaylinks add shop page with the seller number and MWS authorization token you have obtained.',
        },
        noon: {
            a1: 'How to get email',
            a2: 'Step 1:<br>Log in to the seller account of noon platform and click [profile]',
            a3: 'Step 2:<br>Copy email and fill in the add store page',
        },
        cdiscount: {
            a1: 'Cdiscount store binding Guide',
            a2: "1. Please log in to the seller\'s background with Cdiscount account password, ",
            a3: "2. Click 'Settings' in the upper right corner of the seller\'s background to view the seller ID. Then select 'your personal settings and bank details';",
            a4: '3. Select "connection information" in "your personal settings and bank details"; view your API account and change the API password.',
            a5: '(1) If you have set the password before, just find the API user name and fill in the previous password, as shown in the figure below.',
            a6: '(2) If you have not set the API password before, you need to consult your customer manager or customer service to get the initial password and then reset the password to use the new password for store authorization.',
            a7: '4. Finally, add a store in the ipaylinks backstage store management page and select Cdiscount platform to input the seller ID, API account and password to bind the store.',
        },
        OnBuyShop: {
            a1: "1. Please login the seller\'s background with onbuy account password, ",
            a2: "2. Click the seller\'s background to view the seller ID.",
            a3: '3. Select "imports & integrations" in "listing & products"; view the key in your API account.',
            a4: '4. Finally, add a store in the ipaylinks background store management page and select onbuy platform to copy the seller ID, consumer key and secret key to bind the store.',
            a5: 'How to get API information of stores?'
        },
        getOrderFlow: {
            Howflow: 'How to obtain order flow',
            Step1: 'Step 1',
            Step2: 'Step 2',
            Step3: 'Step 3',
            Step4: 'Step 4',
            Step5: 'Step 5',
            Step6: 'Step 6',
            Step7: 'Step 7',
            OpenChrome: 'Open Chrome browser and click "..." in the upper right corner In the drop-down box, select the Chrome extension as shown in the figure below',
            Clickmenu: 'Click the extension in the upper left corner and select "Open Chrome web Store" in the menu',
            Searchchrome: 'Search "iPayLinks trade authenticity of the information gathering tool" on the home page of the app store, and then click "add to chrome"',
            Afteradding: 'After adding, the plug-in will be displayed above the browser',
            Loginto: 'Log in to the non seller background, click the "iPayLinks trade authenticity of the information gathering tool" icon, and click "start collection"',
            Donotagain: 'Do not close the pop-up window during the acquisition process. After the acquisition is completed, the tool will stop automatically. At this time, return to the MP payment page, and make payment again',
            Tip: 'Tip: Please complete the order information capture after the payment is made on the non platform, and update your order information in MP, so as not to affect your normal payment'
        },
        Shoplazza: {
            s1: '1.Select the application market in shoplazza and click "private App"',
            s2: '2.Click "Create application" on the right to create developer application',
            s3: '3.Create developer application',
            s4: 'Fill in application details: application name (as developer remarks), developer email, Webhook API version. Interface call permission: select "order permission" and "store information permission" and only configure the read permission. After configuration, click "save" button\n',
            s5: '4.The obtained token information is copied and filled in the "token" input box of the binding store page',
        }
    },
    page403: {
        a1: 'No permission for this page',
        a2: 'please contact the admin of this account',
        a3: 'Home'
    },
    page404: {
        a1: 'Sorry, this page is missed'
    },
    //    调单
    transferRecord: {
        id: 'Record number',
        xgyeid: 'Business order number',
        ddsm: 'Explain',
        gxsj: 'Update time',
        xzzl: 'Download',
        ddjl: 'Investigation Letter Record',
        a1: 'Only supports JPG, PNG, JPEG, BMP, PDF, ZIP, RAR format files.',
        a11: 'Only supports PNG, JPEG, PDF format files.',
        createTime: 'Creation time',
        op: 'Operation',
        a2: 'This fund can only be entered into the account after you provide explanatory materials',
        a3: 'Collection bank account',
        a4: 'Amount'
    },
    //    优惠券
    coupon: {
        myCoupon: 'Coupons',
        available: 'Available',
        used: 'Used',
        beOverdue: 'Expired',
        a1: 'Used/Give back',
        a2: 'Available',
        a3: 'Trans type',
        a4: 'Using Time',
        a5: 'Usage Record',
        a6: 'Usage Rules',
        a7: 'Total',
        a8: 'Used：',
        a9: 'Available：',
        a10: 'Available：',
        a10s: 'Available',
        a11: 'Validity period：',
        a12: 'Details',
        a13: 'about to expire',
        a14: 'charge',
        noCoupon: 'No coupons',
        transId: 'Trans ID',
        type: 'Type',
        a15: 'Back to coupons',
        a16: 'Coupons',
        dyq: 'Voucher',
        edq: 'Credit coupon',
        a17: 'Special reminder: the amount of coupons can be used superimposed, credit coupons can not be used superimposed'
    },
    //    Vcc 虚拟卡
    vcc: {
        tranId: 'Transaction ID',
        ywType: 'Transaction Type',
        zjDescribe: 'Transaction Detail',
        cardNick: 'Nick Name',
        card4: 'Last Four',
        rzTime: 'Settlement Time',
        currency: 'Currency',
        jyAmount: 'Amount',
        cardId: 'Card ID',
        createTime: 'Create Date',
        holdName: 'Cardholder Name',
        yxq: "Expiry Date",
        status: 'Card Status',
        vcList: ' Card List',
        jyxz: 'Transaction Limitation',
        maxAmount: 'Maximum amount',
        maxNumber: 'Maximum times',
        cardTime: '开卡日期',
        okrecharge: 'Add Money',
        a1: 'No more waiting, and make card payment instantly',
        a2: 'Create multiple cards in seconds to make global payment easier. And manage your cards controllable through our spending limits. Contact us and start your card payment immediately.',
        jylb: 'Transaction List',
        kz: 'Card Brand',
        cardCurrency: 'Currency',
        cardCountry: 'Issuing Country',
        kls: 'Transaction Flow',
        kzh: 'Card Accounts',
        kzhxq: 'Card Accounts Detail',
        createNewCard: 'Create New Card',
        createNewCard2: 'Create New Card',
        kzhls: ' Card Account Flow',
        balance: 'Balance',
        createCard: 'Create Card',
        createCard2: 'Create Card',
        Singapore: 'Singapore',
        dj: "Suspend",
        gk: "Close",
        qsrje: 'Please enter',
        kgl: 'Cards Management',
        kh: 'Card PAN ',
        a3: 'Add Money into ',
        a4: ' Virtual Card Account',
        a5: 'Amount',
        a6: 'Maximum transaction amount limit',
        a7: 'Maximum transaction times limit',
        Pleaseenteramount: 'Please enter a positive integer',
        a8: 'No more than ',
        yjh: 'Active',
        qrdj: 'Are you sure to freeze?',
        qrgk: 'Do you want to close the card?'
    },
    // vat缴税  0.3.2  20210318
    vat: {
        vatjs: 'Pay Vat Tax',
        vatjsjl: 'Pay Vat Tax History',
        jsjl: 'VAT Payment History',
        tanId: 'Transaction ID',
        jsjg: 'TAX Institue Name',
        jsjg2: 'TAX Institue',
        jsjgLocation: 'Location',
        jsjgLocation2: 'Location',
        jsAmount: 'Payment Amount',
        yjsdje: 'Estimated Receiving Amount',
        time: 'Tax Payment Period',
        jsfyType: 'Tax type',
        status: 'Status',
        createTime: 'Create at',
        taxIdentifyNumber: 'Tax identification number',
        taxType: 'Tax type',
        taxDate: 'Tax payment period',
        companyName: 'Company name (Please enter the company name registered on the platform)',
        companyName2: 'Company name',
        otherMes: 'Other Tax Info',
        vattaxMes: 'Tax Info',
        taxMes: 'VAT Institution Info',
        confirmMes: 'Confirm the Info',
        bankNo: 'Bank Account',
        a1: 'If there is no tax insitute you needed, please add first by the button above “ Add Tax Institute”',
        chooseTax: 'Select the Tax institution',
        addTax: 'Add Tax Institute',
        bankName: 'Bank Name',
        zzsjg: 'Tax Institute',
        nextTaxAmount: 'Next step: Payment Amount',
        nextTaxMes: 'Next step: Tax Info',
        youAmount: 'Payment Amount',
        a2: 'The Tax info includes: Tax identification number  (steuernummer), Tax type (steuerart), Tax payment period (Zeitraum), and the company name registered on the platform.',
        a3: 'special character can be replaced by space',
        am: 'Monthly',
        aq: 'Quarterly',
        ay: 'Yearly',
        q1: 'First quarter',
        q2: 'Second quarter',
        q3: 'Third quarter',
        q4: 'Fourth quarter',
        chooseYear: 'Select year',
        chooseMonth: 'Select month',
        a4: 'For the tax institute identify this payment, (not concluding Tax identification number, Tax type, Tax payment period) ， only supporting upper and lower case English letters, numbers and spaces',
        a5: 'Great, tax payment submitted!',
        a6: 'Estimated received on',
        continueTax: 'Pay Vat Tax',
        lookDetail: 'View details'
    },
    binPhoneJson: {
        title: 'Noticed that you have not bound your phone number',
        a1: 'In order to ensure the safety of your funds and the use of account functions, please bind your mobile phone number as soon as possible',
        btn: 'Go to binding',
        a2: 'Due to compliance requirements, your following collection account (to be downloaded) needs to supplement the store registration information. ',
        a3: 'To Supplement',
        a4: 'Download Accounts'
    },
    keyManagement: {
        wd: 'API Documents',
        wdms: 'This API documentation contains technical information about the integration with iPayLinks to make international payments via the API.',
        ckwd: 'Check Details',
        mygl: 'Basic Settings',
        ts1: 'Please apply to get this function before using it.',
        an1: 'Apply to Open',
        ts2: 'Your applicaiton have been received, we will audit it in one business day. Thanks for you patience.',
        ts3: 'Your application has been rejected, please revise it and submit again or ask the Customer Consultant.',
        an2: 'Apply to Open',
        jbxx: 'Basic Info',
        kfsz: 'Developing Configuration',
        bwyq: 'Respones Signature',
        jmfs: 'Report Encryption',
        jqfs: 'Report Signature',
        hddz: 'Callback URL',
        sz: 'Set',
        ck: 'View',
        cz: 'Reset',
        sz1: 'Set ',
        ck1: 'View ',
        cz1: 'Reset ',
        aqyz: 'Verification',
        ts4: 'For your account safety, please verify your operation, and verification code will be  send to ',
        ts5: 'Your APP Key has been reset as: ',
        jqlx: 'Signature Type',
        gyzf: 'Public Signature',
        ts6_1: 'IPL will verify the signature, you can use ',
        ts6_2: '( third party tool) to generate public signature.',
        confirm: 'Confirm',
        cancel: 'Cancel',
        ts11: 'Dear Merchant, your App Key is:',
        ts7: 'Dear Merchant, your Report Encryption is:',
        ts8: 'Dear Merchant, your Response Signature is:',
        ts9: 'Dear Merchant, your Report Signature is:',
        ts10: 'Your Report Encryption has been reset as:',
        sqcg: 'Submit Successfully',
        sqsb: 'Application Rejected',
        sbly: 'Rejected Reason',
        ktsq: 'API Application',
        ts12: 'Please set Report Signature',
        ts13: 'Please set Callback URL',
        ts14: 'Tips:Please fill with reasonable reason,and you will be informed the result in one business day.',
        ts15: 'Please paste the key generated by OpenSSL.(20-200)',
        ts16: 'Please enter Callback URL',
        ts17: 'Please enter application reason (less than 100 characters）'
    },
    holderManagement: {
        type: 'Type',
        holdName: 'Store Holder Name',
        holdNameCare: '(Please fill in the name of the company or individual of the backstage page of the store. (Chinese or English name)). ',
        country: 'Country',
        idType: 'Store Holder Certificate Type',
        idNo: 'Certificate Number',
        address: 'Store Holder Address',
        addHolder: 'Add new store Info',
        companyAdd: 'Company address',
        fddbssgj: 'Country of legal representative',
        fddbxm: 'Certificate type of legal representative',
        fddbCardNo: ' Certificate number of legal representative',
        fddbName: 'Name of legal representative',
        modifyHolder: 'Modify store holder information',
        searchName: 'Search store Holder Name',
        resubmit: 'Resubmit',
        addHolderBtn: 'New store Info',
        a1: 'Account holder information is being reviewed, please check the bank information later',
        a2: 'Store holder information',
        a3: 'Store information',
        ghcyr: 'Change of store holder',
        glcyr: ' Choose a store holder',
        holderBankMes: 'Store Holder Bank Info',
        holderBankMesC: '(Please enter Enterprise Account )',
        continueEditMes: 'Unfinished draft, do you want to continue or cancel it? ',
        fangqi: 'Cancel',
        qrbj: "After editing, the store holder information associated with this holder\'s collection account number will be changed. Are you sure you want to edit it",
        jxbj: 'Continue editing',
        ccyrygl: 'This store holder has been associated with a collection account and cannot be deleted at the moment. Please add a new store holder information and modify the store holder on the collection account details page before deleting.',
        qrlkm: 'Are you sure to leave?  ',
        ckycCopy: 'Copy KYC information'
    },
    AmazonHolderMes: {
        a1: '如何获取Amazon店铺持有人信息截图',
        a2: 'Amazon Europe and UK',
        a3: '1. Log in to the background of Amazon seller center, and click "Settings" - "account information" in the upper right corner to enter the account information interface.',
        a4: '2. Click "identity information" under "business information".',
        a5: '3. Under "business and contact information", you can view the name of your account holder (consistent with the legal name of the company).',
        a6: 'Amazon North America / Japan',
        a7: '1. Log in to the background of Amazon seller center, and click "Settings" - "account information" in the upper right corner to enter the account information interface.',
        a8: '2. Click "Legal Entity" under "business information".',
        a9: '3. Under "legal company name", you can view the name of your account holder (consistent with the legal company name).',
        a10: 'Amazon UAE / Saudi Arabia',
        a11: '1. Log in to the background of Amazon seller center, and click "Settings" - "account information" in the upper right corner to enter the account information interface.',
        a12: '2. Click "Legal Entity" under "business information".',
        a13: '3. Under "legal company name", you can view the name of your account holder (consistent with the legal company name).',
        a14: 'The content of the agreement has been confirmed',
        a15: 'The content of the agreement is not confirmed',
        a16: 'I know the content and confirm'
    },
    v0629: {
        a1: 'Application record',
        a2: 'Apply',
        a3: 'Application time',
        a4: 'Applicant',
        a5: 'Withdrawal / payment amount',
        a6: 'Reasons',
        a7: 'Audit status',
        a8: 'Remarks',
        a9: 'Reminder: at present, the system defaults that the validity period of the restored order is 180 days (the order created 180 days ahead of the current time). If you have special circumstances that cause the order funds 180 days ago to enter the country (for example, Paypal Funds are frozen and other reasons), you can apply for special configuration.',
        a10: 'please do not apply for normal capital entry. The application will be rejected.\'',
        a11: 'Special application',
        a12: 'Amount to be withdrawn / paid',
        a13: 'Currency',
        a14: 'Reasons',
        a15: 'Please fill in the application reason of no more than 200 words',
        a16: 'Please input the amount',
        a17: 'Upload screenshots of frozen PayPal e-mails, messages in PayPal websites, etc., and support no more than 10 files with a total of 20MB in JPG, PNG, JPEG, BMP, PDF, zip, rar formats',
        a18: 'Upload certificate, drag the file here,',
        a19: 'or click upload',
        a20: 'Only JPG, PNG, JPEG, BMP, PDF, zip, rar format files are supported',
        a21: 'Insufficient wallet balance'
    },
    v0819: {
        title: 'Account Cancellation Instructions',
        explain1: 'Please read the following instructions carefully before you cancel your account to avoid losses:',
        explain2: 'Once cancellation is complete, all data of your current account will be cleared and unable to recover in any way.',
        explain3: 'Other iPayLinks accounts authorized under your current account will not be able to log in.',
        explain4: 'If you wish to cooperate with iPayLinks in the future, you cannot restore your previous account, please apply for a new account. ',
        apply: 'Applies',
        explain5: 'For your legitimate rights，the following conditions must be met for account cancellation：',
        explain6: '1. No new transactions have been made in the current account for 180 days',
        explain7: '2. The balance of all currencies in the current account is 0 ',
        explain8: '3. There are no obligations which should be fulfilled , Including chargeback, retrieval',
        explain9: "4. Merchant\'s associated account",
        explain13: "5. Anything else you need to do to protect your account security and property rights ",
        explain10: 'I have read, confirmed and agree to the ',
        explain11: '《iPayLinks Account Cancellation Agreement 》',
        confirm: 'Confirm',
        explain12: 'Dear user, your account is being processed for cancellation',
        explain14: 'IPL support staff  will contact you as soon as possible, please pay attention to your email and call  ',
        agreement: {
            title: 'iPayLinks Account Cancellation Agreement',
            a1: '在正式开始注销流程前，请您特别注意如下特别说明：注销iPayLinks帐户后，您将无法再以此账户登录和使用iPayLinks的相关产品与服务，iPayLinks也将同时终止为该账户提供我们高品质、多元化的产品与服务。且iPayLinks账户一旦注销完成，将无法恢复。请您在注销前慎重考虑。',
            a2: '若您经过慎重考虑后仍决定注销iPayLinks账户的，请您务必先行仔细阅读和充分理解本《iPayLinks账户注销协议》，您按照我们的注销操作指引勾选本注销协议并点击注销的操作行为即视为您已经同意签署和遵守本协议全部内容。如您在注销后需要再次使用我们服务的，欢迎您使用手机号码或iPayLinks允许的其他方式重新注册。',
            a3: '本注销协议指导您注销iPayLinks账户。请仔细阅读这些条款，因为它们构成了您和我们之间的法律关系。',
            a4: '最后更新：2021年4月',
            a5: '1.注销的要求',
            a6: '在您向我们申请注销iPayLinks账户之前或正在申请注销iPayLinks账户的过程中，为保障您的账户安全和财产权益，请您先行检查与确保您申请注销的iPayLinks账户已经同时满足以下几点，包括：',
            a7: '1.1 账户是通过我们的www.ipaylinks.com网站（“网站”）注册、符合《用户注册协议》及相关说明规范的账户，且为您本人注册的账户；',
            a8: '1.2 该账户处于安全状态，即在最近两周内，您没有进行密码修改、手机号码修改等操作；',
            a9: '1.3 该账户内无资金，即账户内所有币种账户余额已为零；',
            a10: '1.4 该账户已在其他App账号退出，微信小程序账户已登出；',
            a11: '1.5 该账户项下无应当履行而尚未履行完毕的义务；',
            a12: '1.6 该账户处于正常状态，即您账户的信息是最新、完整、正确的，且账户未被采取止付、有权机关冻结等限制措施；',
            a13: '1.7 其他为了保障您的账户安全和财产权益需要满足的内容。',
            a14: '上述问题您可首先尝试自行处理，如您无法处理的或在处理过程中有任何疑惑的，可联系iPayLinks客服支持部门协助处理。',
            a15: '2.注销的影响',
            a16: '账户注销将会对您产生如下影响：',
            a17: '2.1 iPayLinks账户一旦注销，您将无法登录、使用该账户，即您将无法再以此账户登录/使用/继续使用iPayLinks的相关产品与服务；',
            a18: '2.2 iPayLinks账户一旦注销，您曾通过该账户登录、使用的iPayLinks的产品与服务下的所有内容、信息、数据、记录将会被删除或匿名化处理，您也无法再检索、访问、获取、继续使用和找回，也无权要求我们找回（但法律法规另有规定或监管部门另有要求的除外），包括：',
            a19: '•该账户下您的个人资料及绑定信息（例如：绑定手机号、邮箱等）；',
            a20: '•该账户下您的个人身份信息（同时您亦不再享有iPayLinks《隐私政策》中约定的用户权利，但法律法规另有规定的除外）；',
            a21: '•该账户下您的交易记录；',
            a22: '•其他所有内容、信息、数据、记录。',
            a23: '2.3 账户注销后该账户使用期间已产生的但未处理完毕的资产或权益及未来的预期利益均将作废。即iPayLinks账户一旦注销，我们将会对该账户下的全部资产或权益做清除处理，包括：',
            a24: '•【未使用的优惠券】；',
            a25: '•【未使用的免费提现额度】；',
            a26: '•其他已产生但未处理完毕的权益或未来预期的收益。',
            a27: '2.4 iPayLinks账户一旦注销完成，将无法恢复（即使您在注销后以同一手机号码再次向我们申请注册iPayLinks账户，此时该账户为新的用户账户。',
            a28: '因此，我们提醒您在申请注销前对您认为需要备份的所有信息和数据提前自行做好备份，否则您自行承担因所需信息和数据丢失所产生的风险）；',
            a29: '2.5 iPayLinks账户一旦注销，您与我们曾签署过的《用户注册协议》等法律文件相应终止（但我们与您之间已约定继续生效的或法律法规另有规定的除外）；',
            a30: '2.6 如您在注销账户前存在违法违规、侵权违约等不当行为或未完结义务的，您仍将承担相应责任；',
            a31: '2.7其他因iPayLinks账户注销产生的结果。',
            a32: '3.如何注销iPayLinks账户',
            a33: '3.1我们的网站为您提供了在线注销功能，您可以按照页面操作指引进行在线注销。当然，您也可以直接与我们的客服支持部门联系进行账户注销。',
            a34: '3.2本《iPayLinks账户注销协议》中包含了账户注销对您权益产生的影响等多方面的内容阐述，请您仔细阅读与充分理解，在同意本《iPayLinks账户注销协议》的全部内容后再进行下一步注销操作。',
            a35: '3.3为保障您的账户安全和财产权益，我们需要进行注销申请的身份验证（例如：验证账户绑定的手机号码等），以确保该账户是您本人注册的。',
            a36: '3.4为了维护您和其他用户的合法利益，在您申请注销账户时，我们会进行风险审查，您的账户应当不存在未完结交易或其他未了结的权利义务，且不存在其他因注销可能引发纠纷的情况。如您的账户有余额或关联资产，请您在注销前先将您的账户下对应的可用款项全部提现，或者通过转账等途径支用完毕。',
            a37: '3.5账户注销的处理期限最长为【14】日，即在您已成功向我们提交了iPayLinks账户注销申请后的【14】日内（从成功提交申请之时起算），账户将被注销（本协议另有约定的除外）。在前述【14】日内，您任可以登录该账户。或联系客服支持部门来取消账户注销。',
            a38: '3.6如超过上述第3.5点所述期限后，该账户将被永久注销。',
            a39: '本协议未尽事宜，请参考iPayLinks《用户注册协议》、《隐私政策》及注销过程中的相关规则、说明等。',
            a40: '同时，您知悉并同意：即使您的iPayLinks账户被注销，也并不代表减轻或免除您应根据相关法律法规、相关协议、规则等（可能）需要承担的相关责任。'
        }
    },
    save: 'Save',
    query: 'Search',
    financeService: {
        Applicationdate: 'Application date',
        Today: 'Today',
        Last7days: 'Last 7 days',
        Last30days: 'Last 30 days',
        Last90days: 'Last 90 days',
        Last1year: 'Last 1 year',
        Loanproduct: 'Loan product',
        All: 'All',
        Status: 'Status',
        ApplicationID: 'Application ID',
        Productname: 'Product name',
        Approvalquota: 'Approval quota/10,000',
        Creditexpirationtime: 'Credit expiration time',
        Annualizedrate: 'Annualized rate',
        Repaymentmethod: 'Repayment method',
        Accountmanager: 'Account manager',
        myApplication: 'My Application',
        Myloan: 'My loan',
        Serialnumber: 'Serial number',
        LoanID: 'Loan ID',
        Loanproduct2: 'Loan product',
        Loanamount: 'Loan amount/10,000',
        Deadline: 'Deadline',
        Loandate: 'Loan date',
        Duedate: 'Due date',
        Overduedate: 'Overdue date',
        Settlementdate: 'Settlement date',
        Repaymentrecord: 'Repayment record',
        Repaymentnumber: 'Repayment number',
        Repaymenttime: 'Repayment time',
        Capital: 'Capital',
        Interest: 'Interest',
        Totalrepayment: 'Total repayment',
        Repaymentcardnumber: 'Repayment card number',
        Repaymentplan: 'Repayment plan',
        Periods: 'Periods',
        Capitalpayable: 'Capital payable',
        Interestpayable: 'Interest payable',
        Penaltypayable: 'Penalty payable',
        Amountpayable: 'Amount payable',
        Singlerepayment: 'Single repayment',
        Totalrepayment2: 'Total repayment',
        Loanssupermarket: 'Loan products',
        CreditLoans2: 'Pure credit',
        CreditLoans: 'Pure credit, 0 mortgage',
        viewNow: 'View Now',
        Unfortunately: 'Unfortunately, your application is not approved. Please try again in one month.If you have any questions, please contact your account manager.',
        questionsmanager: 'If you have any questions, please contact your account manager.',
        ProductIntroduction: 'Product Introduction',
        BasicRequirements: 'Basic Requirements',
        OperationProcedures: 'Operation Procedures',
        FAQ: 'FAQ',
        Openingconditions: 'Opening conditions',
        Loansuccessfully: 'Loan intention submitted successfully',
        pleaseaccountmanager: "If the loan intention application is successfully submitted, we'll call you and let you know what to do next.For further questions, please contact your account manager.",
        gotit: 'I got it',
        processedmanager: 'Your loan application is being processed.If you have any questions, please contact your account manager!',
        expiredreapply: 'Your quota has expired, please reapply.',
        Reapply: 'Reapply',
        InProcess: 'In Process',
        Applicationinprocess: 'Application in process',
        Waitingforwithdrawal: 'Waiting for withdrawal',
        myLoan: 'My Loan',
        totalamount: 'Total Quota',
        Available: 'Available Quota',
        Used: 'Used Quota',
        expirytime: 'expiry time',
        annualizedrate: 'Annualized Rate',
        ask: 'Querstion：',
        answer: 'Answer：',
        Storeauthorization: 'Store authorization',
        Scancodeapply: 'Scan code to apply',
        Wechatscancode: 'Wechat scan code',
        ViewProgress: 'View application Progress',
        Wechatwithdraw: 'Wechat scan code, immediately withdraw',
        WechatView: 'Wechat scan code, immediately check',
        agreen: 'Agree',
        disagree: 'Disagree',
        Codescanningwithdrawal: 'Code scanning withdrawal',
        toRepayment: 'Repayment',
        repaymentSuccess: 'Repayment Successfully!',
        backList: 'Back to list',
        confirmRepayment: 'Confirm Repayment',
        // Periods:'期数',
        // Duedate:'Due date',
        // Capitalpayable:'Capital payable',
        // Interestpayable:'Interest payable',
        // Penaltypayable:'Penalty payable',
        // Amountpayable:'Amount payable',
        Totalamountpayable: 'Total amount payable',
        Amountperiod: 'You are making a repayment operation',
        Youoperation: 'You are in the process of repayment',
        Confirmagainsentto: 'Confirm again, please complete the verification operation, the verification code will be  send to',
        followingstoresbind: 'The following stores meet the product access requirements of Zhihui Ying, please select the store you need to bind (multiple selection is supported) :',
        Scancontract: 'Scan code to view contract',
        viewcontract: 'View Contract',
        Someapply1: 'Some of the stores you bound do not meet the application conditions. You can choose to rebind the store or continue to apply',
        Someapply2: 'The stores you bind do not meet the application conditions. You can choose to continue to apply after changing stores',
        Someapply3: 'Congratulations, your store is bound successfully. Please continue to apply for the next step',
        Continueapply: 'Continue Apply',
        Changeshop: 'Change shop',
        submitSuccess: 'Submit Successfully',
        storeprocessed: 'Your application is being processed',
        Wepatiently: 'We will arrange customer service personnel to contact you as soon as possible. Please keep your mobile phone unblocked and wait patiently.',
        backappList: 'Back to application arket',
        rateMonth: 'Monthly Rate'
    },
    user: {
        s0: 'Email cannot be empty',
        s1: 'Operator name',
        s2: 'New bound phone number',
        s3: 'Please enter',
        s4: 'Mobile verification code',
        s5: 'Please enter',
        s6: 'Note: Only mainland China mobile phone is supported to bind currently.',
        s7: 'Get verification code',
        s8: 'The mobile number has been successfully bound.',
        s9: 'Successfully get the verification code',
        s10: 'New bound email',
        s11: 'Current bound email',
        s12: 'Please enter',
        s13: 'Email verification code',
        s14: 'Please enter',
        s15: 'The email has been successfully bound.',
        s16: 'Current bound mobile',
        s17: 'Mobile cannot be empty',
        v1: 'Member name',
        v2: 'Member ID',
        v3: 'Current operator name',
        v4: 'Changing your password regularly will make your account more secure.',
        v5: 'The password must be at least 6 digits. Use a combination of two or more letters, numbers and symbols',
        v6: 'You have bound your mobile phone.',
        v7: "You have not bound email yet.",
        v8: 'You have bound the email.',
        v9: 'Role serial number',
        v10: 'Role name',
        v11: 'Role description',
        v12: 'Last modification time',
        v13: 'Authorization',
        v14: 'Login account',
        v15: 'Real name',
        v16: 'Department',
        v17: 'Operator status',
        v18: 'Creation',
        v19: 'Assigned role',
        v20: 'Role assignment',
        v21: 'Locked',
        v22: 'Please enter pure numbers.',
        v23: 'Please enter the correct email address.',
        v24: 'Please enter',
        v25: 'Please select',
        v26: 'You have successfully modified the operator.',
        v27: 'Configuration succeed',
        v28: 'Add operator failed. Please try again.',
        v29: 'Read',
        v30: 'Unread',
        v31: 'Message theme',
        v32: 'Notification time',
        v33: 'Cannot be the same as the current mobile number.',
        v34: 'The binding mobile number has been successfully modified.',
        v35: 'The role name cannot be empty.',
        v36: 'Role description cannot be empty.',
        v37: 'The permissions cannot be empty.',
        v38: 'Modification Submission',
        v39: 'Please enter',
        v40: 'Please enter',
        v41: 'You have successfully modified the role',
        v42: 'Modify operator failed, please try again.',
        v43: 'Current payment password',
        v44: 'New payment password',
        v45: 'Please enter',
        v46: 'Please enter',
        v47: 'Security strength',
        v48: 'Low',
        v49: 'Medium',
        v50: 'High',
        a1: '•Please enter 6 to 20 characters, only letters(case sensitive), numbers, and punctuation (except space) contained, and at least 2 type of letters, numbers, and symbols',
        ra1: '•Please enter 8 to 20 characters, only letters(case sensitive), numbers, and punctuation (except space) contained, and at least 2 type of letters, numbers, and symbols',
        a2: 'Confirm new payment password',
        a3: 'Please enter the payment password again.',
        a4: 'Please enter according to the rules',
        a5: 'Passwords entered are inconsistent.',
        a6: 'The new password can not be empty.',
        a7: 'Confirm password can not be empty.',
        a8: 'The current login password can not be empty.',
        a9: 'You have successfully modified the payment password.',
        a10: 'Payment password reset successfully!',
        a11: 'Login password reset successfully!',
        a12: 'Must be at least 18 years old',
        a13: 'Age cannot be empty',
        a14: 'You have successfully modified the login password. Please login again.',
        a15: 'Cannot be the same as the current email.',
        a16: 'Notice',
        a17: 'Response message list',
        a18: 'Last login time',
        a19: 'Keyword',
        a20: 'Please enter',
        a21: 'Log type',
        a22: 'Log content',
        a23: 'Your operator account is at risk. For your account security, please complete the security information!',
        a24: 'Non-Chinese users please',
        a25: 'Skip the bound phone number',
        a26: 'Next',
        a27: 'Back',
        a28: 'Back to home',
        a29: 'Add bank card successfully',
        a30: 'We will review the card you added, and you can withdraw money to this card when its status is available.',
        a31: 'Continue to add bank card',
        a32: 'Back',
        a33: 'Withdraw',
        a34: 'Fill in operator information.',
        a35: 'Password setting',
        a36: 'Operator name should be 5-32 digit, alphabet, and underscore combination.',
        a37: 'Please enter',
        a38: 'Operator name',
        a39: 'Please enter',
        a40: 'Please enter',
        a41: 'Operator ID',
        a42: 'New login password',
        a43: 'Please enter',
        a44: '• Please enter 8~20 characters, only letters, numbers, And punctuation (except spaces). There are at least 2 letters, Numbers and symbols. The letters are case sensitive.',
        a45: 'Confirm login password',
        a46: 'Please enter the login password again.',
        a47: 'Confirm payment password',
        a48: 'Set authority',
        a49: 'You have successfully added the operator ',
        a50: ',Assign the right to the him/her.',
        b1: 'Please enter numbers, letters, or underlines.',
        b2: 'Cannot be same with login password.',
        b3: 'Login password is not consistent, please re-enter',
        b4: 'Payment password is not consistent, please re-enter',
        b5: 'Please enter 5-32 letters, numbers, and underscore combination.',
        b6: 'Real name cannot be empty.',
        b7: "The operator's department can not be empty.",
        b8: 'Add bank card failed',
        b9: 'Add bank card failed, go check it ',
        b10: 'Solution',
        b11: 'Contact number',
        b12: 'Contact address',
        b13: 'Merchant name',
        b14: 'Modify password',
        b15: "You have not bound phone yet.",
        b16: 'Current login password',
        b17: 'Please enter',
        b18: 'Please enter',
        b19: 'Confirm new login password',
        b20: 'The current payment password can not be empty',
        b21: 'Please enter',
        b22: 'Please enter',
        b23: 'Start time',
        b24: 'Operation time',
        b25: 'Operator',
        b26: 'Operator ID',
        b27: 'Role',
        b28: 'Add Role',
        b29: 'You will delete the operator configuration',
        b30: 'Deleted successfully! You have successfully deleted the operator configuration.',
        b31: 'Operator name can not be empty',
        b32: 'Payment password can not be empty',
        b33: 'Reset login password',
        b34: "Reset payment password",
        b35: 'Successfully added a role',
        b36: 'Modify failed',
        b37: 'Please enter the correct IP address',
    },
    authorize: {
        authorization: 'Please log in to iPayLinks cross-border payment account and complete authorization',
        Loginaddress: 'Login to your phone number or email address',
        enteraddress: 'Please enter your phone number or email address',
        Authorizationconfirmation: 'Authorization confirmation',
    },
    appsMarket: {
        appsMarket: 'Application Market',
        detail: 'Application Detail'
    },
    v1014: {
        title: 'Notification language',
        zh: 'Chinese notice',
        en: 'English notice'
    },
    common: {
        index: "No.",
        actions: "Actions",
        reset: "Reset",
        no_data: "No data",
        search: "Search",
        cancel: "Cancel",
        confirm: "Confirm",
        delete: "Delete",
        edit: "Edit",
        view: "View",
        add: "Add",
        save: "Save",
        amount_format_error: "Amount format error",
        amount_greater_than_balance: "Amount cannot be greater than available balance",
        amount_empty: "Please enter amount",
        amount_greater_than_balance_withdraw: "Withdraw amount cannot be greater than balance",
        loading: "Loading...",
    },
    router: {
        mobileNotVerified: "Please complete your account holder information setup first",
        kycRequired: "Please complete identity verification first",
    },
}
